import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import ProgressBar from "progressBar";
import SongContextView from "views/common/SongContextView";
import DynamicPageView from "views/common/DynamicPageView";
import PersistentModels from "services/PersistentModels";
import LocalStorageHelper from "models/helper/LocalStorageHelper";
import SingleSongSelectorInputView from "views/common/SingleSongSelectorInputView";
import SongContextController from "controllers/common/SongContextController";
import TrebbleClientAPI from "models/helper/TrebbleClientAPI";
import Typeahead from "typeahead";
import Mention from "mention";
import owlcarousel from "owlcarousel";
import Utils from "models/helper/Utils";
import FeatureRolloutHelper from "models/helper/FeatureRolloutHelper";
import AudioRecorderHelper from "models/helper/AudioRecorderHelper";
import { STATUSES as RECORDING_DRAFT_STATUSES } from "models/helper/BrowserRecordingDraftStore";
import RSVP from "rsvp";
import React from "react";
import { createRoot } from "react-dom/client";
import FolderPicker from "../../components/common/FolderPicker";
import ti18n from "i18n!nls/RecordAudioHightlightPagei18n";
import pageTemplate from 'text!../../../templates/audioHighlight/RecordAudioHighlightPageNewTemplate.html';
import {tz as momentTimezone} from 'moment-timezone';
import moment from 'moment';
import Swiper from 'swiper';
import Shepherd from 'shepherd.js';
import { offset } from '@floating-ui/dom';
import '../../../css/recordAudioHighlightStudioDock.css';

const CREATION_MODE = {"FROM_FILE":"fromFile", "FROM_RECORDING":"fromRecording","FROM_TEXT":"fromText", "FROM_VOICE_ACTOR":"fromVoiceActor", "FROM_TRANSCRIPT":"fromTranscript"};
const DEFAULT_MAX_RECORD_SIZE_IN_MILLI = LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSeconds() ?  LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSeconds() * 1000 : 600000;
const DEFAULT_MAX_RECORD_SIZE_IN_MILLI_ON_UPLOAD = 5400000;//LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSecondsOnUpload && LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSecondsOnUpload() ?  LocalStorageHelper.getInstance().getCustomMaxCapsuleLimitInSecondsOnUpload() * 1000 : 600000;
const TO_BE_DELETED_RECORDING_COLOR = "rgb(217, 30, 24)";
const DEFAULT_TRAIL_COLOR = "rgba(255,255,255,0.1)";
const TO_DELETE_ICON = "ion-ios7-close-empty";
const HINT_DELETE_ICON_MESSAGE = window.getI18n(ti18n,"SELECT_LAST_AUDIO_TO_RECORD");
const READY_TO_DELETED_ICON = "ion-ios7-trash";
const HINT_READY_TO_DELETE_ICON_MESSAGE = window.getI18n(ti18n,"DELETE_SELECTED_AUDIO_RECORDING");

const SHOW_PLAY_BUTTON_INSIDE_CIRCULAR_TIMER =  false;
const DELETE_PREVIOUS_RECORDING_WITHOUT_CONFIRMATION = true;

const ALLOW_USER_TO_RECORD_MULTIPLE_AUDIO_SEGMENT = true;
const SHOW_DECIMAL_IN_RECORDING_TIME = false;
const RECORDING_PREVIEW_ATTACH_TIMEOUT_IN_MILLI = 2500;

const BACKGROUND_MUSIC_URI_TO_INFO = {};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/284_full_summer-in-brooklyn_0161.mp3"] = {name: "Summer In Brooklyn",artistName  : "Mattjis Muller", downloadUrl : "https://www.premiumbeat.com/royalty_free_music/songs/summer-in-brooklyn"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/200_full_paper-stars_0147.mp3"] = {name: "Paper Stars",artistName  : "Liam Aidan", downloadUrl : "https://www.premiumbeat.com/royalty-free-tracks/paper-stars"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/texasradiofish_-_Rey_DM.mp3"] = {name: "Rey_DM",artistName  : "Texasradiofixh", downloadUrl : "http://dig.ccmixter.org/files/texasradiofish/46274"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/mood-music_715141.mp3"] = {name: "Mood Music",artistName  : "Mike Sears", downloadUrl : "https://www.beatstars.com/beat/mood-music-715141"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/drunk-texting_592809.mp3"] = {name: "Drunk Texting",artistName  : "Mike Sears", downloadUrl : "https://www.beatstars.com/beat/drunk-texting-592809"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/moon_795265.mp3"] = {name: "Moon",artistName  : "Lo Life", downloadUrl : "https://www.beatstars.com/beat/moon-795265"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/millyrock_752134.mp3"] = {name: "MillyRock",artistName  : "Lo Life", downloadUrl : "https://www.beatstars.com/beat/millyrock-752134"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/afro_trap_beat.mp3"] = {name: "Afro Trap",artistName  : "Winner on the track", downloadUrl : "https://www.youtube.com/watch?v=9uEgMtIPNLY"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/naza_keblack_type_beat.mp3"] = {name: "AfroBeat",artistName  : "Monedaz", downloadUrl : "https://www.youtube.com/watch?v=unIVBXi8Fo4"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/9197010_David___Goliath_Extended_Mix.mp3"] = {name: "David & Goliath",artistName  : "Jonas Aden", downloadUrl : "https://www.spinninrecords.com/releases/david-goliath/"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/9432857_Bubblegum_Original_Mix.mp3"] = {name: "Bubblegum",artistName  : "Sonny Bass, Jordi Rivera", downloadUrl : "https://www.spinninrecords.com/releases/bubblegum/"};
BACKGROUND_MUSIC_URI_TO_INFO["http://web.trebble.fm/audioassets/9710435_Look_Away_Extended_Mix.mp3"] = {name: "Look Away",artistName  : "JLV", downloadUrl : "https://www.spinninrecords.com/releases/look-away/"};
const CHOOSE_BACKGROUND_TRACK_LABEL  = window.isMobileBrowser? '<div >'+window.getI18n(ti18n, "SWIPE_TO_SELECT_BACKGROUND_MUSIC")+'</div>':'<div >'+window.getI18n(ti18n, "TAP_ARROW_TO_SELECT_BACKGROUND_MUSIC")+'</div>';
const NO_BACKGROUND_TRACK  = '<br/><span style="font-weight: bold">'+window.getI18n(ti18n, "NO_BACKGROUND_MUSIC")+'</span>';
const DO_NOT_SHOW_UPLOAD_AUDIO_FILE_IN_PAGE_HEADER = false;
const DO_NOT_SHOW_RECORD_AUDIO_IN_PAGE_HEADER = false;
const PUBLISHED_SETTING_VALUES = {"NOW":"now","SCHEDULED":"scheduled"};
const SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER = true;
const BACKGROUND_MUSIC_SELECTION_BOX_HEIGHT =  90;
const SHOW_COUNTER_TIMER_CLASS =  "showCountTimer";
const DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES = true;
const ALLOW_CHOOSING_MUSIC_ON_MOBILE_APP = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.ALLOW_USE_MUSIC_WHILE_RECORDING_CAPSULE_ON_MOBILE);
const CSS_PAGE_BACKGROUND =  FeatureRolloutHelper.getInstance().getFeatureVariable(FeatureRolloutHelper.FEATURES.CAPSULE_RECORDING_UI_DEFAULT_CONFIG,FeatureRolloutHelper.FEATURES.CAPSULE_RECORDING_UI_DEFAULT_CONFIG.variables.css_page_background, null);
const IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_FROM_TEXT);
const IS_CAPSULE_CREATION_VIA_VOICE_ACTOR = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_USING_VOICE_ACTOR);
const ENABLE_ADDING_MUSIC_TO_PLAY_AFTER_CAPSULE = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.ENABLE_CAPABILITY_TO_PLAY_MUSIC_AFTER_CAPSULE);
const CONFIGURE_BACKGROUND_MUSIC = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.CONFIGURE_BACKGROUND_MUSIC);
const MAX_NUMBER_OF_WORDS = FeatureRolloutHelper.getInstance().getFeatureVariable(FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_USING_VOICE_ACTOR, FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_USING_VOICE_ACTOR.variables.max_number_of_words_allowed, 500);
const MIN_HOUR_REQUIRED_FOR_NARRATION = FeatureRolloutHelper.getInstance().getFeatureVariable(FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_USING_VOICE_ACTOR, FeatureRolloutHelper.FEATURES.CREATE_CAPSULE_USING_VOICE_ACTOR.variables.min_time_required_for_narration_in_hours, 12);
const USE_DEFAULT_MUSIC_SELECTOR =  false;
const TREBBLE_TEXT_BASED_AUDIO_EDITOR = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.TREBBLE_TEXT_BASED_AUDIO_EDITOR, true);
const DISABLE_CAN_SAVE_SHORTCAST_ONLY_AFTER_EDIT = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.DISABLE_CAN_SAVE_SHORTCAST_ONLY_AFTER_EDIT, false);
const RECORD_PAGE_ONBOARDING = FeatureRolloutHelper.getInstance().isFeatureEnabled(FeatureRolloutHelper.FEATURES.RECORD_PAGE_ONBOARDING, true);
const STUDIO_DOCK_RECORD_UI = (function() {
    const featureRolloutHelper = FeatureRolloutHelper.getInstance();
    const featureConfig = FeatureRolloutHelper.FEATURES.STUDIO_DOCK_RECORD_UI;
    const featureKey = featureConfig && featureConfig.key ? featureConfig.key : featureConfig;

    try {
        const optimizelyClient = featureRolloutHelper && featureRolloutHelper.optimizelyClientInstance;
        const optimizelyConfig = optimizelyClient && optimizelyClient.getOptimizelyConfig ? optimizelyClient.getOptimizelyConfig() : null;
        const featuresMap = optimizelyConfig && optimizelyConfig.featuresMap;
        if (!featureKey || !featuresMap || !featuresMap[featureKey]) {
            return true;
        }
    } catch (error) {
        console.warn("Unable to inspect the STUDIO_DOCK_RECORD_UI rollout; defaulting to the studio dock recorder", error);
        return true;
    }

    return featureRolloutHelper.isFeatureEnabled(featureConfig, true);
})();

const RecordAudioHightlightPageNewView = Backbone.View.extend({



    "pageName": "Record Audio Hightlight Page",

    initialize: function(options) {
        const viewOptions = {};
        this._songModel = options.model;
        this._pageId = options.pageId;
        this._audioRecordingSupported = options.audioRecordingSupported;
        this._customPageTitle = options.customPageTitle;
        this._capsuleInfoToEdit = null;
        // this._songSelectorListView = options.songSelectorListView;
        this._songAttachedToCapsuleSongSelectorInputView = options.songAttachedToCapsuleSongSelectorInputView;
        this._backgroundSongSelectorInputView = options.backgroundSongSelectorInputView;
        this._capsuleInfoProgressBarView = options.capsuleInfoProgressBarView;
        this._audioEditorProgressBarView = options.audioEditorProgressBarView;
        this._recordKey = options.recordKey;
        this._createAShortcast  = options.createAShortcast;
        this._followersUsersInfo = options.followersUsersInfo;
        this._creationModeSelectorView = options.creationModeSelectorView;
        this._creationModeFlatListViewContainer$el = options.creationModeFlatListViewContainer$el;
        this._receiverUserId = options.receiverUserId;
        this._saveAsDraft = options.saveAsDraft;
        this._recordOnly = options.recordOnly;
        this._canSaveChanges = options.canSaveChanges !== false;
        this._recordingMediaType = options.recordingMediaType === "video" ? "video" : "audio";
        this._studioDockVisualSource = options.recordingVisualSource === "screen" ? "screen" : "camera";
        this._opensProjectInEditor = options.opensProjectInEditor === true;
        this._selectedDefaultTranscriptionLanguage = options.selectedDefaultTranscriptionLanguage;
        this._capsuleSchedulingAvailable = options.capsuleSchedulingAvailable;
        this._canSaveOnlyAfterTranscriptionAndEditing = options.canSaveOnlyAfterTranscriptionAndEditing? !DISABLE_CAN_SAVE_SHORTCAST_ONLY_AFTER_EDIT: false;
        this._workspaceId = Object.prototype.hasOwnProperty.call(options || {}, "workspaceId") ? options.workspaceId : undefined;
        // Folder id used to pre-select the folder picker in the save step.
        // When non-null, the user opened Create Content from within a library folder
        // and the resulting capsule will default to being saved into that folder.
        this._defaultFolderId = options.defaultFolderId || null;
        this._selectedFolderId = this._defaultFolderId;
        this._folderPickerRoot = null;
        this._availableFolders = [];
        this._recordMaxSize = (options && options.recordMaxSize) ? options.recordMaxSize : DEFAULT_MAX_RECORD_SIZE_IN_MILLI;
        const contentView = {};
        this.deletionMode = false;
        this.isReadyToBedeleted = false;
        this.template = _.template(pageTemplate);
        this._capsuleCategoryCollection =options.capsuleCategoryCollection;
        this._recordingInstructionsDisplayed = true;
        this._timezoneCollection =options.timezoneCollection;
        this._supportedTranscriptionLanguagesCollection  = options.supportedTranscriptionLanguagesCollection;
        this._selectedDefaultCategoryId = options.selectedDefaultCategoryId;
        this._selectedDefaultTimezone = options.selectedDefaultTimezone;
        this._peakMeterView = options.peakMeterView;
        this._audioEditorView = null;

        this._uploadElementId = "uploadWrapper_"+((new Date()).getTime());
        const songJson = this._songModel? this._songModel.toJSON(): null;
        this._toBeSentToAnotherUser = this._receiverUserId? true: false;
        const templateParams = {"model": songJson, "uploadElementId": this._uploadElementId,"pageId": this._pageId, "toBeSentToAnotherUser": this._toBeSentToAnotherUser , "maxCapsuleLimitInMillisec": DEFAULT_MAX_RECORD_SIZE_IN_MILLI, "maxCapsuleLimitInMillisecOnUpload": DEFAULT_MAX_RECORD_SIZE_IN_MILLI_ON_UPLOAD, "ti18n": ti18n, "customPageTitle": this._customPageTitle, "createAShortcast": this._createAShortcast, "ALLOW_TRANSCRIPTION":TREBBLE_TEXT_BASED_AUDIO_EDITOR, "recordingMediaType": this._recordingMediaType, "STUDIO_DOCK_RECORD_UI": STUDIO_DOCK_RECORD_UI};
        this._templateParams = templateParams;
        templateParams.moment = moment;
        //contentView.$el = $(contentViewTemplate(templateParams));





        this._uploadedFileAdded = false;

        this._completedRecordedSnippetArray = [];
        this._nextButtonEnable = true;
        this._currentRecordedSnippet = [];
        this._isRecording = false;
        this._isStoppingRecording = false;
        this._pendingRecordedSnippet = null;
        this._currentRecordedFile = null;
        this._isPlaying = false;
        this._isPlaybackLoading = false;
        this._recordingPreviewState = "idle";
        this._clearRecordingPreviewBinding = null;
        this._recordedVideoPlaybackPromise = null;
        this._recordedVideoPlaybackResolve = null;
        this._recordedVideoPlaybackReject = null;
        this._recordedVideoPlaybackQueue = [];
        this._recordedVideoPlaybackForcedVisualStage = false;
        this._beforeUnloadHandler = this._onBeforeUnload.bind(this);
        this._beforeUnloadHandlerRegistered = false;
        this._recordingDeviceRefreshToken = 0;
        this._inlineRecordingDeviceControlsInitialized = false;
        this._pendingRecordingMediaTypeChange = null;
        this._recoveryMode = !!options.recoveryMode;
        this._recordingDraftRecoveryItems = options.recoverableDrafts ? options.recoverableDrafts.slice() : [];
        this._draftRibbonDismissed = false;
        this._inlineDraftRecoveryPanelOpen = !!this._recoveryMode;

    },

    events : {
        "click #header-back-button" : "navigateToPreviousPageConfirm",
        "click #deleteButton:not(.trebble_disabled)" :"_onDeleteBtnClicked",
        "click #showUploadSectionButton" : "_showUploadSection",
        "click [id=showRecordSectionButton]" : "_showRecordSection",
        "click [id=showTextToSpeechSectionButton]" : "_showTextToSpeechSection",
        "click [id=showVoiceActorNarrationSectionButton]" : "_showUseVoiceActorSection",
        "click #playButton:not(.trebble_disabled)": "_playStopPlayingRecording",
        "click #saveButtonIcon:not(.trebble_disabled)" : "_saveRecording",
        "click #nextButton:not(.trebble_disabled)" : "onNextButtonClicked",
        "click #doneRecordingButtonIcon:not(.trebble_disabled)" : "onDoneRecordingButtonClicked",
        "click #previousButton:not(.trebble_disabled)" : "onPreviousButtonClicked",
        "click #recordButton" :"_onRecordRecordingButtonClicked",
        "click #stopRecordingButton" :"_onPauseRecordingButtonClicked",
        "click #recordAudioModeButton" : "_onRecordAudioModeButtonClicked",
        "click #recordVideoModeButton" : "_onRecordVideoModeButtonClicked",
        "click #retryRecordingPreviewButton" : "_onRetryRecordingPreviewButtonClicked",
        "change #inlineRecordingMicrophoneFld" : "_onInlineRecordingMicrophoneChanged",
        "change #inlineRecordingCameraFld" : "_onInlineRecordingCameraChanged",
        "click #requestRecordingDevicePermissionButton:not(.trebble_disabled)" : "_onRequestRecordingDevicePermissionButtonClicked",
        "click #whatsacapsuleButton" : "onWhatsACapsuleButtonClicked",
        "click #showRecordingSettingsButton:not(.trebble_disabled)" : "_showRecordingSettings",
        "click #studioDockShowRecordBtn" : "_onStudioDockModePillRecordClicked",
        "click #studioDockShowUploadBtn" : "_onStudioDockModePillUploadClicked",
        "click #studioDockNotesToggle" : "_onStudioDockNotesToggleClicked",
        "click #studioDockSettingsBtn:not(.trebble_disabled)" : "_showRecordingSettings",
        "click #studioDockDrawerClose" : "_onStudioDockDrawerCloseClicked",
        "click #studioDockNotesDrawerClose" : "_onStudioDockDrawerCloseClicked",
        "click #recordingPreviewGridToggleButton" : "_onStudioDockGridToggleClicked",
        "click #studioDockDrawerEchoToggle" : "_onStudioDockEchoToggleClicked",
        "click #studioDockDrawerNoiseToggle" : "_onStudioDockNoiseToggleClicked",
        "click #studioDockDrawerAutoGainToggle" : "_onStudioDockAutoGainToggleClicked",
        "click #studioDockDrawerCountdownToggle" : "_onStudioDockCountdownToggleClicked",
        "click #studioDockDrawerGridToggle" : "_onStudioDockDrawerGridToggleClicked",
        "change #studioDockDrawerMicrophoneFld" : "_onStudioDockDrawerMicrophoneChanged",
        "change #studioDockDrawerCameraFld" : "_onStudioDockDrawerCameraChanged",
        "change #studioDockDrawerSpeakerFld" : "_onStudioDockDrawerSpeakerChanged",
        "change #studioDockDrawerResolutionFld" : "_onStudioDockDrawerResolutionChanged",
        "click #transcribe_and_edit_audio_btn" : "showTranscriptionParameters",
        "click #continue_with_no_edit_btn:not(.trebble_disabled)" : "onNextButtonClicked",
        "click #transcribe_btn:not(.trebble_disabled)" : "_onTranscribeAndEditAudioBtnClicked",
        "click [data-recording-draft-action='recover']" : "_onRecoverRecordingDraftButtonClicked",
        "click [data-recording-draft-action='discard']" : "_onDiscardRecordingDraftButtonClicked",
        "click [data-recording-draft-action='dismiss-ribbon']" : "_onDismissDraftRibbonClicked",
        "click [data-recording-draft-action='open-drawer']" : "_onOpenDraftDrawerClicked",
        "click #draftDrawerClose" : "_onDraftDrawerCloseClicked"




    },

    _onTranscribeAndEditAudioBtnClicked : function(){
        this.hideTranscriptionParameters();
        this.trigger("transcribeAndEditAudio");

    },

    _onRecoverRecordingDraftButtonClicked: function(event) {
        if(event && event.preventDefault){ event.preventDefault(); }
        if(event && event.stopPropagation){ event.stopPropagation(); }
        const recordingId = event && event.currentTarget ? $(event.currentTarget).attr("data-recording-id") : null;
        if (recordingId) {
            this.trigger("recoverRecordingDraft", recordingId);
        }
    },

    _onDiscardRecordingDraftButtonClicked: function(event) {
        if(event && event.preventDefault){ event.preventDefault(); }
        if(event && event.stopPropagation){ event.stopPropagation(); }
        const recordingId = event && event.currentTarget ? $(event.currentTarget).attr("data-recording-id") : null;
        if (recordingId) {
            this.trigger("discardRecordingDraft", recordingId);
        }
    },

    _onDismissDraftRibbonClicked: function(event) {
        if(event && event.preventDefault){ event.preventDefault(); }
        if(event && event.stopPropagation){ event.stopPropagation(); }
        this._draftRibbonDismissed = true;
        if (this.draftRibbon$el) {
            this.draftRibbon$el.css("display", "none");
        }
    },

    _onOpenDraftDrawerClicked: function(event) {
        if(event && event.preventDefault){ event.preventDefault(); }
        if(event && event.stopPropagation){ event.stopPropagation(); }
        this._setStudioDockPanelState("drafts");
    },

    _onDraftDrawerCloseClicked: function(event) {
        if(event && event.preventDefault){ event.preventDefault(); }
        if(event && event.stopPropagation){ event.stopPropagation(); }
        this._setStudioDockPanelState(null);
    },

    _bindRecordingDraftRecoveryActionButtons: function() {
        const self = this;
        let actionButtons$el = $();
        if(!this._recordingDraftRecoveryActionClickHandler){
            this._recordingDraftRecoveryActionClickHandler = function(event) {
                const action = $(event.currentTarget).attr("data-recording-draft-action");
                if(action === "recover"){
                    self._onRecoverRecordingDraftButtonClicked(event);
                }
                if(action === "discard"){
                    self._onDiscardRecordingDraftButtonClicked(event);
                }
                if(action === "open-drawer"){
                    self._onOpenDraftDrawerClicked(event);
                }
                if(action === "dismiss-ribbon"){
                    self._onDismissDraftRibbonClicked(event);
                }
            };
        }

        if(this.draftRibbon$el && this.draftRibbon$el.length){
            actionButtons$el = actionButtons$el.add(this.draftRibbon$el.find("[data-recording-draft-action]"));
        }
        if(this.draftDrawer$el && this.draftDrawer$el.length){
            actionButtons$el = actionButtons$el.add(this.draftDrawer$el.find("[data-recording-draft-action]"));
        }
        if(this.recordingDraftRecoveryPanel$el && this.recordingDraftRecoveryPanel$el.length){
            actionButtons$el = actionButtons$el.add(this.recordingDraftRecoveryPanel$el.find("[data-recording-draft-action]"));
        }
        if(this.draftPill$el && this.draftPill$el.length){
            actionButtons$el = actionButtons$el.add(this.draftPill$el);
        }
        if(!actionButtons$el.length){
            return;
        }

        actionButtons$el
            .off("click.recordingDraftRecovery")
            .on("click.recordingDraftRecovery", this._recordingDraftRecoveryActionClickHandler);
        this._recordingDraftRecoveryDocumentEvent = "click.recordingDraftRecovery." + this.cid;
        $(document)
            .off(this._recordingDraftRecoveryDocumentEvent, "[data-recording-draft-action]", this._recordingDraftRecoveryActionClickHandler)
            .on(this._recordingDraftRecoveryDocumentEvent, "[data-recording-draft-action]", this._recordingDraftRecoveryActionClickHandler);
    },

    _unbindRecordingDraftRecoveryActionButtons: function() {
        if(this.draftRibbon$el && this.draftRibbon$el.length){
            this.draftRibbon$el.find("[data-recording-draft-action]").off("click.recordingDraftRecovery");
        }
        if(this.draftDrawer$el && this.draftDrawer$el.length){
            this.draftDrawer$el.find("[data-recording-draft-action]").off("click.recordingDraftRecovery");
        }
        if(this.recordingDraftRecoveryPanel$el && this.recordingDraftRecoveryPanel$el.length){
            this.recordingDraftRecoveryPanel$el.find("[data-recording-draft-action]").off("click.recordingDraftRecovery");
        }
        if(this.draftPill$el && this.draftPill$el.length){
            this.draftPill$el.off("click.recordingDraftRecovery");
        }
        if(this._recordingDraftRecoveryDocumentEvent && this._recordingDraftRecoveryActionClickHandler){
            $(document).off(this._recordingDraftRecoveryDocumentEvent, "[data-recording-draft-action]", this._recordingDraftRecoveryActionClickHandler);
        }
        this._recordingDraftRecoveryDocumentEvent = null;
        this._recordingDraftRecoveryActionClickHandler = null;
    },

    _addCapsuleCategoriesToView : function(){
        const selectCategory$El =  this.$el.find("#categoryFld");
        const selectedLabel$El = this.$el.find("#categoryFld-button > span");
        if(this._capsuleCategoryCollection){
            this._capsuleCategoryCollection.each((function(categoryListItemModel){
                if(this._selectedDefaultCategoryId == categoryListItemModel.getId()){
                    selectCategory$El.append("<option value='"+categoryListItemModel.getId()+"' selected='selected'>"+ categoryListItemModel.getLabel()+"</option>");
                    selectedLabel$El.html(categoryListItemModel.getLabel());
                }else{
                    selectCategory$El.append("<option value='"+categoryListItemModel.getId()+"'>"+ categoryListItemModel.getLabel()+"</option>");
                }
            }).bind(this));
        }
    },


    _addTimezonesToView : function(){
        const selectTimezone$El =  this.$el.find("#schedulingTimezoneFld");
        const selectTimezoneLabel$El = this.$el.find("#schedulingTimezoneFld-button > span");
        if(this._timezoneCollection){
            this._timezoneCollection.each((function(timezoneListItemModel){
                if(this._selectedDefaultTimezone == timezoneListItemModel.getId()){
                    selectTimezone$El.append("<option value='"+timezoneListItemModel.getId()+"' selected='selected'>"+ timezoneListItemModel.getLabel()+"</option>");
                    selectTimezoneLabel$El.html(timezoneListItemModel.getLabel());
                }else{
                    selectTimezone$El.append("<option value='"+timezoneListItemModel.getId()+"'>"+ timezoneListItemModel.getLabel()+"</option>");
                }
            }).bind(this));
        }
    },

    _addTranscriptioneSupportedLanguageToView : function(){
        const selectSupportedTranscriptionLanguage$El =  this.$el.find("#languageUsedInAudioFld");
        const selectSupportedTranscriptionLanguageLabel$El = this.$el.find("#languageUsedInAudioFld-button > span");
        if(this._supportedTranscriptionLanguagesCollection){
            this._supportedTranscriptionLanguagesCollection.each((function(languageListItemModel){
                if(this._selectedDefaultTranscriptionLanguage == languageListItemModel.getId()){
                    selectSupportedTranscriptionLanguage$El.append("<option value='"+languageListItemModel.getId()+"' selected='selected'>"+ languageListItemModel.getLabel()+"</option>");
                    selectSupportedTranscriptionLanguageLabel$El.html(languageListItemModel.getLabel());
                }else{
                    selectSupportedTranscriptionLanguage$El.append("<option value='"+languageListItemModel.getId()+"'>"+ languageListItemModel.getLabel()+"</option>");
                }
            }).bind(this));
        }
    },

    setAudioRecordingSupported: function(audioRecordingSupported){
        this._audioRecordingSupported = audioRecordingSupported;
        if(this._audioRecordingSupported){
           this._showRecordSection();
       }else{
           this._showUploadSection();
       }
   },
   _onUserTapOnPoupContent: function() {
    if (!this._isRecording) {
        this._cancelSnippetDeletion();
    }
},

showCounterAnimation : function(numberOfSecondsToCount){
    return this.showCounterAnimationRecursive(numberOfSecondsToCount);
},

_createTourStepForWelcomeToRecordPage :function(tour){
    return {
        title: window.getI18n(ti18n, "ONBOARD_STEP_1_TITLE_WELCOME_TO_STUDIO_PAGE"),
        text: window.getI18n(ti18n, "ONBOARD_STEP_1_DESC_WELCOME_TO_STUDIO_PAGE"),
        attachTo: {
            element: this.$el.find(".createCapsulePage.studio-dock .mode-pill").get(0) || this.$el.find(".mode-pill").get(0),
            on: "bottom",
        },
        arrow: true,
        modalOverlayOpeningPadding: 10,
        floatingUIOptions: {
            middleware: [offset({ mainAxis: 20, crossAxis: 0 })]
          },
        buttons: [
          {
            action: function () {
                  if (this.$el.is(":visible")) {
                    return tour.complete();
                  } else {
                    if (window.trebbleAnalyticsHelper) {
                      window.trebbleAnalyticsHelper.trackEvent(
                        "recordPage",
                        "recordPageeNotVisibleToContinueOnboarding",
                        "My record page not visible to continue onboarding",
                      );
                    }
                  }

            }.bind(this),
            text: window.getI18n(ti18n, "OKAY"),
          },
        ],
        id: "onboarding_welcome_my_record_page_step",
      };
},

_createTourStepForSaveOrEditPage: function(tour){
    return {
        title: window.getI18n(ti18n, "ONBOARD_STEP_1_TITLE_SAVE_OR_EDIT_PAGE"),
        text: window.getI18n(ti18n, "ONBOARD_STEP_1_DESC_SAVE_OR_EDIT_PAGE"),
        attachTo: {
            element: this.$el.find(".message_to_start_transcription_box_wrapper > .actionButtonWrapper ").get(0),
            on: "top",
        },
        arrow: true,
        modalOverlayOpeningPadding: 0,
        floatingUIOptions: {
            middleware: [offset({ mainAxis: 20, crossAxis: 0 })]
          },
        when: {
            show: (function() {
                // Add click listeners to both buttons to complete tour when clicked
                const continueBtn = this.$el.find('#continue_with_no_edit_btn');
                const transcribeBtn = this.$el.find('#transcribe_and_edit_audio_btn');

                const completeTour = function(e) {
                    tour.complete();
                };

                continueBtn.one('click', completeTour);
                transcribeBtn.one('click', completeTour);

                // Store cleanup function
                tour._saveOrEditCleanup = function() {
                    continueBtn.off('click', completeTour);
                    transcribeBtn.off('click', completeTour);
                };
            }).bind(this),
            hide: function() {
                // Cleanup listeners when tour step is hidden
                if (tour._saveOrEditCleanup) {
                    tour._saveOrEditCleanup();
                    delete tour._saveOrEditCleanup;
                }
            }
        },
        buttons: [
          {
            action: function () {
                  if (this.$el.is(":visible")) {
                    return tour.complete();
                  } else {
                    if (window.trebbleAnalyticsHelper) {
                      window.trebbleAnalyticsHelper.trackEvent(
                        "recordPage",
                        "saveOrEditPageeNotVisibleToContinueOnboarding",
                        "Save Or Edit page not visible to continue onboarding",
                      );
                    }
                  }

            }.bind(this),
            text: window.getI18n(ti18n, "OKAY"),
          },
        ],
        id: "onboarding_save_or_edit_page_step",
      };
},

showSaveOrEditOnboardingInstruction :function(){
    if (RECORD_PAGE_ONBOARDING && this.messageToStartTranscriptionBox$el.is(":visible") && !LocalStorageHelper.getInstance().isSaveOrEditPageOnboardingWasCompletedOrDismissed() && !this._saveOrEditOnboardingTour && this.$el.is(":visible")) {
        try {
          const tour = new Shepherd.Tour({
            useModalOverlay: true,
            keyboardNavigation: false,
            defaultStepOptions: {
              cancelIcon: {
                enabled: false,
              },

              classes: "sequencer-onboarding-popup",
              scrollTo: false,
            },
          });
          //this._selectFourLinesOfTextIfContextMenuIsNotDisplayed();
          tour.addStep(this._createTourStepForSaveOrEditPage(tour));

          tour.start();
          this._saveOrEditOnboardingTour = tour;
          tour.once(
            "start",
            function () {
              this.trigger("saveorEditPageOnboardingTourStarted");
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "saveorEditPageOnboardingStarted",
                  "Save Or Edit Page Onboarding Started ",
                );
              }
            }.bind(this),
          );
          tour.once(
            "complete",
            function () {
              this.trigger("saveorEditPageOnboardingTourCompleted");
              this._saveOrEditOnboardingTour = null;
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "saveorEditPageOnboardingCompleted",
                  "Save Or Edit Page Onboarding Completed ",
                );
              }
            }.bind(this),
          );
          tour.once(
            "cancel",
            function () {
              this.trigger("saveorEditPageOnboardingTourCancelled");
              this._saveOrEditOnboardingTour = null;
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "saveorEditPageOnboardingCancelled",
                  "Save Or Edit Page Onboarding Cancelled ",
                );
              }
            }.bind(this),
          );

          tour.on(
            "show",
            function () {
              this.trigger("saveorEditPageOnOnboardingStepDisplayed");
              const stepDisplayedId = this.getOnboardingCurrentStepIdDisplayed();
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "saveorEditPageOnboardingStepDisplayed",
                  "Save Or Edit Page Onboarding Step Displayed ",
                  null,
                  { stepDisplayedId: stepDisplayedId },
                );
              }
            }.bind(this),
          );
        } catch (error) {
          if (window.trebbleAnalyticsHelper) {
            window.trebbleAnalyticsHelper.trackEvent(
              "recordPage",
              "FailedToCreaterecordPageOnboarding",
              "Failed to create Save Or Edit page onboarding ",
              null,
              { error: error },
            );
          }
        }
      } else {
        if (!this._saveOrEditOnboardingTour && window.trebbleAnalyticsHelper) {
          window.trebbleAnalyticsHelper.trackEvent(
            "recordPage",
            "saveOrEditPageNotVisibleToContinueOnboarding",
            "Record Page not visible to continue onboarding",
          );
        }
      }
},

showRecordPageOnboardingInstruction :function(){
    if (RECORD_PAGE_ONBOARDING && !this._recordOnboardingTour && this.$el.is(":visible")) {
        try {
          const tour = new Shepherd.Tour({
            useModalOverlay: true,
            keyboardNavigation: false,
            defaultStepOptions: {
              cancelIcon: {
                enabled: false,
              },

              classes: "sequencer-onboarding-popup",
              scrollTo: { behavior: "smooth", block: "center" },
            },
          });
          //this._selectFourLinesOfTextIfContextMenuIsNotDisplayed();
          tour.addStep(this._createTourStepForWelcomeToRecordPage(tour));

          tour.start();
          this._recordOnboardingTour = tour;
          tour.once(
            "start",
            function () {
              this.trigger("recordPageOnboardingTourStarted");
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "recordPageOnboardingStarted",
                  "Record Page Onboarding Started ",
                );
              }
            }.bind(this),
          );
          tour.once(
            "complete",
            function () {
              this.trigger("recordPageOnboardingTourCompleted");
              this._recordOnboardingTour = null;
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "recordPageOnboardingCompleted",
                  "Record Page Onboarding Completed ",
                );
              }
            }.bind(this),
          );
          tour.once(
            "cancel",
            function () {
              this.trigger("recordPageOnboardingTourCancelled");
              this._recordOnboardingTour = null;
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "recordPageOnboardingCancelled",
                  "Record Page Onboarding Cancelled ",
                );
              }
            }.bind(this),
          );

          tour.on(
            "show",
            function () {
              this.trigger("recordPageOnOnboardingStepDisplayed");
              const stepDisplayedId = this.getOnboardingCurrentStepIdDisplayed();
              if (window.trebbleAnalyticsHelper) {
                window.trebbleAnalyticsHelper.trackEvent(
                  "recordPage",
                  "recordPageOnboardingStepDisplayed",
                  "Record Page Onboarding Step Displayed ",
                  null,
                  { stepDisplayedId: stepDisplayedId },
                );
              }
            }.bind(this),
          );
        } catch (error) {
          if (window.trebbleAnalyticsHelper) {
            window.trebbleAnalyticsHelper.trackEvent(
              "recordPage",
              "FailedToCreaterecordPageOnboarding",
              "Failed to create Record page onboarding ",
              null,
              { error: error },
            );
          }
        }
      } else {
        if (!this._recordOnboardingTour && window.trebbleAnalyticsHelper) {
          window.trebbleAnalyticsHelper.trackEvent(
            "recordPage",
            "recordPageNotVisibleToContinueOnboarding",
            "Record Page not visible to continue onboarding",
          );
        }
      }
},

showCounterAnimationRecursive : function(numberToShow){
    if(numberToShow == 0){
        this.counterAnimationBox$el.find("#counterNumber").remove();
        this.$el.removeClass(SHOW_COUNTER_TIMER_CLASS);
        this.$el.css("padding-top", "54px");//We are doing this because it seems like the padding gets removed during the animation but it doesn't come back after
        return RSVP.Promise.resolve();
    }else{
        this.counterAnimationBox$el.find("#counterNumber").remove();
        const counterNumber$el = $("<div id='counterNumber'></div>");
        this.counterAnimationBox$el.append(counterNumber$el);
        counterNumber$el.html(numberToShow);
        if(!this.$el.hasClass(SHOW_COUNTER_TIMER_CLASS)){
            this.$el.addClass(SHOW_COUNTER_TIMER_CLASS)
        }
        return Utils.getInstance().applyAnimationCssClass(counterNumber$el,"zoomIn", "1s").then((function(){
            return this.showCounterAnimationRecursive(numberToShow - 1);
        }).bind(this)).catch(function(error){
            console.error(error);
        })
    }

},

showTranscriptionParameters : function(){
    this.transcribeAndEditBtn$el.hide();
    this.transcriptionParametersBox$el.show();
    this._onTranscriptionLanguageFieldValueChange();
    this._syncAudioEditorSectionHeight();
},

hideTranscriptionParameters : function(){
    this.transcriptionParametersBox$el.hide()
    this.transcribeAndEditBtn$el.show();
    this._onTranscriptionLanguageFieldValueChange();
    if(this._canSaveOnlyAfterTranscriptionAndEditing){
        this.showTranscriptionParameters();
    }
    this._syncAudioEditorSectionHeight();
},

showHideTranscribeAndEditButton : function(show){
    if(show){
        this.transcribeAndEditBtn$el.show();
    } else {
        this.transcribeAndEditBtn$el.hide();
    }
    this._syncAudioEditorSectionHeight();
},

_syncAudioEditorSectionHeight: function(){
    if(!this.audioEditorSection$el || !this.audioEditorSection$el.length){
        return;
    }

    const router = PersistentModels.getInstance() && PersistentModels.getInstance().getRouter ? PersistentModels.getInstance().getRouter() : null;
    const viewportHeight = router && router.getViewportHeight ? router.getViewportHeight() : window.getDocumentClienHeight();
    const headerHeight = 57;
    const targetHeight = Math.max(viewportHeight - headerHeight, 0) + "px";
    this.audioEditorSection$el.css({"height": targetHeight});

    if(this.audioEditorAndTranscriptionBox$el && this.audioEditorAndTranscriptionBox$el.length){
        const shouldCenterEmptyState = this.audioEditorAndTranscriptionBox$el.hasClass("is-empty-transcription-state");
        this.audioEditorAndTranscriptionBox$el.css(shouldCenterEmptyState ? {
            "min-height": targetHeight,
            "height": targetHeight
        } : {
            "min-height": "",
            "height": ""
        });
    }

    if(this.messageToStartTranscriptionBox$el && this.messageToStartTranscriptionBox$el.length){
        this.messageToStartTranscriptionBox$el.css({
            "margin-top": ""
        });
    }
},

_syncAudioEditorLayoutState: function(){
    if(!this.audioEditorAndTranscriptionBox$el || !this.audioEditorAndTranscriptionBox$el.length){
        return;
    }

    const isMessageBoxVisible = !!(this.messageToStartTranscriptionBox$el && this.messageToStartTranscriptionBox$el.length && this.messageToStartTranscriptionBox$el.is(":visible"));
    const isSequencerVisible = !!(this.sequncerNodeWrapper$el && this.sequncerNodeWrapper$el.length && this.sequncerNodeWrapper$el.is(":visible"));
    const shouldCenterEmptyState = isMessageBoxVisible && !isSequencerVisible;

    this.audioEditorAndTranscriptionBox$el.toggleClass("is-empty-transcription-state", shouldCenterEmptyState);
},

setIsPlaybackLoading : function(isPlaybackLoading){
    if(!this._isRecording){
        this._isPlaybackLoading = isPlaybackLoading;
    }
    this._updatePlayPauseButtonClass();
},

isPlaying : function(){
    return this._isPlaying;
},

setIsPlaying: function(isPlaying) {
    this._isPlaying = isPlaying;
    this._updatePlayPauseButtonClass();
},

isRecordedVideoPlaybackActive: function() {
    return !!this._recordedVideoPlaybackPromise;
},

_applyPreferredSpeakerOutputToMediaElement: function(mediaElement) {
    if(!mediaElement || typeof mediaElement.setSinkId !== "function" || !this._isSpeakerOutputSelectionSupported()){
        return RSVP.Promise.resolve(null);
    }

    const localStorageHelper = LocalStorageHelper.getInstance();
    const preferredPlaybackOutputDeviceId = localStorageHelper.getPreferredPlaybackOutputDeviceSelectionWasExplicit() ? localStorageHelper.getPreferredPlaybackOutputDeviceId() : "";
    const targetSinkId = preferredPlaybackOutputDeviceId && preferredPlaybackOutputDeviceId !== "default" ? preferredPlaybackOutputDeviceId : "";

    if(mediaElement.sinkId === targetSinkId){
        return RSVP.Promise.resolve(targetSinkId);
    }

    return RSVP.Promise.resolve(mediaElement.setSinkId(targetSinkId)).catch((function(error) {
        console.warn("Unable to route media playback to the selected speaker output", error);

        if(!targetSinkId){
            return null;
        }

        return RSVP.Promise.resolve(mediaElement.setSinkId("")).then((function() {
            return "";
        }).bind(this)).catch(function(defaultOutputError) {
            console.warn("Unable to fall back to the default speaker output", defaultOutputError);
            return null;
        });
    }).bind(this));
},

_clearRecordedVideoPlaybackElement: function() {
    if(!this.recordedPlaybackVideo$el || !this.recordedPlaybackVideo$el.length){
        return;
    }

    const playbackVideoEl = this.recordedPlaybackVideo$el.get(0);
    playbackVideoEl.onended = null;
    playbackVideoEl.onerror = null;
    playbackVideoEl.onloadedmetadata = null;

    try {
        playbackVideoEl.pause();
    } catch (_) {
        // Ignore cleanup failures while resetting the playback overlay.
    }

    try {
        playbackVideoEl.removeAttribute("src");
        playbackVideoEl.src = "";
        playbackVideoEl.removeAttribute("poster");
        if(playbackVideoEl.load){
            playbackVideoEl.load();
        }
    } catch (_) {
        // Ignore media element cleanup failures while resetting playback.
    }
},

_teardownRecordedVideoPlayback: function(error) {
    const resolvePlayback = this._recordedVideoPlaybackResolve;
    const rejectPlayback = this._recordedVideoPlaybackReject;
    const hadActivePlayback = !!this._recordedVideoPlaybackPromise;

    this._clearRecordedVideoPlaybackElement();
    this._recordedVideoPlaybackPromise = null;
    this._recordedVideoPlaybackResolve = null;
    this._recordedVideoPlaybackReject = null;
    this._recordedVideoPlaybackQueue = [];

    if(this.recordedPlaybackVideo$el){
        this.recordedPlaybackVideo$el.hide();
    }
    if(this.recordingPreviewStage$el){
        this.recordingPreviewStage$el.removeClass("is-recorded-playback");
    }
    if(this.recordedPlaybackBadge$el){
        this.recordedPlaybackBadge$el.hide();
    }
    if(this.videoPeakMeterContainer$el){
        this._syncPeakMeterContainerForMediaType();
    }
    if(this._recordedVideoPlaybackForcedVisualStage && this.$el){
        const panel$el = this.$el.find(".panel");
        if(panel$el && panel$el.length){
            panel$el.removeClass("has-visual");
        }
        this._recordedVideoPlaybackForcedVisualStage = false;
    }

    this._syncRecordingPreviewPresentation();

    if(hadActivePlayback){
        if(error && rejectPlayback){
            rejectPlayback(error);
        }else if(resolvePlayback){
            resolvePlayback();
        }
    }
},

_playRecordedVideoPlaybackAtIndex: function(index) {
    if(!this._recordedVideoPlaybackQueue || index >= this._recordedVideoPlaybackQueue.length){
        this._teardownRecordedVideoPlayback();
        return;
    }

    if(!this.recordedPlaybackVideo$el || !this.recordedPlaybackVideo$el.length){
        this._teardownRecordedVideoPlayback(new Error("Recorded video playback is unavailable."));
        return;
    }

    const mediaInfo = this._recordedVideoPlaybackQueue[index];
    if(!mediaInfo || !mediaInfo.localUrl){
        this._teardownRecordedVideoPlayback(new Error("Recorded video playback is unavailable."));
        return;
    }

    const playbackVideoEl = this.recordedPlaybackVideo$el.get(0);
    this._clearRecordedVideoPlaybackElement();
    this.recordedPlaybackVideo$el.show();

    playbackVideoEl.muted = false;
    playbackVideoEl.defaultMuted = false;
    playbackVideoEl.volume = 1;
    playbackVideoEl.playsInline = true;
    playbackVideoEl.preload = "auto";
    if(mediaInfo.thumbnail){
        playbackVideoEl.poster = mediaInfo.thumbnail;
    }

    playbackVideoEl.onended = (function() {
        this._playRecordedVideoPlaybackAtIndex(index + 1);
    }).bind(this);
    playbackVideoEl.onerror = (function() {
        this._teardownRecordedVideoPlayback(new Error("Unable to play the recorded video."));
    }).bind(this);
    playbackVideoEl.onloadedmetadata = (function() {
        this._setCompactVideoTimerLabel("0:00");
    }).bind(this);

    playbackVideoEl.src = mediaInfo.localUrl;
    if(playbackVideoEl.load){
        playbackVideoEl.load();
    }

    RSVP.Promise.resolve(this._applyPreferredSpeakerOutputToMediaElement(playbackVideoEl)).then((function() {
        const playPromise = playbackVideoEl.play ? playbackVideoEl.play() : null;
        if(playPromise && playPromise.catch){
            playPromise.catch((function(error) {
                if(this._recordedVideoPlaybackPromise){
                    this._teardownRecordedVideoPlayback(error);
                }
            }).bind(this));
        }
    }).bind(this));
},

playRecordedVideoPlayback: function(mediaDescriptors) {
    const playableVideoDescriptors = (mediaDescriptors || []).filter(function(mediaDescriptor) {
        return !!(mediaDescriptor && mediaDescriptor.localUrl);
    });

    if(!playableVideoDescriptors.length){
        return RSVP.reject(new Error("No recorded media is available for playback."));
    }

    this.stopRecordedVideoPlayback();

    if(this.recordingPreviewContainer$el){
        this.recordingPreviewContainer$el.show();
    }
    if(this.recordingPreviewStage$el){
        this.recordingPreviewStage$el.addClass("is-recorded-playback");
    }
    if(this.recordedPlaybackBadge$el){
        this.recordedPlaybackBadge$el.show();
    }
    if(this.videoPeakMeterContainer$el){
        this.videoPeakMeterContainer$el.hide();
    }
    if(this.$el){
        const panel$el = this.$el.find(".panel");
        if(panel$el && panel$el.length && !panel$el.hasClass("has-visual")){
            panel$el.addClass("has-visual");
            this._recordedVideoPlaybackForcedVisualStage = true;
        }
    }

    this._recordedVideoPlaybackQueue = playableVideoDescriptors;
    this._recordedVideoPlaybackPromise = new RSVP.Promise((function(resolve, reject) {
        this._recordedVideoPlaybackResolve = resolve;
        this._recordedVideoPlaybackReject = reject;
    }).bind(this));

    this._playRecordedVideoPlaybackAtIndex(0);
    return this._recordedVideoPlaybackPromise;
},

stopRecordedVideoPlayback: function() {
    const playbackWasVisible = this.isRecordedVideoPlaybackActive() || (this.recordedPlaybackVideo$el && this.recordedPlaybackVideo$el.is(":visible"));
    this._teardownRecordedVideoPlayback();
    return RSVP.Promise.resolve(playbackWasVisible);
},

setUploadedFileAdded : function(uploadedFileAdded){
    this._uploadedFileAdded = uploadedFileAdded;
    this._enableNextButtonIfApplicable();
    this._updateHeaderButtons();
},

onTextToConvertToAudioFieldChange : function(){
    this._enableNextButtonIfApplicable();
    this._updateHeaderButtons();
},

onTextToNarrateFieldChange : function(){
    this._isTextToNarrateCountValid();
    this._enableNextButtonIfApplicable();
    this._updateHeaderButtons();
},

_onTranscriptionLanguageFieldValueChange :function(){
    if(this.getLanguageUsedInAudio()){
        this.$el.find("#transcribe_btn").removeClass("trebble_disabled");
    }else{
        this.$el.find("#transcribe_btn").addClass("trebble_disabled");
    }
},

_setSaveAsDraft :function(){
    this.doNotAddOnAirCheckbox$el.get(0).checked = true;
    this.onDoNotAddOnAirCheckboxChange();
    this.$el.attr("saveAsDraft","true");
},


_isTextToNarrateCountValid :function(){
    const textToNarrate = this.getTextToNarrate();
    const wordCount = Utils.getInstance().wordCount(textToNarrate);
    const numberOfWordRemaining = MAX_NUMBER_OF_WORDS - wordCount;
    this.wordCountNumber$el.html(numberOfWordRemaining);
    return numberOfWordRemaining >= 0;

},

getUploadElementId : function(){
    return this._uploadElementId;
},

setContentLoading : function(contentLoading){
    this.$el.attr("content_loading", !!contentLoading);
},

setAudioEditorView : function(audioEditorView){
    if(this._audioEditorView){
        this._audioEditorView.$el.remove();
    }
    this._audioEditorView = audioEditorView;
    this.$el.find(".sequencer_node_wrapper").append(this._audioEditorView.$el);
    this._syncAudioEditorLayoutState();
    this._syncAudioEditorSectionHeight();
    if(window.trebbleAnalyticsHelper){
        window.trebbleAnalyticsHelper.trackEvent("audioEditor", "Audio Editor was added to page", "Audio Editor was added to page");
    }
},

_updatePlayPauseButtonClass: function() {
    const pauseClass = "ion-ios7-pause";//"fontello-icon-pause-1";
    const pauseHintMessage = "Pause";
    const playClass = "ion-ios7-play";//"fontello-icon-play-1";
    const playHintMessage = "Play";
    const loadingClass = "ion-loading-c";
    const loadingHintMessage = "Loading";
    const playButtonEl = this.$el.find("#playButton");
    const playButtonElIcon = this.$el.find("#playButton > t");
    if (this._isPlaybackLoading) {
        playButtonElIcon.removeClass(playClass);
        playButtonElIcon.removeClass(pauseClass);
        playButtonElIcon.addClass(loadingClass);
        playButtonEl.attr("data-hint","");
    } else {
        playButtonElIcon.removeClass(loadingClass);
        if (this._isPlaying) {
            playButtonElIcon.removeClass(playClass);
            playButtonElIcon.addClass(pauseClass);
            playButtonEl.attr("data-hint",pauseHintMessage);
        } else {
            playButtonElIcon.removeClass(pauseClass);
            playButtonElIcon.addClass(playClass);
            playButtonEl.attr("data-hint",playHintMessage);
        }
    }

},
_initializeCarousels: function() {
 //this.$el.find("#songSelectorWrapper").append(this._songSelectorListView.$el);
 this.$el.find("#songToPlayAfterCapsuleInputPlaceholder").append(this._songAttachedToCapsuleSongSelectorInputView.$el);
 this.$el.find("#backgroundMusicInputPlaceholder").append(this._backgroundSongSelectorInputView.$el);
 this.carousel$el = this.$el.find(".carouselWrapper").owlCarousel({

    navigation: false, // Show next and prev buttons
    pagination: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    afterAction: this._onCarouselMove.bind(this),
    touchDrag: false,
    mouseDrag: false,
    singleItem: true
});
 this._numberOfCarouselItems = TREBBLE_TEXT_BASED_AUDIO_EDITOR ? 3: 2;
 this._currentCarouselPositon = 0;
 this.setSelectedSongView(null);
},

_addArrowToSelectWidget: function() {
this.$el.find("#capsuleLifeSpanFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#categoryFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#schedulingTimezoneFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#privacySettingFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#publishingSettingFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#ttsLanguageFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#ttsLanguageForVoiceActorFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#languageUsedInAudioFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#voiceProfileFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#voiceToneFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#inlineRecordingMicrophoneFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');
this.$el.find("#inlineRecordingCameraFld-button").append('<i class="ion-chevron-down" style="display: inline-block;"></i>');

},

_removeParanthesesFromDeviceLabel : function(deviceLabel){
return deviceLabel ? deviceLabel.replace(/ *\([^)]*\) */g, ' ').trim() : "";
},

_getDeviceLabelToDisplay: function(device, fallbackBaseLabel, index) {
const label = device && device.label ? this._removeParanthesesFromDeviceLabel(device.label) : "";

if (label) {
    return label;
}

return fallbackBaseLabel + " " + (index + 1);
},

_getDefaultSpeakerOutputLabel: function() {
return window.getI18n(ti18n, "DEFAULT_SPEAKER_OUTPUT");
},

_isSpeakerOutputSelectionSupported: function() {
return AudioRecorderHelper.getInstance().isSpeakerOutputSelectionSupported();
},

_refreshSelectWidget : function(select$El){
if(select$El && select$El.length && select$El.data("mobile-selectmenu")){
    select$El.selectmenu("refresh", true);
}
},

_setSelectWidgetLabel: function(select$El) {
if(!select$El || !select$El.length){
    return;
}

const selectId = select$El.attr("id");
if(!selectId){
    return;
}

const buttonLabel$El = this.$el.find("#" + selectId + "-button > span");
if(buttonLabel$El && buttonLabel$El.length){
    const selectedOption$El = select$El.find("option:selected").first();
    buttonLabel$El.text(selectedOption$El && selectedOption$El.length ? selectedOption$El.text() : "");
}
},

_persistAutoSelectedRecordingDevice: function(select$El, deviceId) {
if(!select$El || !select$El.length){
    return;
}

const selectId = select$El.attr("id");
const normalizedDeviceId = deviceId === "default" ? "" : deviceId;

if(selectId === "studioDockDrawerSpeakerFld"){
    if(normalizedDeviceId === undefined || normalizedDeviceId === null){
        return;
    }

    LocalStorageHelper.getInstance().setPreferredPlaybackOutputDeviceId(normalizedDeviceId);
    LocalStorageHelper.getInstance().setPreferredPlaybackOutputDeviceSelectionWasExplicit(false);
    return;
}

if(!normalizedDeviceId){
    return;
}

if(selectId === "inlineRecordingMicrophoneFld"){
    LocalStorageHelper.getInstance().setPreferredDeviceAudioId(normalizedDeviceId);
}else if(selectId === "inlineRecordingCameraFld"){
    LocalStorageHelper.getInstance().setPreferredDeviceVideoId(normalizedDeviceId);
}
},

_populateRecordingDeviceSelect: function(select$El, devices, preferredDeviceId, fallbackBaseLabel, emptyLabel) {
if(!select$El || !select$El.length){
    return;
}

const selectId = select$El.attr("id");
const isSpeakerOutputSelect = selectId === "studioDockDrawerSpeakerFld";
const availableDevices = devices || [];
let selectedDeviceId = null;
const preferredPlaybackOutputDeviceSelectionWasExplicit = isSpeakerOutputSelect ? LocalStorageHelper.getInstance().getPreferredPlaybackOutputDeviceSelectionWasExplicit() : false;
const normalizedPreferredDeviceId = isSpeakerOutputSelect ?
    (preferredPlaybackOutputDeviceSelectionWasExplicit && preferredDeviceId && preferredDeviceId !== "default" ? preferredDeviceId : "") :
    preferredDeviceId;
const appendDefaultSpeakerOutputOption = (function() {
    if(!isSpeakerOutputSelect || !this._isSpeakerOutputSelectionSupported()){
        return;
    }

    const defaultSpeakerOption$El = $("<option></option>").attr("value", "").text(this._getDefaultSpeakerOutputLabel());
    if(normalizedPreferredDeviceId === ""){
        defaultSpeakerOption$El.attr("selected", "selected");
        selectedDeviceId = "";
    }
    select$El.append(defaultSpeakerOption$El);
}).bind(this);
select$El.empty();

if(!availableDevices.length){
    if(isSpeakerOutputSelect && this._isSpeakerOutputSelectionSupported()){
        appendDefaultSpeakerOutputOption();
        if(selectedDeviceId === null){
            selectedDeviceId = "";
            select$El.val(selectedDeviceId);
        }
        this._refreshSelectWidget(select$El);
        this._setSelectWidgetLabel(select$El);
        return;
    }

    select$El.append($("<option></option>").attr({
        value: "",
        disabled: "disabled",
        selected: "selected",
        hidden: "hidden"
    }).text(emptyLabel));
    this._refreshSelectWidget(select$El);
    this._setSelectWidgetLabel(select$El);
    return;
}

appendDefaultSpeakerOutputOption();

availableDevices.forEach((function(device, index) {
    if(isSpeakerOutputSelect && (!device || !device.deviceId || device.deviceId === "default")){
        return;
    }

    const optionValue = device.deviceId;
    const optionLabel = this._getDeviceLabelToDisplay(device, fallbackBaseLabel, index);
    const option$El = $("<option></option>").attr("value", optionValue).text(optionLabel);

    if(normalizedPreferredDeviceId !== null && normalizedPreferredDeviceId !== undefined && normalizedPreferredDeviceId == optionValue){
        option$El.attr("selected", "selected");
        selectedDeviceId = optionValue;
    }

    select$El.append(option$El);
}).bind(this));

if(isSpeakerOutputSelect){
    if(selectedDeviceId === null){
        selectedDeviceId = "";
    }
    select$El.val(selectedDeviceId);
}else if(!selectedDeviceId){
    selectedDeviceId = availableDevices[0].deviceId;
    select$El.val(selectedDeviceId);
    this._persistAutoSelectedRecordingDevice(select$El, selectedDeviceId);
}

this._refreshSelectWidget(select$El);
this._setSelectWidgetLabel(select$El);
},

_setInlineRecordingDeviceControlsDisabled: function(disabled) {
const setSelectDisabledState = function(select$El) {
    if(!select$El || !select$El.length){
        return;
    }

    if(disabled){
        select$El.attr("disabled", "disabled");
    }else{
        select$El.removeAttr("disabled");
    }

    if(select$El.data("mobile-selectmenu")){
        select$El.selectmenu(disabled ? "disable" : "enable");
    }
};

setSelectDisabledState(this.inlineRecordingMicrophoneFld$el);
setSelectDisabledState(this.inlineRecordingCameraFld$el);

if(this.requestRecordingDevicePermissionButton$el){
    this.requestRecordingDevicePermissionButton$el[disabled ? "addClass" : "removeClass"]("trebble_disabled");
}
},

_updateInlineRecordingDeviceFieldVisibility: function() {
const isVideoRecordingMode = this._isVideoRecordingMode();

if(this.recordingDeviceSelectors$el){
    this.recordingDeviceSelectors$el.toggleClass("singleField", !isVideoRecordingMode);
}

if(this.recordingCameraField$el){
    this.recordingCameraField$el.toggle(isVideoRecordingMode);
}
},

_updateRecordingDevicePermissionBanner: function(permissionState, audioDevices, videoDevices) {
if(!this.recordingDevicePermissionBanner$el || !this.recordingDevicePermissionText$el){
    return;
}

// In the studio-dock redesign we only surface the permission banner for
// HARD blocks (permissionState === "denied"). For the "prompt / labels not
// visible yet" case we no longer show a big coral banner — permission is
// requested lazily when the user actually tries to record, and the source
// pills below carry a subtle inline hint if needed. This keeps the page
// quiet and elegant until something is actually wrong.
const isVideoRecordingMode = this._isVideoRecordingMode();
let shouldShowBanner = false;
let shouldShowAction = false;
let message = "";

if(permissionState === "denied"){
    shouldShowBanner = true;
    message = window.getI18n(ti18n, isVideoRecordingMode ? "DEVICE_ACCESS_BLOCKED_VIDEO" : "DEVICE_ACCESS_BLOCKED_AUDIO");
}

this.recordingDevicePermissionText$el.text(message);
this.recordingDevicePermissionBanner$el.css("display", shouldShowBanner ? "flex" : "none");

if(this.requestRecordingDevicePermissionButton$el){
    this.requestRecordingDevicePermissionButton$el.css("display", shouldShowAction ? "inline-flex" : "none");
}
},

refreshInlineRecordingDeviceSelectors: function() {
if(!this.inlineRecordingMicrophoneFld$el || !this.inlineRecordingMicrophoneFld$el.length){
    return RSVP.Promise.resolve();
}

const isVideoRecordingMode = this._isVideoRecordingMode();
const audioDevicesPromise = AudioRecorderHelper.getInstance().getAudioDevicesAvailableWithoutPrompt().catch(function() {
    return [];
});
const videoDevicesPromise = isVideoRecordingMode ? AudioRecorderHelper.getInstance().getVideoDevicesAvailableWithoutPrompt().catch(function() {
    return [];
}) : RSVP.Promise.resolve([]);
const audioOutputDevicesPromise = this._isSpeakerOutputSelectionSupported() ? AudioRecorderHelper.getInstance().getAudioOutputDevicesAvailableWithoutPrompt().catch(function() {
    return [];
}) : RSVP.Promise.resolve([]);
const permissionStatePromise = AudioRecorderHelper.getInstance().getRecordingPermissionState(this._recordingMediaType).catch(function() {
    return "unknown";
});
const refreshToken = this._recordingDeviceRefreshToken + 1;
this._recordingDeviceRefreshToken = refreshToken;

return RSVP.all([audioDevicesPromise, videoDevicesPromise, permissionStatePromise, audioOutputDevicesPromise]).then((function(results) {
    if(refreshToken !== this._recordingDeviceRefreshToken){
        return;
    }

    const audioDevices = results[0] || [];
    const videoDevices = results[1] || [];
    const permissionState = results[2] || "unknown";
    const audioOutputDevices = results[3] || [];

    this._populateRecordingDeviceSelect(
        this.inlineRecordingMicrophoneFld$el,
        audioDevices,
        LocalStorageHelper.getInstance().getPreferredDeviceAudioId(),
        window.getI18n(ti18n, "MICROPHONE"),
        window.getI18n(ti18n, "NO_MICROPHONE_AVAILABLE")
    );

    this._populateRecordingDeviceSelect(
        this.inlineRecordingCameraFld$el,
        videoDevices,
        LocalStorageHelper.getInstance().getPreferredDeviceVideoId(),
        window.getI18n(ti18n, "CAMERA"),
        window.getI18n(ti18n, "NO_CAMERA_AVAILABLE")
    );

    if(this.studioDockDrawerSpeakerFld$el && this.studioDockDrawerSpeakerFld$el.length){
        this._populateRecordingDeviceSelect(
            this.studioDockDrawerSpeakerFld$el,
            audioOutputDevices,
            LocalStorageHelper.getInstance().getPreferredPlaybackOutputDeviceId(),
            window.getI18n(ti18n, "SPEAKER"),
            window.getI18n(ti18n, "NO_SPEAKER_AVAILABLE")
        );
    }

    this._updateInlineRecordingDeviceFieldVisibility();
    this._updateRecordingDevicePermissionBanner(permissionState, audioDevices, videoDevices);
    this._setInlineRecordingDeviceControlsDisabled(this._isRecordingFlowBusy());
    if(STUDIO_DOCK_RECORD_UI){
        this._refreshStudioDockSourcePillMenus();
        this._syncStudioDockDrawerControls();
    }
    this._onWindowSizeChanged();
}).bind(this)).catch((function(error) {
    console.error("Unable to refresh inline recording device selectors", error);
    this._updateInlineRecordingDeviceFieldVisibility();
    this._updateRecordingDevicePermissionBanner("unknown", [], []);
    this._setInlineRecordingDeviceControlsDisabled(this._isRecordingFlowBusy());
    if(STUDIO_DOCK_RECORD_UI){
        this._syncStudioDockDrawerControls();
    }
}).bind(this));
},

_onInlineRecordingMicrophoneChanged: function() {
if(this._isRecordingFlowBusy() || !this.inlineRecordingMicrophoneFld$el){
    return;
}

LocalStorageHelper.getInstance().setPreferredDeviceAudioId(this.inlineRecordingMicrophoneFld$el.val());
this._setSelectWidgetLabel(this.inlineRecordingMicrophoneFld$el);
this._syncStudioDockDrawerControls();
},

_onInlineRecordingCameraChanged: function() {
if(this._isRecordingFlowBusy() || !this.inlineRecordingCameraFld$el){
    return;
}

LocalStorageHelper.getInstance().setPreferredDeviceVideoId(this.inlineRecordingCameraFld$el.val());
this._setSelectWidgetLabel(this.inlineRecordingCameraFld$el);
this._syncStudioDockDrawerControls();
this.trigger("recordingVideoDeviceChanged");
},

_onRequestRecordingDevicePermissionButtonClicked: function() {
if(this._isRecordingFlowBusy()){
    return;
}

this.trigger("requestRecordingDevicePermissions", this._recordingMediaType);
},

getStudioDockVisualSource: function() {
    return this._studioDockVisualSource === "screen" ? "screen" : "camera";
},

setStudioDockVisualSource: function(sourceType, skipEvent) {
    const normalizedSourceType = sourceType === "screen" ? "screen" : "camera";
    this._studioDockVisualSource = normalizedSourceType;

    if(this.$el){
        this.$el.attr("recording-visual-source", normalizedSourceType);
    }
    if(this.recordingPreviewStage$el){
        this.recordingPreviewStage$el.toggleClass("is-screen-source", normalizedSourceType === "screen");
        this.recordingPreviewStage$el.toggleClass("is-camera-source", normalizedSourceType !== "screen");
    }

    this._syncStudioDockSourcePillsWithMode();
    this._syncStudioDockDrawerControls();

    if(!skipEvent){
        this.trigger("recordingVisualSourceChanged", normalizedSourceType);
    }
},

_cloneSelectOptionsToStudioDockDrawer: function(sourceSelect$el, targetSelect$el) {
    if(!sourceSelect$el || !sourceSelect$el.length || !targetSelect$el || !targetSelect$el.length){
        return;
    }

    const selectedValue = sourceSelect$el.val();
    targetSelect$el.empty();

    sourceSelect$el.find("option").each(function() {
        const option$el = $(this);
        const clonedOption$el = $("<option></option>").attr("value", option$el.attr("value") || "").text(option$el.text());
        if(option$el.is(":disabled")){
            clonedOption$el.attr("disabled", "disabled");
        }
        if(option$el.is(":hidden")){
            clonedOption$el.attr("hidden", "hidden");
        }
        if(option$el.is(":selected")){
            clonedOption$el.attr("selected", "selected");
        }
        targetSelect$el.append(clonedOption$el);
    });

    targetSelect$el.val(selectedValue);
    this._refreshSelectWidget(targetSelect$el);
},

_setStudioDockSwitchState: function(button$el, enabled) {
    if(!button$el || !button$el.length){
        return;
    }

    button$el.toggleClass("is-on", !!enabled).attr("aria-pressed", enabled ? "true" : "false");
},

_syncStudioDockPreviewGridState: function() {
    const isGridEnabled = LocalStorageHelper.getInstance().getRecordingPreviewGridEnabled();
    if(this.recordingPreviewStage$el && this.recordingPreviewStage$el.length){
        this.recordingPreviewStage$el.toggleClass("grid-on", isGridEnabled);
    }
    this._setStudioDockSwitchState(this.recordingPreviewGridToggleButton$el, isGridEnabled);
    this._setStudioDockSwitchState(this.studioDockDrawerGridToggle$el, isGridEnabled);
},

_syncStudioDockDrawerControls: function() {
    if(!STUDIO_DOCK_RECORD_UI){
        return;
    }

    if(this.studioDockDrawerResolutionFld$el && this.studioDockDrawerResolutionFld$el.length){
        this.studioDockDrawerResolutionFld$el.val(LocalStorageHelper.getInstance().getRecordingVideoResolution());
        this._refreshSelectWidget(this.studioDockDrawerResolutionFld$el);
    }

    if(this.studioDockDrawerSpeakerFld$el && this.studioDockDrawerSpeakerFld$el.length){
        const preferredPlaybackOutputDeviceId = LocalStorageHelper.getInstance().getPreferredPlaybackOutputDeviceSelectionWasExplicit() ? LocalStorageHelper.getInstance().getPreferredPlaybackOutputDeviceId() : "";
        const hasMatchingSpeakerOption = !!preferredPlaybackOutputDeviceId && this.studioDockDrawerSpeakerFld$el.find("option").filter(function() {
            return $(this).attr("value") == preferredPlaybackOutputDeviceId;
        }).length > 0;
        this.studioDockDrawerSpeakerFld$el.val(hasMatchingSpeakerOption ? preferredPlaybackOutputDeviceId : "");
        this._refreshSelectWidget(this.studioDockDrawerSpeakerFld$el);
    }

    this._setStudioDockSwitchState(this.studioDockDrawerEchoToggle$el, LocalStorageHelper.getInstance().getRecordingEchoCancellationEnabled());
    this._setStudioDockSwitchState(this.studioDockDrawerNoiseToggle$el, LocalStorageHelper.getInstance().getRecordingNoiseSuppressionEnabled());
    this._setStudioDockSwitchState(this.studioDockDrawerAutoGainToggle$el, LocalStorageHelper.getInstance().getRecordingAutoGainControlEnabled());
    this._setStudioDockSwitchState(this.studioDockDrawerCountdownToggle$el, LocalStorageHelper.getInstance().getRecordingCountdownEnabled());
    this._syncStudioDockPreviewGridState();

    const isVideoMode = this._isVideoRecordingMode();
    const isScreenSource = this.getStudioDockVisualSource() === "screen";

    if(this.studioDockDrawerResolutionField$el){
        this.studioDockDrawerResolutionField$el.toggle(isVideoMode && !isScreenSource);
    }
    if(this.studioDockDrawerSpeakerField$el){
        this.studioDockDrawerSpeakerField$el.toggle(this._isSpeakerOutputSelectionSupported());
    }
    if(this.studioDockDrawerGridToggleRow$el){
        this.studioDockDrawerGridToggleRow$el.toggle(isVideoMode);
    }
    if(this.studioDockDrawerScreenNote$el){
        this.studioDockDrawerScreenNote$el.toggle(isVideoMode && isScreenSource);
    }
},

_toggleStudioDockBooleanPreference: function(getterName, setterName) {
    const localStorageHelper = LocalStorageHelper.getInstance();
    const currentValue = localStorageHelper[getterName]();
    localStorageHelper[setterName](!currentValue);
    this._syncStudioDockDrawerControls();
},

_onStudioDockGridToggleClicked: function() {
    this._toggleStudioDockBooleanPreference("getRecordingPreviewGridEnabled", "setRecordingPreviewGridEnabled");
},

_onStudioDockEchoToggleClicked: function() {
    this._toggleStudioDockBooleanPreference("getRecordingEchoCancellationEnabled", "setRecordingEchoCancellationEnabled");
},

_onStudioDockNoiseToggleClicked: function() {
    this._toggleStudioDockBooleanPreference("getRecordingNoiseSuppressionEnabled", "setRecordingNoiseSuppressionEnabled");
},

_onStudioDockAutoGainToggleClicked: function() {
    this._toggleStudioDockBooleanPreference("getRecordingAutoGainControlEnabled", "setRecordingAutoGainControlEnabled");
},

_onStudioDockCountdownToggleClicked: function() {
    this._toggleStudioDockBooleanPreference("getRecordingCountdownEnabled", "setRecordingCountdownEnabled");
},

_onStudioDockDrawerGridToggleClicked: function() {
    this._onStudioDockGridToggleClicked();
},

_onStudioDockDrawerMicrophoneChanged: function() {
    if(this._isRecordingFlowBusy() || !this.studioDockDrawerMicrophoneFld$el || !this.inlineRecordingMicrophoneFld$el){
        return;
    }

    this.inlineRecordingMicrophoneFld$el.val(this.studioDockDrawerMicrophoneFld$el.val()).trigger("change");
    this._syncStudioDockDrawerControls();
},

_onStudioDockDrawerCameraChanged: function() {
    if(this._isRecordingFlowBusy() || !this.studioDockDrawerCameraFld$el || !this.inlineRecordingCameraFld$el){
        return;
    }

    this.inlineRecordingCameraFld$el.val(this.studioDockDrawerCameraFld$el.val()).trigger("change");
    this._syncStudioDockDrawerControls();
},

_onStudioDockDrawerSpeakerChanged: function() {
    if(!this.studioDockDrawerSpeakerFld$el || !this.studioDockDrawerSpeakerFld$el.length){
        return;
    }

    const preferredPlaybackOutputDeviceId = this.studioDockDrawerSpeakerFld$el.val();
    LocalStorageHelper.getInstance().setPreferredPlaybackOutputDeviceId(preferredPlaybackOutputDeviceId);
    LocalStorageHelper.getInstance().setPreferredPlaybackOutputDeviceSelectionWasExplicit(!!preferredPlaybackOutputDeviceId);
    this._refreshSelectWidget(this.studioDockDrawerSpeakerFld$el);
    this._syncStudioDockDrawerControls();

    if(this.recordedPlaybackVideo$el && this.recordedPlaybackVideo$el.length && this.recordedPlaybackVideo$el.is(":visible")){
        this._applyPreferredSpeakerOutputToMediaElement(this.recordedPlaybackVideo$el.get(0));
    }

    AudioRecorderHelper.getInstance().applyPreferredPlaybackOutputDeviceToActivePlayers();
},

_onStudioDockDrawerResolutionChanged: function() {
    if(this._isRecordingFlowBusy() || !this.studioDockDrawerResolutionFld$el){
        return;
    }

    LocalStorageHelper.getInstance().setRecordingVideoResolution(this.studioDockDrawerResolutionFld$el.val());
    this._refreshSelectWidget(this.studioDockDrawerResolutionFld$el);
    this._syncStudioDockDrawerControls();
    this.trigger("recordingVideoResolutionChanged");
},

_initStudioDockSourcePills: function() {
    if(!STUDIO_DOCK_RECORD_UI || !this.$el){
        return;
    }
    const $pillRow = this.$el.find(".source-row");
    if(!$pillRow.length || this._studioDockSourcePillsInitialized){
        return;
    }
    this._studioDockSourcePillsInitialized = true;

    this._studioDockPillMic$el = $pillRow.find(".source-pill[data-kind='mic']");
    this._studioDockPillCamera$el = $pillRow.find(".source-pill[data-kind='camera']");
    this._studioDockPillScreen$el = $pillRow.find(".source-pill[data-kind='screen']");
    if(this._studioDockPillScreen$el && this._studioDockPillScreen$el.length && !AudioRecorderHelper.getInstance().isScreenShareSupported()){
        this._studioDockPillScreen$el.hide();
    }

    const self = this;

    // Mic pill: menu open/close
    this._studioDockPillMic$el.on("click", ".sp-main", function(e) {
        e.preventDefault();
        e.stopPropagation();
        self._toggleStudioDockPillMenu(self._studioDockPillMic$el);
    });
    // Mic toggle is inert (mic always on while recording is possible)
    this._studioDockPillMic$el.on("click", ".sp-toggle-wrap", function(e) {
        e.preventDefault();
        e.stopPropagation();
    });

    // Camera pill: menu open/close
    this._studioDockPillCamera$el.on("click", ".sp-main", function(e) {
        e.preventDefault();
        e.stopPropagation();
        self._toggleStudioDockPillMenu(self._studioDockPillCamera$el);
    });
    // Camera toggle: triggers existing audio/video mode switch
    this._studioDockPillCamera$el.on("click", ".sp-toggle-wrap", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(self._isStoppingRecording || (self._isRecordingFlowBusy() && self._recordingMediaType !== "video")){
            return;
        }
        if(self._recordingMediaType === "video" && self.getStudioDockVisualSource() === "camera"){
            self._onRecordAudioModeButtonClicked();
        } else {
            self.setStudioDockVisualSource("camera");
            if(self._recordingMediaType !== "video"){
                self._onRecordVideoModeButtonClicked();
            }
        }
    });

    // Screen pill: first safe version switches the single visual source
    // between camera and screen. It does not attempt live PiP compositing.
    this._studioDockPillScreen$el.on("click", ".sp-toggle-wrap, .sp-main", function(e) {
        e.preventDefault();
        e.stopPropagation();
        if(self._isStoppingRecording || (self._isRecordingFlowBusy() && self._recordingMediaType !== "video")){
            return;
        }
        if(self._recordingMediaType === "video" && self.getStudioDockVisualSource() === "screen"){
            self.setStudioDockVisualSource("camera", true);
            self._onRecordAudioModeButtonClicked();
            return;
        }

        self.setStudioDockVisualSource("screen");
        if(self._recordingMediaType !== "video"){
            self._requestRecordingMediaTypeChange("video");
        }
    });

    // Close menus on outside click
    if(!this._studioDockPillOutsideHandlerBound){
        this._studioDockPillOutsideHandlerBound = true;
        this._studioDockPillOutsideHandler = function() {
            self._closeAllStudioDockPillMenus();
        };
        $(document).on("click.studioDockPills", this._studioDockPillOutsideHandler);
    }

    // Initial render
    this._refreshStudioDockSourcePillMenus();
    this._syncStudioDockSourcePillsWithMode();
},

_toggleStudioDockPillMenu: function($pill) {
    if(!$pill || !$pill.length){
        return;
    }
    const willOpen = !$pill.hasClass("sp-menu-open");
    this._closeAllStudioDockPillMenus();
    $pill.toggleClass("sp-menu-open", willOpen);
},

_closeAllStudioDockPillMenus: function() {
    if(!this.$el){
        return;
    }
    this.$el.find(".source-pill.sp-menu-open").removeClass("sp-menu-open");
},

_refreshStudioDockSourcePillMenus: function() {
    if(!STUDIO_DOCK_RECORD_UI || !this._studioDockSourcePillsInitialized){
        return;
    }

    this._renderStudioDockPillMenu(
        this._studioDockPillMic$el,
        this.inlineRecordingMicrophoneFld$el,
        (function(deviceId, label) {
            if(!this.inlineRecordingMicrophoneFld$el){
                return;
            }
            this.inlineRecordingMicrophoneFld$el.val(deviceId).trigger("change");
        }).bind(this)
    );

    this._renderStudioDockPillMenu(
        this._studioDockPillCamera$el,
        this.inlineRecordingCameraFld$el,
        (function(deviceId, label) {
            if(!this.inlineRecordingCameraFld$el){
                return;
            }
            this.inlineRecordingCameraFld$el.val(deviceId).trigger("change");
        }).bind(this)
    );
},

_renderStudioDockPillMenu: function($pill, $selectEl, onPick) {
    if(!$pill || !$pill.length || !$selectEl || !$selectEl.length){
        return;
    }
    const $menu = $pill.find(".sp-menu");
    const $deviceLabel = $pill.find(".sp-main .sp-device");
    $menu.empty();

    const options = $selectEl.get(0) ? $selectEl.get(0).options : [];
    const selectedVal = $selectEl.val();
    let selectedText = "";

    for(let i = 0; i < options.length; i++){
        const opt = options[i];
        const value = opt.value;
        const text = opt.textContent || opt.innerText || "";
        const isSelected = value === selectedVal;
        if(isSelected){
            selectedText = text;
        }
        const $btn = $("<button type=\"button\" class=\"sp-menu-item\"></button>");
        $btn.text(text);
        if(isSelected){
            $btn.addClass("selected");
            $btn.append("<span class=\"sp-menu-check\">&#10003;</span>");
        }
        $btn.on("click", function(e) {
            e.preventDefault();
            e.stopPropagation();
            if(typeof onPick === "function"){
                onPick(value, text);
            }
            $deviceLabel.text(text);
            $menu.find(".sp-menu-item").removeClass("selected").find(".sp-menu-check").remove();
            $(this).addClass("selected").append("<span class=\"sp-menu-check\">&#10003;</span>");
            $pill.removeClass("sp-menu-open");
        });
        $menu.append($btn);
    }

    $deviceLabel.text(selectedText);
},

_syncStudioDockSourcePillsWithMode: function() {
    if(!STUDIO_DOCK_RECORD_UI || !this._studioDockSourcePillsInitialized){
        return;
    }
    const isVideo = this._recordingMediaType === "video";
    const isScreenSource = isVideo && this.getStudioDockVisualSource() === "screen";
    const isCameraSource = isVideo && !isScreenSource;
    if(this._studioDockPillCamera$el){
        this._studioDockPillCamera$el.toggleClass("is-on", isCameraSource);
    }
    if(this._studioDockPillMic$el){
        this._studioDockPillMic$el.addClass("is-on");
    }
    if(this._studioDockPillScreen$el){
        this._studioDockPillScreen$el.toggleClass("is-on", isScreenSource);
        this._studioDockPillScreen$el.find(".sp-device").text(isScreenSource ? window.getI18n(ti18n, "SCREEN_SHARE") : "");
    }
    const $visualStage = this.$el ? this.$el.find(".visual-stage") : null;
    if($visualStage && $visualStage.length){
        $visualStage.toggleClass("show-camera", isCameraSource);
        $visualStage.toggleClass("show-screen", isScreenSource);
    }
    const $panel = this.$el ? this.$el.find(".panel") : null;
    if($panel && $panel.length){
        $panel.toggleClass("has-visual", isVideo);
    }
    if(this.recordingPreviewGridToggleButton$el){
        this.recordingPreviewGridToggleButton$el.toggle(isVideo);
    }
},

_onCarouselMove: function() {

},

setCapsuleInfoToEdit: function(capsuleInfoToEdit){
    this._capsuleInfoToEdit = capsuleInfoToEdit;
    if(this._capsuleInfoToEdit){
        this.titleField$el.val(this._capsuleInfoToEdit.getTitle());
        this.comment$el.val(this._capsuleInfoToEdit.getText());
    }

},

navigateToPreviousPage : function(){
    return PersistentModels.getInstance().getRouter().navigateToPreviousPage();
},

_setPageCanBeDeletedIfHidden: function(canBeDeletedIfHidden){
this._canBeDeletedIfHidden = canBeDeletedIfHidden;
},

_canPageBeDeletedIfHidden : function(){
return this._canBeDeletedIfHidden;
},

_isRecordingFlowBusy: function() {
return !!(this._isRecording || this._isStoppingRecording);
},

_isUploadOrTranscriptionFlowBusy: function() {
return !!(this._uploadingViewInCapsuleInfoDisplayed || this._uploadingViewInAudioEditorDisplayed);
},

_shouldWarnBeforeUnload: function() {
return this._isRecordingFlowBusy() || this._isUploadOrTranscriptionFlowBusy();
},

_onBeforeUnload: function(event) {
if(!this._shouldWarnBeforeUnload()){
    return;
}

if(event){
    event.preventDefault();
    event.returnValue = "";
}

return "";
},

_refreshBeforeUnloadProtection: function() {
if(typeof window === "undefined" || !window.addEventListener || !window.removeEventListener){
    return;
}

this.showBackButton();

if(this._shouldWarnBeforeUnload()){
    if(!this._beforeUnloadHandlerRegistered){
        window.addEventListener("beforeunload", this._beforeUnloadHandler);
        this._beforeUnloadHandlerRegistered = true;
    }
}else if(this._beforeUnloadHandlerRegistered){
    window.removeEventListener("beforeunload", this._beforeUnloadHandler);
    this._beforeUnloadHandlerRegistered = false;
}
},

_syncRecordingInteractionBusyState: function() {
const isBusy = this._isRecordingFlowBusy();
const isFinalizingRecording = !!this._isStoppingRecording;
const isVideoRecordingSupported = AudioRecorderHelper.getInstance().isRecordingMediaTypeSupported("video");
const shouldDisableVisualSourcePills = isFinalizingRecording || !isVideoRecordingSupported || (isBusy && this._recordingMediaType !== "video");
const methodName = isBusy ? "addClass" : "removeClass";

if(this.recordButtonWrapper$el){
    this.recordButtonWrapper$el[methodName]("trebble_disabled");
}
if(this.stopRecordingButton$el){
    this.stopRecordingButton$el[isFinalizingRecording ? "addClass" : "removeClass"]("trebble_disabled");
}
if(this.recordAudioModeButton$el){
    this.recordAudioModeButton$el[methodName]("trebble_disabled");
}
if(this.recordVideoModeButton$el){
    this.recordVideoModeButton$el.toggleClass("trebble_disabled", isBusy || !isVideoRecordingSupported).attr("aria-disabled", (isBusy || !isVideoRecordingSupported) ? "true" : "false");
}
if(this.showRecordingSettingsButton$el){
    this.showRecordingSettingsButton$el[methodName]("trebble_disabled");
    this.showRecordingSettingsButton$el.prop("disabled", isBusy).attr("aria-disabled", isBusy ? "true" : "false");
}
const studioDockSettingsButton$el = (this.studioDockSettingsButton$el && this.studioDockSettingsButton$el.length) ? this.studioDockSettingsButton$el : (this.$el ? this.$el.find("#studioDockSettingsBtn") : $());
if(studioDockSettingsButton$el && studioDockSettingsButton$el.length){
    studioDockSettingsButton$el.toggleClass("trebble_disabled", isBusy).prop("disabled", isBusy).attr("aria-disabled", isBusy ? "true" : "false");
    this.studioDockSettingsButton$el = studioDockSettingsButton$el;
}
if(this.doneRecordingButton$el){
    if(isBusy){
        this.doneRecordingButton$el.addClass("trebble_disabled");
    }else{
        this.doneRecordingButton$el.removeClass("trebble_disabled");
    }
}
if(this._studioDockPillMic$el){
    this._studioDockPillMic$el.toggleClass("is-disabled", isBusy).attr("aria-disabled", isBusy ? "true" : "false");
}
if(this._studioDockPillCamera$el){
    this._studioDockPillCamera$el.toggleClass("is-disabled", shouldDisableVisualSourcePills).attr("aria-disabled", shouldDisableVisualSourcePills ? "true" : "false");
}
if(this._studioDockPillScreen$el){
    this._studioDockPillScreen$el.toggleClass("is-disabled", shouldDisableVisualSourcePills).attr("aria-disabled", shouldDisableVisualSourcePills ? "true" : "false");
}
if(isBusy){
    this._closeAllStudioDockPillMenus();
}

this._setInlineRecordingDeviceControlsDisabled(isBusy);
},

_finalizeRecordingUiState: function() {
if(this.$el){
    this.$el.attr("is-recording","false");
    this.$el.attr("is-recording-finalizing","false");
}

this._syncCompactVideoTimerRowState();
this._refreshBeforeUnloadProtection();
this._syncRecordingInteractionBusyState();
this.showBackButton();

if(SHOW_PLAY_BUTTON_INSIDE_CIRCULAR_TIMER){
    this.progressbarText$el.hide();
    this.playButton$el.show();
}

if(this._canBackgroundMusicUsed()){
    if(this._hasContentRecorded()){
        this._showTrackContainer();
    }else{
        this._hideTrackContainer();
    }
}

this._enableNextButtonIfApplicable();
this._enableDoneRecordingBtnIfApplicable();
this._flushPendingRecordingMediaTypeChange();
},

navigateToPreviousPageConfirm : function(){
if(this._shouldWarnBeforeUnload()){
    return;
}
if(this.wasAudioContentCreated()){
    const buttonLabels = [window.getI18n(ti18n,"NO"), window.getI18n(ti18n,"YES")];
    const confirmCallback = (function(buttonIndex){
        if(buttonIndex ==  2){
            this._setPageCanBeDeletedIfHidden(true);
            this.navigateToPreviousPage();
        }
    }).bind(this);
    const message = window.getI18n(ti18n,"ARE_YOU_WANT_TO_NAVIGATE_TO_PREVIOUS_SCREEN");
    const canRecoverCurrentBrowserRecording = this.isInRecordMode() && !this.isAudioWasTranscribedAndEdited() && AudioRecorderHelper.getInstance().isDurableBrowserRecordingDraftsEnabled();
    const recoverLaterSubMessage = window.getI18n(ti18n, "RECORDING_CAN_BE_RECOVERED_LATER");
    const subMessage = canRecoverCurrentBrowserRecording ?
        (recoverLaterSubMessage && recoverLaterSubMessage !== "RECORDING_CAN_BE_RECOVERED_LATER" ? recoverLaterSubMessage : "Your unfinished browser recording can be recovered later from this device.") :
        window.getI18n(ti18n,"ALL_YOUR_RECORDING_AND_EDITS_WILL_BE_LOST");
    window.showConfirmDialog(message , confirmCallback, window.getI18n(ti18n,"DELETE_CAPSULE"), buttonLabels,null , null, subMessage);
}else{
    this._setPageCanBeDeletedIfHidden(true);
    this.navigateToPreviousPage();
}
},

_showPauseRecordingButton : function(show){
if(show){
    this.recordButtonWrapper$el.addClass("hidden");
    this.stopRecordingButton$el.removeClass("hidden");

}else{
    this.stopRecordingButton$el.addClass("hidden");
    this.recordButtonWrapper$el.removeClass("hidden");
}
},

_onPauseRecordingButtonClicked : function(){
if(this._isStoppingRecording || !this._isRecording || (this.stopRecordingButton$el && this.stopRecordingButton$el.hasClass("trebble_disabled"))){
    return;
}
this._stopRecording();
},

_onRecordRecordingButtonClicked : function(){
if(this._isRecordingFlowBusy() || (this.recordButtonWrapper$el && this.recordButtonWrapper$el.hasClass("trebble_disabled"))){
    return;
}
this.trigger("checkRecordingPermissionAndRecord");
},

onUserStartRecording : function(){
this._startRecording();
this.recordingInstruction$el.hide();
this._recordingInstructionsDisplayed  = false;
if(this.trackContainer$el){
    this.trackContainer$el.hide()
}
if(this.trackSlectorBlockSpacer$el){
    if(this.$el && this.$el.hasClass("studio-dock")){
        this.trackSlectorBlockSpacer$el.hide();
    }else{
        this.trackSlectorBlockSpacer$el.css("display", "flex");
    }
}
this._showPauseRecordingButton(true);
},

_initpublishingSettingField :function(){
this.$el.find("#publishingSettingFld").on("change",this._hideShowSchedulingDateFieldIfApplicable.bind(this));
if(!this._capsuleSchedulingAvailable){
    this.publishingSettingWrapper$el.hide();
}
},

_onVoiceActorNarrationSelected : function(){
this.$el.find("#publishingSettingFld option[value="+PUBLISHED_SETTING_VALUES.NOW+"]").attr('disabled', true);
this.$el.find(".narration_schedule_warning .number_of_hours_for_narration").html(MIN_HOUR_REQUIRED_FOR_NARRATION);
this.$el.find(".narration_schedule_warning").show();
if(this.getPublishedSetting() == PUBLISHED_SETTING_VALUES.NOW){
    this.$el.find("#publishingSettingFld").find(":selected").removeAttr("selected");
    this.$el.find("#publishingSettingFld").find("[value="+PUBLISHED_SETTING_VALUES.SCHEDULED+"]").attr("selected","selected");
    this.$el.find("#publishingSettingFld").val(PUBLISHED_SETTING_VALUES.SCHEDULED).change();
}
},

_onVoiceActorNarrationUnselected : function(){
this.$el.find("#publishingSettingFld option[value="+PUBLISHED_SETTING_VALUES.NOW+"]").removeAttr('disabled');
this.$el.find(".narration_schedule_warning").hide();
},

_initSchedulingDatePicker : function(){
const tomorrow = new Date();
tomorrow.setDate(new Date().getDate()+1);
tomorrow.setHours(0,0,0,0);

const useLastCapsuleScheduleDate = window._lastCapsuleUploadSettings && window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession && tomorrow.getTime() <= window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession.getTime();

this.schedulingSettingFld$el.pickadate({
    selectMonths: true, // Creates a dropdown to control month
    selectYears: 10,
    min: tomorrow,
    container: this.$el,
    containerHidden: this.$el,
    formatSubmit: 'yyyy/mm/dd',
    today: window.getI18n(ti18n,"TODAY"),
    clear: window.getI18n(ti18n,"CLEAR"),
    close: window.getI18n(ti18n,"OK"),
    onClose: function() {
        $(document.activeElement).blur();
    },
    onStart: function ()
    {
        const date = (useLastCapsuleScheduleDate) ? window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession : new Date();
        this.set('select', [date.getFullYear(), date.getMonth() , date.getDate()+ 1]);
    },
    closeOnSelect: false, // Close upon selecting a date,
    // container: 'body', // ex. 'body' will append picker to body
});
if(useLastCapsuleScheduleDate){
    this.$el.find("#publishingSettingFld").find(":selected").removeAttr("selected");
    this.$el.find("#publishingSettingFld").find("[value="+PUBLISHED_SETTING_VALUES.SCHEDULED+"]").attr("selected","selected");
    this.$el.find("#publishingSettingFld").val(PUBLISHED_SETTING_VALUES.SCHEDULED).change();
    if(window._lastCapsuleUploadSettings && window._lastCapsuleUploadSettings.capsuleLastScheduleDurationInCurrentSession){
        this.$el.find("#capsuleLifeSpanFld").find(":selected").removeAttr("selected");
        this.$el.find("#capsuleLifeSpanFld").find("[value="+window._lastCapsuleUploadSettings.capsuleLastScheduleDurationInCurrentSession+"]").attr("selected","selected");
        this.$el.find("#capsuleLifeSpanFld").val(window._lastCapsuleUploadSettings.capsuleLastScheduleDurationInCurrentSession).change();
    }
    this._hideShowSchedulingDateFieldIfApplicable();
}
},

_initSchedulingTimePicker : function(){
const tomorrow = new Date();
tomorrow.setDate(new Date().getDate()+1);
tomorrow.setHours(0,0,0,0);

const useLastCapsuleScheduleDate = window._lastCapsuleUploadSettings && window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession && tomorrow.getTime() <= window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession.getTime();
let startTimeString = "00:00";
if(useLastCapsuleScheduleDate){
window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession;
const hours = window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession.getHours();
const minutes = window._lastCapsuleUploadSettings.capsuleLastScheduleDateInCurrentSession.getMinutes();
startTimeString = ""+((hours< 10)?"0"+hours:hours)+":"+ ((minutes< 10)?"0"+minutes:minutes);
}

this.schedulingTimeFld$el.pickatime({
default: startTimeString,
interval: 5,
container: this.$el,
containerHidden: this.$el,
twelvehour: false, // Use AM/PM or 24-hour format
donetext: window.getI18n(ti18n,"OK"), // text for done-button
cleartext: window.getI18n(ti18n,"CLEAR"), // text for clear-button
canceltext: window.getI18n(ti18n,"CANCEL"), // Text for cancel-button,
//container: 'body', // ex. 'body' will append picker to body
autoclose: true, // automatic close timepicker
ampmclickable: true, // make AM PM clickable
onClose: function() {
    $(document.activeElement).blur();
},


});
this.schedulingTimeFld$el.val(startTimeString);
},

isShowNotesButtonToggleOn : function(){
if(STUDIO_DOCK_RECORD_UI && this.$el){
    const shell$el = this.$el.find("#recordingBlock .shell");
    if(shell$el && shell$el.length){
        return shell$el.hasClass("notes-open");
    }
}
const showNotesToggleInput$el = this.$el.find("#showNotesToggleBox input").first();
if(showNotesToggleInput$el && showNotesToggleInput$el.length){
    return !!showNotesToggleInput$el.prop('checked');
}
return false;
},

_setCompactVideoTimerLabel: function(timerLabel) {
if(this.videoRecordingTimerValue$el){
    this.videoRecordingTimerValue$el.text(timerLabel || "0:00");
}
},

_syncCompactVideoTimerRowState: function() {
if(!this.videoRecordingTimerRow$el){
    return;
}

const shouldShowNotes = this.isShowNotesButtonToggleOn();
const isVideoRecordingMode = this._isVideoRecordingMode();
const shouldHideTimerForNotes = shouldShowNotes && !STUDIO_DOCK_RECORD_UI;
const shouldShowRow = isVideoRecordingMode && !shouldHideTimerForNotes && this._recordingPreviewState !== "error";
const shouldShowTimerValue = !!(this._isRecording || this._isStoppingRecording);

this.videoRecordingTimerRow$el.css("display", shouldShowRow ? "flex" : "none");
this.videoRecordingTimerRow$el.toggleClass("show-timer", shouldShowTimerValue);
this.videoRecordingTimerRow$el.toggleClass("preview-only", shouldShowRow && !shouldShowTimerValue);
},

_syncCircularProgressVisibilityForMode: function() {
if(!this.recordProgressContainer$el){
    return;
}

const shouldHideCircularProgress = this._isVideoRecordingMode();
const progressSvg$el = this.recordProgressContainer$el.find("svg");

if(progressSvg$el && progressSvg$el.length){
    progressSvg$el.css("display", shouldHideCircularProgress ? "none" : "block");
}
},

_syncRecordingLayoutVisibility: function() {
if(!this.noteSection$el || !this.flexContentCenteringBox$el){
    return;
}

const shouldShowNotes = this.isShowNotesButtonToggleOn();
const isVideoRecordingMode = this._isVideoRecordingMode();

if(STUDIO_DOCK_RECORD_UI){
    this.noteSection$el.attr("aria-hidden", shouldShowNotes ? "false" : "true");
}else if(shouldShowNotes){
    this.noteSection$el.removeClass("hidden").css("display","flex");
}else{
    this.noteSection$el.addClass("hidden").hide();
}

this.flexContentCenteringBox$el.css("display", (!isVideoRecordingMode && !(shouldShowNotes && !STUDIO_DOCK_RECORD_UI)) ? "flex" : "none");
this._syncCompactVideoTimerRowState();

this._syncCircularProgressVisibilityForMode();
},

onShowNotesToggleClicked : function(){
if(STUDIO_DOCK_RECORD_UI && this.$el){
    this._syncStudioDockPanelButtons();
}
this._syncRecordingLayoutVisibility();
},
_initShowNotesSection : function(){
this.$el.find("#showNotesToggleBox input").first().on("change",this.onShowNotesToggleClicked.bind(this));
this.onShowNotesToggleClicked();
},

_initDeleteButtonIfApplicable: function(){
const iconToChange$el = this.$el.find("#deleteButton > t");
const deleteBtn$el = this.$el.find("#deleteButton");
if(DELETE_PREVIOUS_RECORDING_WITHOUT_CONFIRMATION){
iconToChange$el.addClass(READY_TO_DELETED_ICON);
iconToChange$el.removeClass(TO_DELETE_ICON);
deleteBtn$el.attr("data-hint",HINT_READY_TO_DELETE_ICON_MESSAGE);

}else{

iconToChange$el.addClass(TO_DELETE_ICON);
iconToChange$el.removeClass(READY_TO_DELETED_ICON);
deleteBtn$el.attr("data-hint",HINT_DELETE_ICON_MESSAGE);

}
if(this._completedRecordedSnippetArray.length > 0){

deleteBtn$el.removeClass("trebble_disabled");

}else{
if(!deleteBtn$el.hasClass("trebble_disabled")){
deleteBtn$el.addClass("trebble_disabled");
}
}

},

_getRecordingCircleHtml : function(){
return '<span class="red_recording_circle"></span>';
},

_relocateTimerSpanToDock: function() {
    if(!this.$el){ return; }
    const timerSpan$el = this.$el.find("#recordProgressContainer .progressbar-text .timer-progress");
    const dockSlot$el = this.$el.find(".timer-area .live-timer-slot");
    if(!timerSpan$el.length || !dockSlot$el.length){
        console.warn("_relocateTimerSpanToDock: timer span or dock slot not found", {
            hasTimer: timerSpan$el.length, hasSlot: dockSlot$el.length
        });
        return;
    }
    if($.contains(dockSlot$el.get(0), timerSpan$el.get(0))){
        this._liveTimerSpan$el = timerSpan$el;
        return;
    }
    timerSpan$el.detach().appendTo(dockSlot$el);
    this._liveTimerSpan$el = timerSpan$el;
},

afterRendering: function() {
this.noteSection$el = this.$el.find("#noteSection");
this.studioDockDrawer$el = this.$el.find("#studioDockDrawer");
this.timeLeftToRecord$el = this.$el.find("#time_left_to_record");
this.totalRecordingTime$el = this.$el.find("#total_recording_time");

this._initializeCarousels();
this._addArrowToSelectWidget();
this._initCommentBox();
this._initSchedulingDatePicker();
this._initSchedulingTimePicker();
this._initpublishingSettingField();
this._initShowNotesSection();
this._initDeleteButtonIfApplicable();
this._inlineRecordingDeviceControlsInitialized = true;
this.refreshInlineRecordingDeviceSelectors();
if (STUDIO_DOCK_RECORD_UI) {
    this._mountStudioDockDrawersToBody();
    this._applyStudioDockDrawerRootStyles();
    this._bindStudioDockFloatingDrawerHandlers();
    this._initStudioDockSourcePills();
}


this.progressbarContainer$el = this.recordProgressContainer$el.first();
const progressbarContainer = this.progressbarContainer$el[0];
this.deleteProgressBar = new ProgressBar.Circle(progressbarContainer, {
color: TO_BE_DELETED_RECORDING_COLOR,
trailColor: DEFAULT_TRAIL_COLOR,
strokeWidth: 1,
trailWidth: 1,
duration: this._recordMaxSize
});
this.recordedProgressBar = new ProgressBar.Circle(progressbarContainer, {
color: '#FCB03C',
trailColor: 'transparent',
strokeWidth: 1,
trailWidth: 1,
duration: this._recordMaxSize,
step: (function(state, circle) {
    const timeLeftInMilliseconds = this._recordMaxSize - (circle.value() * this._recordMaxSize)
    let timeLeftFormattedForDisplay = "0:00";
let timeElapsed = "0:00";
if(timeLeftInMilliseconds > 0){
    let m1 = moment.duration(timeLeftInMilliseconds);
    timeLeftFormattedForDisplay = m1.minutes() + ":" +(m1.seconds()<10? "0"+m1.seconds() : m1.seconds());
    if(SHOW_DECIMAL_IN_RECORDING_TIME){
        let millisec = m1.milliseconds();
        //timeLeftFormattedForDisplay = timeLeftFormattedForDisplay +"."+ ((millisec <100)?  "0"+Math.floor(millisec/10) : Math.floor(millisec/10));
        timeLeftFormattedForDisplay = timeLeftFormattedForDisplay +"."+ Math.floor(millisec/100);
    }
}
if(circle.value() > 0){
    let m2 = moment.duration(circle.value() * this._recordMaxSize);
    timeElapsed = m2.minutes() + ":" +(m2.seconds()<10? "0"+m2.seconds() : m2.seconds());
    if(SHOW_DECIMAL_IN_RECORDING_TIME){
        let millisec = m2.milliseconds();
        //timeElapsed = timeElapsed +"."+ ((millisec <100)?  "0"+Math.floor(millisec/10) : Math.floor(millisec/10));
        timeElapsed = timeElapsed +"."+ Math.floor(millisec/100);
    }
}
this.timeLeftToRecord$el.html(timeLeftFormattedForDisplay);
this.totalRecordingTime$el.html(timeElapsed);
//circle.setText((circle.value() * this._recordMaxSize / 1000).toFixed(1) + "s");
//circle.setText(timeElapsed);
(this._liveTimerSpan$el && this._liveTimerSpan$el.length ? this._liveTimerSpan$el : this.$el.find(".progressbar-text .timer-progress")).html(timeElapsed);
this._setCompactVideoTimerLabel(timeElapsed);
}).bind(this)

});
if (STUDIO_DOCK_RECORD_UI) { this._relocateTimerSpanToDock(); }
//this.recordButton$el = this.$el.find("#recordButton > t");
this.recordButtonWrapper$el = this.$el.find("#recordButton");
this.stopRecordingButton$el  = this.$el.find("#stopRecordingButton");
this.headerBackButton$el  = this.$el.find("#header-back-button");
this.showNotesToggleBox$el  = this.$el.find("#showNotesToggleBox");

if(!this._audioRecordingSupported){
this._showUploadSection();
this.showRecordSectionButton$el.hide();
}
if(this._saveAsDraft){
this._setSaveAsDraft();
}

if(SHOW_PLAY_BUTTON_INSIDE_CIRCULAR_TIMER){
this.$el.find("#recordControlsWrapper #playButton").insertAfter(this.$el.find(".progressbar-text"))/*.click(this._playStopPlayingRecording.bind(this))*/.hide();
this.$el.find("#deleteButton").hide();
}
this._switchToDeletionMode(false);
this._enableNextButtonIfApplicable();
this._enableDoneRecordingBtnIfApplicable();
this._syncRecordingInteractionBusyState();
this.$el.find("#comment").val("cc");
this.$el.find("#comment").val("");
this.$el.on("pageAppendedToBody", (function(){
if(CONFIGURE_BACKGROUND_MUSIC){
this._setupBackgroundMusicSelector();
}else{
if(USE_DEFAULT_MUSIC_SELECTOR){
    this._setupBackgroundTrackSelector();
}
}
}).bind(this));

if(CSS_PAGE_BACKGROUND){
this.$el.css("background", CSS_PAGE_BACKGROUND);
}


//this.$el.find("#comment").mention(params);
//this.$el.find(".commentForm").on("submit", this._onFormSubmit.bind(this));
//this.$el.find("#commentBtn").click(this._onCommentButtonClicked.bind(this));
},



setCreationMode : function(creationMode){
if(creationMode == CREATION_MODE.FROM_RECORDING){
return this._showRecordSection();
}
if(creationMode == CREATION_MODE.FROM_TEXT){
return this._showTextToSpeechSection();
}
if(creationMode == CREATION_MODE.FROM_FILE){
return this._showUploadSection();
}
if(creationMode == CREATION_MODE.FROM_VOICE_ACTOR){
return this._showUseVoiceActorSection();
}
if(creationMode == CREATION_MODE.FROM_TRANSCRIPT){
return this._showUseVoiceActorSection();
}
},

_showUploadSection : function(){
this.clearRecordingPreviewStream();
this.showUploadSectionButton$el.hide();
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_RECORD_AUDIO_IN_PAGE_HEADER){
this.showRecordSectionButton$el.show();
this.$el.find(".orrecordsection").hide();
}else{
this.showRecordSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
this.showTextToSpeechSectionButton$el.show();
}else{
this.showTextToSpeechSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
this.showVoiceActorNarrationSectionButton$el.show();
}else{
this.showVoiceActorNarrationSectionButton$el.hide();
}
if (STUDIO_DOCK_RECORD_UI) {
    const recordingShell$el = this.$el.find("#recordingBlock .shell");
    this._closeStudioDockSidePanels();
    this.recordingBlock$el.css("display", "flex");
    this.recordingBlock$el.addClass("upload-mode-shell");
    recordingShell$el.addClass("upload-mode").removeClass("notes-open").removeClass("settings-open");
} else {
    this.recordingBlock$el.hide();
}
this.showRecordingSettingsButton$el.hide();
this.doneRecordingButton$el.hide();
this.textToSpeechBlock$el.hide();
this.useVoiceActorBlock$el.hide();
this._onVoiceActorNarrationUnselected();
this.uploadBlock$el.attr('style', 'display: -webkit-flex; display: flex;display: -moz-flex; display: -ms-flex');
if (STUDIO_DOCK_RECORD_UI && this.uploadBlock$el && this.uploadBlock$el.length) {
    const uploadBlockEl = this.uploadBlock$el.get(0);
    uploadBlockEl.style.setProperty("width", "100%", "important");
    uploadBlockEl.style.setProperty("height", "auto", "important");
    uploadBlockEl.style.setProperty("max-width", "none", "important");
    uploadBlockEl.style.setProperty("max-height", "none", "important");
    uploadBlockEl.style.setProperty("margin-top", "0px", "important");
    uploadBlockEl.style.setProperty("margin-bottom", "0px", "important");
    uploadBlockEl.style.setProperty("padding", "0 20px 24px", "important");
    uploadBlockEl.style.setProperty("align-self", "stretch", "important");
    uploadBlockEl.style.setProperty("flex", "1 1 auto", "important");
}
this.trigger("setFileUploadMode");
this._setCreationMode(CREATION_MODE.FROM_FILE);
this._onWindowSizeChanged();
this._enableNextButtonIfApplicable();
if (STUDIO_DOCK_RECORD_UI) { this._syncStudioDockModePill("upload"); }

},

_setCreationMode: function(creationMode){
this._creationMode = creationMode;
this.$el.attr("creationMode", this._creationMode);
},


_showRecordSection : function(){
this.showRecordSectionButton$el.hide();
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_UPLOAD_AUDIO_FILE_IN_PAGE_HEADER){
this.showUploadSectionButton$el.show();
}else{
this.showUploadSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
this.showTextToSpeechSectionButton$el.show();
}else{
this.showTextToSpeechSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
this.showVoiceActorNarrationSectionButton$el.show();
}else{
this.showVoiceActorNarrationSectionButton$el.hide();
}
this.uploadBlock$el.hide();
this.textToSpeechBlock$el.hide();
this.useVoiceActorBlock$el.hide();
if (STUDIO_DOCK_RECORD_UI) {
    this.recordingBlock$el.css("display", "flex");
} else {
    this.recordingBlock$el.show();
}
if (STUDIO_DOCK_RECORD_UI) {
    this.recordingBlock$el.removeClass("upload-mode-shell");
    this.$el.find("#recordingBlock .shell").removeClass("upload-mode");
}
if(this.getRecordingMediaType() === "video"){
    this.recordingPreviewContainer$el.show();
}
if(window.waitForCordovaToLoad){
this.showRecordingSettingsButton$el.hide();
}else{
this.showRecordingSettingsButton$el.css("display","inline-flex");
}
this._onVoiceActorNarrationUnselected();
this.trigger("setRecordMode");
this._setCreationMode(CREATION_MODE.FROM_RECORDING);
this._onWindowSizeChanged();
this._enableNextButtonIfApplicable();
if (STUDIO_DOCK_RECORD_UI) { this._syncStudioDockModePill("record"); }

},

_showTextToSpeechSection : function(){
if(IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
this.showTextToSpeechSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_RECORD_AUDIO_IN_PAGE_HEADER){
this.showRecordSectionButton$el.show();
this.$el.find(".orrecordsection").hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES ){
this.showUploadSectionButton$el.show();
}else{
this.showUploadSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
this.showVoiceActorNarrationSectionButton$el.show();
}else{
this.showVoiceActorNarrationSectionButton$el.hide();
}
this.uploadBlock$el.hide();
this.showRecordingSettingsButton$el.hide();
this.recordingBlock$el.hide();
this.useVoiceActorBlock$el.hide();
this.textToSpeechBlock$el.show();
this._onVoiceActorNarrationUnselected();
this.trigger("setFromTextMode");
this._setCreationMode(CREATION_MODE.FROM_TEXT);
this._onWindowSizeChanged();
this._enableNextButtonIfApplicable();

},

_showUseVoiceActorSection : function(){
if(IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
this.showVoiceActorNarrationSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_RECORD_AUDIO_IN_PAGE_HEADER){
this.showRecordSectionButton$el.show();
this.$el.find(".orrecordsection").hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES ){
this.showUploadSectionButton$el.show();
}else{
this.showUploadSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
this.showTextToSpeechSectionButton$el.show();
}else{
this.showTextToSpeechSectionButton$el.hide();
}

this.uploadBlock$el.hide();
this.recordingBlock$el.hide();
this.showRecordingSettingsButton$el.hide();
this.textToSpeechBlock$el.hide();
this.useVoiceActorBlock$el.show();
this._onVoiceActorNarrationSelected();
this.onTextToNarrateFieldChange();
this.trigger("setFromVoiceActor");
this._setCreationMode(CREATION_MODE.FROM_VOICE_ACTOR);
this._onWindowSizeChanged();
this._enableNextButtonIfApplicable();

},

setInCreationFromTranscriptMode : function(){
this._showCreatedFromTranscriptionSection();
this.onNextButtonClicked(true)
},

_showCreatedFromTranscriptionSection : function(){
this.showUploadSectionButton$el.hide();
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_RECORD_AUDIO_IN_PAGE_HEADER){
this.showRecordSectionButton$el.show();
this.$el.find(".orrecordsection").hide();
}else{
this.showRecordSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
this.showTextToSpeechSectionButton$el.show();
}else{
this.showTextToSpeechSectionButton$el.hide();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
this.showVoiceActorNarrationSectionButton$el.show();
}else{
this.showVoiceActorNarrationSectionButton$el.hide();
}
this.recordingBlock$el.hide();
this.showRecordingSettingsButton$el.hide();
this.textToSpeechBlock$el.hide();
this.useVoiceActorBlock$el.hide();
this._setCreationMode(CREATION_MODE.FROM_TRANSCRIPT);
this._onWindowSizeChanged();
this._enableNextButtonIfApplicable();
},



getLifeSpan: function() {
return this.$el.find("#capsuleLifeSpanFld option:selected").val();
},

getCategoryId: function() {
return this.$el.find("#categoryFld option:selected").val();
},

getTimezone: function() {
return this.$el.find("#schedulingTimezoneFld option:selected").val();
},

getPublishedSetting : function(){
return this.$el.find("#publishingSettingFld option:selected").val();
},

getScheduleStartDate : function(){
if(this._capsuleSchedulingAvailable && this.isScheduled()){
const dateString = this.schedulingSettingFld$el.val();
const dateStringSubmitFormat =  this.$el.find("input[name=schedulingSettingFld_submit]").val();
const timeString = this.schedulingTimeFld$el.val();
//return dateString ? new Date(dateString): dateString;
//return dateString ? momentTimezone(dateString + " "+ timeString,"D MMM, YYYY HH:mm", this.getTimezone()).toDate(): dateString;
return dateStringSubmitFormat ? momentTimezone(dateStringSubmitFormat + " "+ timeString,"YYYY/MM/DD HH:mm", this.getTimezone()).toDate(): dateStringSubmitFormat;
}else{
return null;
}
},

getCategoryLabel: function() {
return this.$el.find("#categoryFld option:selected").text();
},

getTimezoneLabel: function() {
return this.$el.find("#schedulingTimezoneFld option:selected").text();
},

getComment: function() {
return this.$el.find("#comment").val();
},

getTitle : function(){
return this.$el.find("#titleField").val();

},

getDoNotAddOnAir : function(){
	return !!(this.doNotAddOnAirCheckbox$el && this.doNotAddOnAirCheckbox$el.length && this.doNotAddOnAirCheckbox$el.get(0).checked);
},

onDoNotAddOnAirCheckboxChange : function(){
if(this.getDoNotAddOnAir()){
if(!this.capsuleConfigWrapper$el.hasClass("isHidden")){
    this.capsuleConfigWrapper$el.addClass("isHidden");
}
if(!this.schedulingTimezoneWrapper$el.hasClass("isHidden")){
    this.schedulingTimezoneWrapper$el.addClass("isHidden");
}
if(!this.scheduleInfoWrapper$el.hasClass("isHidden")){
    this.scheduleInfoWrapper$el.addClass("isHidden");
}
if(this._capsuleSchedulingAvailable){
    if(!this.publishingSettingWrapper$el.hasClass("isHidden")){
        this.publishingSettingWrapper$el.addClass("isHidden");
    }
    if(!this.schedulingTimeWrapper$el.hasClass("isHidden")){
        this.schedulingTimeWrapper$el.addClass("isHidden");
    }

}
}else{
this.capsuleConfigWrapper$el.removeClass("isHidden");
this.schedulingTimezoneWrapper$el.removeClass("isHidden");
this.scheduleInfoWrapper$el.removeClass("isHidden");
if(this._capsuleSchedulingAvailable){
    this.publishingSettingWrapper$el.removeClass("isHidden");
    this.schedulingTimeWrapper$el.removeClass("isHidden");
}
}
},


isPrivate : function(){
return this.$el.find("#privacySettingFld").val() == "private";
},

isInRecordMode :function(){
return this._creationMode == CREATION_MODE.FROM_RECORDING;
},

isInUploadMode :function(){
return this._creationMode == CREATION_MODE.FROM_FILE;
},

isInTTSMode :function(){
return this._creationMode == CREATION_MODE.FROM_TEXT;
},

isInVoiceActorMode :function(){
return this._creationMode == CREATION_MODE.FROM_VOICE_ACTOR;
},

isInCreateFromTranscriptMode : function(){
return this._creationMode == CREATION_MODE.FROM_TRANSCRIPT;
},



_enableNextButtonIfApplicable: function(forceDisable) {
this._nextButtonEnable = false;
if(forceDisable){
this._nextButtonEnable = false;
this.$el.find("#nextButton").addClass("trebble_disabled");
this.$el.find("#playButton").addClass("trebble_disabled");
this.$el.find("#deleteButton").addClass("trebble_disabled");
this.showUploadSectionButton$el.addClass("trebble_disabled");
this.showTextToSpeechSectionButton$el.addClass("trebble_disabled");
this.showVoiceActorNarrationSectionButton$el.addClass("trebble_disabled");
return;
}else{
const deleteBtn$el = this.$el.find("#deleteButton");
if(this._completedRecordedSnippetArray.length > 0){

    deleteBtn$el.removeClass("trebble_disabled");

}else{
  if(!deleteBtn$el.hasClass("trebble_disabled")){
    deleteBtn$el.addClass("trebble_disabled");
}
}
this.showUploadSectionButton$el.removeClass("trebble_disabled");
this.showTextToSpeechSectionButton$el.removeClass("trebble_disabled");
this.showVoiceActorNarrationSectionButton$el.removeClass("trebble_disabled");
if(this._canSaveOnlyAfterTranscriptionAndEditing  && this.isTranscriptionAndEditAudioScreenDisplayed() && !this.isAudioWasTranscribedAndEdited()){
 this._nextButtonEnable = false;
this.$el.find("#nextButton").addClass("trebble_disabled");
this.$el.find("#playButton").addClass("trebble_disabled");
return;
}

if(this.wasAudioContentCreated()  && !this._uploadingViewInCapsuleInfoDisplayed && !this._uploadingViewInAudioEditorDisplayed){
this._nextButtonEnable = true;
this.$el.find("#nextButton").removeClass("trebble_disabled");
this.$el.find("#playButton").removeClass("trebble_disabled");
} else {
this._nextButtonEnable = false;
this.$el.find("#nextButton").addClass("trebble_disabled");
this.$el.find("#playButton").addClass("trebble_disabled");
}

}
},

_enableDoneRecordingBtnIfApplicable: function(){
    if(this._recordOnly){
        if(this.wasAudioContentCreated()){
            this.doneRecordingButton$el.removeClass("trebble_disabled");
        }else{
            this.doneRecordingButton$el.addClass("trebble_disabled");
        }
    }
},

_getRecordingDraftStatusLabel: function(status) {
    if(!status){
        return window.getI18n(ti18n, "DRAFT_STATUS_RECOVERABLE");
    }

    const statusLabelByStatus = {
        [RECORDING_DRAFT_STATUSES.STOPPED_READY_TO_UPLOAD]: window.getI18n(ti18n, "DRAFT_STATUS_READY_TO_UPLOAD"),
        [RECORDING_DRAFT_STATUSES.UPLOADING]: window.getI18n(ti18n, "DRAFT_STATUS_UPLOADING"),
        [RECORDING_DRAFT_STATUSES.UPLOADED_UNREGISTERED]: window.getI18n(ti18n, "DRAFT_STATUS_UPLOADED"),
        [RECORDING_DRAFT_STATUSES.REGISTERED_UNTRANSCRIBED]: window.getI18n(ti18n, "DRAFT_STATUS_READY_TO_TRANSCRIBE"),
        [RECORDING_DRAFT_STATUSES.TRANSCRIBING]: window.getI18n(ti18n, "DRAFT_STATUS_TRANSCRIBING"),
        [RECORDING_DRAFT_STATUSES.FAILED_RECOVERABLE]: window.getI18n(ti18n, "DRAFT_STATUS_NEEDS_ATTENTION"),
    };

    if(statusLabelByStatus[status]){
        return statusLabelByStatus[status];
    }

    return status.replace(/_/g, " ");
},

_formatRecordingDraftUpdatedAt: function(updatedAt) {
    if(!updatedAt){
        return window.getI18n(ti18n, "DRAFT_UPDATED_JUST_NOW");
    }

    const updatedDate = new Date(updatedAt);
    if(isNaN(updatedDate.getTime())){
        return window.getI18n(ti18n, "DRAFT_UPDATED_JUST_NOW");
    }

    return window.getI18n(ti18n, "DRAFT_UPDATED_AT").replace("{date}", updatedDate.toLocaleString());
},

_renderRecordingDraftRecoveryPanel: function() {
    const recoveryItems = this._recordingDraftRecoveryItems || [];
    const hasItems = recoveryItems.length > 0;
    const shouldShow = !!(this._recoveryMode || hasItems);
    const shouldUseInlineRecoveryPanel = !STUDIO_DOCK_RECORD_UI && this.recordingDraftRecoveryPanel$el && this.recordingDraftRecoveryPanel$el.length;
    const shouldShowInlineRecoveryPanel = shouldUseInlineRecoveryPanel && shouldShow && this._inlineDraftRecoveryPanelOpen !== false;

    if(shouldUseInlineRecoveryPanel){
        this.recordingDraftRecoveryPanel$el.css("display", shouldShowInlineRecoveryPanel ? "block" : "none");
        if(this.recordingDraftRecoveryList$el && this.recordingDraftRecoveryList$el.length){
            this.recordingDraftRecoveryList$el.empty();
        }
        if(this.recordingDraftRecoveryEmptyState$el && this.recordingDraftRecoveryEmptyState$el.length){
            this.recordingDraftRecoveryEmptyState$el.css("display", shouldShowInlineRecoveryPanel && !hasItems ? "" : "none");
        }
    }

    // Keep draft recovery controls in the recording/upload stage. The editor has
    // its own save state and header actions.
    const shouldShowHeaderPill = shouldShow
        && this.isRecordingScreenDisplayed()
        && !this._opensProjectInEditor
        && (this.isInRecordMode() || this.isInUploadMode());

    // Update the header pill
    if(this.draftPill$el && this.draftPill$el.length){
        this.draftPill$el.css("display", shouldShowHeaderPill ? "" : "none");
        if(this.draftPillCount$el && this.draftPillCount$el.length){
            if(hasItems){
                this.draftPillCount$el.text(recoveryItems.length).css("display", "");
            } else {
                this.draftPillCount$el.text("").css("display", "none");
            }
        }
    }

    // Update the ribbon (show first draft, unless user dismissed it)
    if(this.draftRibbon$el && this.draftRibbon$el.length){
        const showRibbon = shouldShow && !this._draftRibbonDismissed && hasItems;
        this.draftRibbon$el.css("display", showRibbon ? "flex" : "none");
        if(showRibbon){
            const first = recoveryItems[0];
            const fileName = first.fileName || first.recordingId || window.getI18n(ti18n, "DRAFT_DEFAULT_FILE_NAME");
            const statusLabel = this._getRecordingDraftStatusLabel(first.status);
            const updatedAtLabel = this._formatRecordingDraftUpdatedAt(first.updatedAt);
            const durationInSeconds = first.durationMs ? Math.max(Math.round(first.durationMs / 1000), 1) : null;
            const detailParts = [statusLabel, updatedAtLabel];
            if(durationInSeconds){ detailParts.unshift(durationInSeconds + "s"); }

            if(this.draftRibbonFileName$el){ this.draftRibbonFileName$el.text(fileName); }
            if(this.draftRibbonDetail$el){ this.draftRibbonDetail$el.text(detailParts.join(" · ")); }
            if(this.draftRibbonCount$el){ this.draftRibbonCount$el.text(recoveryItems.length).css("display", recoveryItems.length > 1 ? "" : "none"); }
            if(this.draftRibbonRecoverBtn$el){ this.draftRibbonRecoverBtn$el.attr("data-recording-id", first.recordingId || ""); }
        }
    }

    // Populate the drawer list
    if(this.draftDrawerList$el && this.draftDrawerList$el.length){
        this.draftDrawerList$el.empty();
    }

    if(!hasItems){
        if(this.draftDrawerEmptyState$el){ this.draftDrawerEmptyState$el.show(); }
        this._bindRecordingDraftRecoveryActionButtons();
        return;
    }

    if(this.draftDrawerEmptyState$el){ this.draftDrawerEmptyState$el.hide(); }

    recoveryItems.forEach((function(draftManifest) {
        if(!draftManifest || !this.draftDrawerList$el){ return; }

        const recordingId = draftManifest.recordingId || "";
        const fileName = _.escape(draftManifest.fileName || draftManifest.recordingId || "Recorded file");
        const statusLabel = _.escape(this._getRecordingDraftStatusLabel(draftManifest.status));
        const updatedAtLabel = _.escape(this._formatRecordingDraftUpdatedAt(draftManifest.updatedAt));
        const durationInSeconds = draftManifest.durationMs ? Math.max(Math.round(draftManifest.durationMs / 1000), 1) : null;
        const detailParts = [statusLabel, updatedAtLabel];
        if(durationInSeconds){ detailParts.unshift(durationInSeconds + "s"); }

        const itemMarkup = [
            "<div class='draft-drawer-item'>",
                "<div class='draft-drawer-name'>" + fileName + "</div>",
                "<div class='draft-drawer-meta'>" + detailParts.join(" · ") + "</div>",
                "<div class='draft-drawer-actions'>",
                    "<button type='button' class='draft-drawer-btn' data-recording-draft-action='recover' data-recording-id='" + _.escape(recordingId) + "'>" + window.getI18n(ti18n, "RECOVER") + "</button>",
                    "<button type='button' class='draft-drawer-btn draft-drawer-btn-discard' data-recording-draft-action='discard' data-recording-id='" + _.escape(recordingId) + "'>" + window.getI18n(ti18n, "DISCARD") + "</button>",
                "</div>",
            "</div>",
        ].join("");

        this.draftDrawerList$el.append(itemMarkup);
        if(shouldShowInlineRecoveryPanel && this.recordingDraftRecoveryList$el && this.recordingDraftRecoveryList$el.length){
            this.recordingDraftRecoveryList$el.append(itemMarkup);
        }
    }).bind(this));

    this._bindRecordingDraftRecoveryActionButtons();
},

setRecordingDraftRecoveryItems: function(recoveryItems) {
    const nextItems = Array.isArray(recoveryItems) ? recoveryItems.slice() : [];
    const getDraftIdentity = function(draftManifest) {
        return draftManifest ? (draftManifest.recordingId || draftManifest.fileName || "") : "";
    };
    const previousDraftIdentities = (this._recordingDraftRecoveryItems || []).map(getDraftIdentity).join("|");
    const nextDraftIdentities = nextItems.map(getDraftIdentity).join("|");
    if(nextItems.length && nextDraftIdentities !== previousDraftIdentities){
        this._draftRibbonDismissed = false;
    }
    this._recordingDraftRecoveryItems = nextItems;
    this._renderRecordingDraftRecoveryPanel();
},

setRecoveryMode: function(recoveryMode) {
    this._recoveryMode = !!recoveryMode;
    this._inlineDraftRecoveryPanelOpen = this._recoveryMode;
    this._renderRecordingDraftRecoveryPanel();
},

addRecoveredRecordingMedia: function(mediaInfo) {
    if(!mediaInfo){
        return;
    }

    const recoveredMediaType = mediaInfo.isVideo ? "video" : "audio";
    if(this.setRecordingMediaType){
        this.setRecordingMediaType(recoveredMediaType);
    }else{
        this._recordingMediaType = recoveredMediaType;
    }
    this._showRecordSection();

    const lastRecordedSnippet = this._completedRecordedSnippetArray.length > 0 ? this._completedRecordedSnippetArray[this._completedRecordedSnippetArray.length - 1] : null;
    const previousRecordedProgress = lastRecordedSnippet && lastRecordedSnippet.length > 1 ? lastRecordedSnippet[1] : 0;
    const recoveredDurationInMilli = mediaInfo && mediaInfo.duration > 0 ? mediaInfo.duration : 0;
    const recoveredProgressDelta = recoveredDurationInMilli > 0 && this._recordMaxSize > 0 ? recoveredDurationInMilli / this._recordMaxSize : 0;
    const recoveredProgress = Math.min(previousRecordedProgress + recoveredProgressDelta, 1);
    this._completedRecordedSnippetArray.push([previousRecordedProgress, recoveredProgress]);
    this._pendingRecordedSnippet = null;
    this._currentRecordedSnippet = null;
    this._isRecording = false;
    this._isStoppingRecording = false;

    if(this.recordedProgressBar && this.recordedProgressBar.set){
        this.recordedProgressBar.set(recoveredProgress);
    }
    if(this.deleteProgressBar && this.deleteProgressBar.set){
        this.deleteProgressBar.set(recoveredProgress);
    }

    if(mediaInfo.isVideo && this.recordingPreviewContainer$el){
        this.recordingPreviewContainer$el.show();
    }

    this._showPauseRecordingButton(false);
    this._finalizeRecordingUiState();
},

wasAudioContentCreated : function(){
return (this.isInRecordMode() && this._completedRecordedSnippetArray.length > 0) || (this.isInUploadMode() && this._uploadedFileAdded) || (this.isInTTSMode() && !this.isTextToConvertFieldEmpty()) || (this.isInVoiceActorMode () && this.isTextToNarrateFieldValid())  || (this.isAudioWasTranscribedAndEdited());
},

_isAudioRecordedForCapsule : function(){
return this._completedRecordedSnippetArray && this._completedRecordedSnippetArray.length > 0;
},
setAudioWasTranscribedAndEdited : function(audioWasTranscribedAndEdited){
this._audioWasTranscribedAndEdited = audioWasTranscribedAndEdited;
this._enableNextButtonIfApplicable();
},

isAudioWasTranscribedAndEdited : function(){
return this._audioWasTranscribedAndEdited;
},

deleteRecordedAudioConfirm : function(){
const buttonLabels = [window.getI18n(ti18n,"NO"), window.getI18n(ti18n,"YES")];
const confirmCallback = (function(buttonIndex){
if(buttonIndex ==  2){
    this.deleteRecordedAudioAndRecordAgain();
}
}).bind(this);
const message = window.getI18n(ti18n,"ARE_YOU_WANT_TO_DELETE_AND_RERECORD_AGAIN");
const subMessage = "";//window.getI18n(ti18n,"YOUR_TRANSCRIPTION_AND_EDIT_WILL_BE_LOST");
window.showConfirmDialog(message , confirmCallback, window.getI18n(ti18n,"DELETE_CAPSULE"), buttonLabels,null , null, subMessage);
} ,

navigateToPreviousPageAndLooseAudioEditChangesConfirm : function(){
const buttonLabels = [window.getI18n(ti18n,"NO"), window.getI18n(ti18n,"YES")];
const confirmCallback = (function(buttonIndex){
if(buttonIndex ==  2){
    if(this.isInCreateFromTranscriptMode()){
        this.navigateToPreviousPage();
    }else{
        this.trigger("resetTranscriptionAndAudioEdits");
        this.onPreviousButtonClicked(null, true);
    }
}
}).bind(this);
const message = window.getI18n(ti18n,"ARE_YOU_WANT_TO_NAVIGATE_TO_PREVIOUS_SCREEN");
const subMessage = window.getI18n(ti18n,"YOUR_TRANSCRIPTION_AND_EDIT_WILL_BE_LOST");
window.showConfirmDialog(message , confirmCallback, window.getI18n(ti18n,"DELETE_CAPSULE"), buttonLabels,null , null, subMessage);
} ,

confirmUserWantToDeleteExistingRecordingIfApplicable : function(){
if(!this._isAudioRecordedForCapsule()){
return RSVP.Promise.resolve(true);
}else{
return new RSVP.Promise((function(resolve, reject){
    try{
        const buttonLabels = [window.getI18n(ti18n,"NO"), window.getI18n(ti18n,"YES")];
        const confirmCallback = (function(buttonIndex){
            if(buttonIndex ==  2){
                this.deleteRecordedAudio().then(function(){
                    resolve(true);
                }).catch(reject);
            }else{
                resolve(false);
            }
        }).bind(this);
        const message = window.getI18n(ti18n,"ARE_YOU_WANT_TO_DELETE_AND_RERECORD_AGAIN");
        const subMessage = "";//window.getI18n(ti18n,"YOUR_TRANSCRIPTION_AND_EDIT_WILL_BE_LOST");
        window.showConfirmDialog(message , confirmCallback, window.getI18n(ti18n,"DELETE_CAPSULE"), buttonLabels,null , null, subMessage);
    }catch(error){
        reject(error);
    }
}).bind(this))

}
} ,


isScheduled : function(){
return this._capsuleSchedulingAvailable && PUBLISHED_SETTING_VALUES.SCHEDULED === this.getPublishedSetting();
},

_getTheRestOfTheDayCapsuleLifeSpanOption$El : function(){
const optionArray  = this.$el.find("#capsuleLifeSpanFld").children();
for(let i =0; i < optionArray.length; i++){
const option$el = $(optionArray[i]);
const value = option$el.val();
if(value && Utils.getInstance().isFloat(parseFloat(value))){
    //this is most likely the rest of the day option
    return option$el;
}
}
},

_hideShowSchedulingDateFieldIfApplicable : function(){
const theRestOfTheDayOption$el = this._getTheRestOfTheDayCapsuleLifeSpanOption$El();
const theRestOfTheDayOptionIsSelected = theRestOfTheDayOption$el.is(':selected');
if(this.isScheduled()){
theRestOfTheDayOption$el.prop("disabled","disabled");
theRestOfTheDayOption$el.removeAttr("selected");
this.$el.find("#capsuleLifeSpanFld").selectmenu('refresh');
this.schedulingSettingWrapper$el.show();
this.schedulingTimeWrapper$el.show();
this.schedulingTimezoneWrapper$el.show();
this.capsuleConfigWrapper$el.insertAfter(this.scheduleInfoWrapper$el);
}else{
theRestOfTheDayOption$el.removeAttr("disabled");
this.schedulingSettingWrapper$el.hide();
this.schedulingTimeWrapper$el.hide();
if(theRestOfTheDayOptionIsSelected){
    this.capsuleConfigWrapper$el.prependTo(this.scheduleInfoWrapper$el);
    this.schedulingTimezoneWrapper$el.show();
}else{
    this.capsuleConfigWrapper$el.insertAfter(this.scheduleInfoWrapper$el);
    this.schedulingTimezoneWrapper$el.hide();
}
}
},

deleteRecordedAudio : function(){
if(DELETE_PREVIOUS_RECORDING_WITHOUT_CONFIRMATION){
return this._executeDeleteRecordingOperationWithoutHighlightingWhatWillBeDeleted();
}else{
this._onDeleteBtnClicked();
return this._onDeleteBtnClicked();
}
},

deleteRecordedAudioAndRecordAgain : function(){
return this.deleteRecordedAudio().then((function(){
this._startRecording();
}).bind(this));

},

_requestRecordedAudioDeletion: function(){
return new RSVP.Promise((function(resolve, reject){
    try{
        this.trigger("deleteRecording", this._getLastCompletedRecordingCounter(), function(error){
            if(error){
                reject(error);
                return;
            }
            resolve();
        });
    }catch(error){
        reject(error);
    }
}).bind(this));
},

_executeDeleteRecordingOperationWithoutHighlightingWhatWillBeDeleted: function(){
//trigger delete record action on model
const deletePromise = this._requestRecordedAudioDeletion();
//delete recorded file info in completed this._completedRecordedSnippetArray.pop();
this._completedRecordedSnippetArray.pop();
const numberOfSnippets = this._completedRecordedSnippetArray.length;
let lastRecordedPostion = 0;
if (numberOfSnippets > 0) {
lastRecordedPostion = this._completedRecordedSnippetArray[numberOfSnippets - 1][1];
}
this.deleteProgressBar.set(lastRecordedPostion);
this.recordedProgressBar.set(lastRecordedPostion);
const iconToChange$el = this.$el.find("#deleteButton > t");
const deleteBtn$el = this.$el.find("#deleteButton");
iconToChange$el.addClass(READY_TO_DELETED_ICON);
iconToChange$el.removeClass(TO_DELETE_ICON);
deleteBtn$el.attr("data-hint",HINT_READY_TO_DELETE_ICON_MESSAGE);

this._switchToDeletionMode(false);
this.isReadyToBedeleted = false;
return deletePromise;
},

_onDeleteBtnClicked: function() {
if (!this.deletionMode) {
this._switchToDeletionMode(true);
}
if(DELETE_PREVIOUS_RECORDING_WITHOUT_CONFIRMATION){

const buttonLabels = [window.getI18n(ti18n,"NO"), window.getI18n(ti18n,"YES")];
const confirmCallback = (function(buttonIndex){
    if(buttonIndex ==  2){
        this._executeDeleteRecordingOperationWithoutHighlightingWhatWillBeDeleted();
    }
}).bind(this);
const message = window.getI18n(ti18n,"ARE_YOU_WANT_TO_DELETE_LAST_AUDIO_SEGMENT");
window.showConfirmDialog(message , confirmCallback, window.getI18n(ti18n,"ARE_YOU_WANT_TO_DELETE_LAST_AUDIO_SEGMENT"), buttonLabels,null , null);

}else{
if (!this.isReadyToBedeleted) {
    this.deleteProgressBar.set(this.recordedProgressBar.value());
    this.deleteProgressBar.svg.display = "block";
    this.isReadyToBedeleted = true;
    const iconToChange$el = this.$el.find("#deleteButton > t");
    const deleteBtn$el = this.$el.find("#deleteButton");
    iconToChange$el.addClass(READY_TO_DELETED_ICON);
    iconToChange$el.removeClass(TO_DELETE_ICON);
    deleteBtn$el.attr("data-hint",HINT_READY_TO_DELETE_ICON_MESSAGE);
    let numberOfSnippets = this._completedRecordedSnippetArray.length;
    let previousRecordedPostion = 0;
    if (numberOfSnippets - 2 >= 0) {
        previousRecordedPostion = this._completedRecordedSnippetArray[numberOfSnippets - 2][1];
    }
    this.recordedProgressBar.set(previousRecordedPostion);
} else {
    //trigger delete record action on model
    const deletePromise = this._requestRecordedAudioDeletion();
    //delete recorded file info in completed this._completedRecordedSnippetArray.pop();
    this._completedRecordedSnippetArray.pop();
    let numberOfSnippets = this._completedRecordedSnippetArray.length;
    let lastRecordedPostion = 0;
    if (numberOfSnippets > 0) {
        lastRecordedPostion = this._completedRecordedSnippetArray[numberOfSnippets - 1][1];
    }
    this.deleteProgressBar.set(lastRecordedPostion);
    this.recordedProgressBar.set(lastRecordedPostion);
    const iconToChange$el = this.$el.find("#deleteButton > t");
    const deleteBtn$el = this.$el.find("#deleteButton");
    iconToChange$el.addClass(TO_DELETE_ICON);
    iconToChange$el.removeClass(READY_TO_DELETED_ICON);
    deleteBtn$el.attr("data-hint",HINT_DELETE_ICON_MESSAGE);
    this._switchToDeletionMode(false);
    this.isReadyToBedeleted = false;
    this._enableNextButtonIfApplicable();
    this._enableDoneRecordingBtnIfApplicable();
    return deletePromise;
}
}
this._enableNextButtonIfApplicable();
this._enableDoneRecordingBtnIfApplicable();
return RSVP.Promise.resolve();
},


_onPageShow: function() {
if(this._backgroundTrackSwiperObj){
this._backgroundTrackSwiperObj.update();
}
this._hideTrackContainer();
if(!this._isRecording && this._hasContentRecorded()){
if(this._canBackgroundMusicUsed()){
//disable background track on mobile for now
this._showTrackContainer();
}
}
},


_canBackgroundMusicUsed : function(){
return (window.waitForCordovaToLoad && ALLOW_CHOOSING_MUSIC_ON_MOBILE_APP) || (!window.isMobileBrowser || window.trebble.allowCreatingCapsuleWithBackgroundMusic)
},

_onPageChange : function(){
this.$el.find("#comment").trigger("autoresize");
},

_cancelSnippetDeletion: function() {
const wasInDeletionMode = this.deletionMode;
this._switchToDeletionMode(false);
if (wasInDeletionMode) {
const numberOfSnippets = this._completedRecordedSnippetArray.length;
let lastRecordedPostion = 0;
if (numberOfSnippets > 0) {
    lastRecordedPostion = this._completedRecordedSnippetArray[numberOfSnippets - 1][1];
}
this.deleteProgressBar.set(lastRecordedPostion);
this.recordedProgressBar.set(lastRecordedPostion);
}
const iconToChange$el = this.$el.find("#deleteButton > t");
const deleteBtn$el = this.$el.find("#deleteButton");
if(DELETE_PREVIOUS_RECORDING_WITHOUT_CONFIRMATION){

iconToChange$el.addClass(READY_TO_DELETED_ICON);
iconToChange$el.removeClass(TO_DELETE_ICON);
deleteBtn$el.attr("data-hint",HINT_READY_TO_DELETE_ICON_MESSAGE);
}else{
iconToChange$el.addClass(TO_DELETE_ICON);
iconToChange$el.removeClass(READY_TO_DELETED_ICON);
deleteBtn$el.attr("data-hint",HINT_DELETE_ICON_MESSAGE);
}
if(this._completedRecordedSnippetArray.length > 0){

deleteBtn$el.removeClass("trebble_disabled");

}else{
if(!deleteBtn$el.hasClass("trebble_disabled")){
deleteBtn$el.addClass("trebble_disabled");
}
}
},

_switchToDeletionMode: function(on) {
if (on) {
this.deletionMode = true;
this.deleteProgressBar.svg.display = "block";
} else {
this.deletionMode = false;
this.deleteProgressBar.svg.display = "none";
this.isReadyToBedeleted = false;
}
},

onNextButtonClicked: function(force) {
if(this.isTranscriptionAndEditAudioScreenDisplayed() && this.isAudioWasTranscribedAndEdited()){
this.trigger("navigatingToNextPageAFterAudioEditorPage");
}
if(this.isRecordingScreenDisplayed() && this._canSaveOnlyAfterTranscriptionAndEditing){
this.showTranscriptionParameters();
}
if(this._currentCarouselPositon +1 < this._numberOfCarouselItems){
//if(this._recordMode){
if (force || (this._nextButtonEnable && this.carousel$el)) {
const carouselData = this.carousel$el.data('owlCarousel');
if(this.isInTTSMode()){
    this._currentCarouselPositon = this._currentCarouselPositon +2;
    carouselData.goTo(this._currentCarouselPositon)
}else{
    this._currentCarouselPositon  = this._currentCarouselPositon +1;

    carouselData.next();
}
this._updateHeaderButtons();

}
this.$el.find("#comment").trigger("autoresize");
this._onCapsuleInfoEdited();
/*}else{
if (this._nextButtonEnable && this.carousel$el) {
    this._currentCarouselPositon  = this._currentCarouselPositon +2;
    const carouselData = this.carousel$el.data('owlCarousel');
    carouselData.goTo(this._currentCarouselPositon);
    this._updateHeaderButtons();

}
}*/
}
},

_onCapsuleInfoEdited : function(){
if(!this.canSaveChanges()){
if(!this.saveButton$el.hasClass("trebble_disabled")){
    this.saveButton$el.addClass("trebble_disabled");
}
return;
}
const titleValid  = this.getTitle() && this.getTitle().trim();
const publishingSettingValid = !(!this.getDoNotAddOnAir() && this.isScheduled() && !this.getScheduleStartDate());
if(titleValid && publishingSettingValid){
this.saveButton$el.removeClass("trebble_disabled");
}else{
if(!this.saveButton$el.hasClass("trebble_disabled")){
    this.saveButton$el.addClass("trebble_disabled");
}
}
},

setSaveAccess : function(canSaveChanges){
this._canSaveChanges = canSaveChanges !== false;
if(this.saveButton$el){
    this._onCapsuleInfoEdited();
}
if(this.showRecordingSettingsButton$el && this.doneRecordingButton$el){
    this._updateHeaderButtons();
}else if(this.$el && !this.canSaveChanges()){
    this.$el.find("#nextButton").hide();
}
},

canSaveChanges : function(){
return this._canSaveChanges !== false;
},

_canShowNextButton : function(){
return !this._recordOnly && this.canSaveChanges();
},

getTimeLeftForTheRestOfTheDayBasedOnTimezone :function(){
const trebbleDefaultTimezone  = this.getTimezone();
const nextMidnightDate = momentTimezone(trebbleDefaultTimezone).set("hour",0).set("minute",0).set("second",0).add(1, "days").toDate();
const aDayInMilliseconds = 24 *60 *60 * 1000;
const timeInDaysUntilTheEndOfTheDay = (nextMidnightDate.getTime() - (new Date()).getTime())/aDayInMilliseconds;
return timeInDaysUntilTheEndOfTheDay;
},


_onTimezoneEdited : function(){
const timezone = this.getTimezone();
const theRestOfTheDayOption$el = this._getTheRestOfTheDayCapsuleLifeSpanOption$El();
theRestOfTheDayOption$el.val(this.getTimeLeftForTheRestOfTheDayBasedOnTimezone());

},


_updateHeaderButtons : function(){
if(this._currentCarouselPositon +1 == this._numberOfCarouselItems){
this.$el.find("#nextButton").hide();
this.showUploadSectionButton$el.hide();
this.showRecordSectionButton$el.hide();
this.showTextToSpeechSectionButton$el.hide();
this.showVoiceActorNarrationSectionButton$el.hide();
this.$el.find("#saveButtonIcon").show();
this.doneRecordingButton$el.hide();
this.showRecordingSettingsButton$el.hide();
}else{
if(this._currentCarouselPositon != 0 || window.waitForCordovaToLoad || !this.isInRecordMode()){
this.showRecordingSettingsButton$el.hide();
}else{
this.showRecordingSettingsButton$el.css("display","inline-flex");
}
if(this._canShowNextButton()){
    this.$el.find("#nextButton").css("display","inline-flex");
}else{
    this.$el.find("#nextButton").hide();
}
if(this.isInRecordMode()){
this.showRecordSectionButton$el.hide();
if(this._recordOnly){
    this.doneRecordingButton$el.css("display","inline-flex");
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_UPLOAD_AUDIO_FILE_IN_PAGE_HEADER){
    this.showUploadSectionButton$el.show();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
    this.showTextToSpeechSectionButton$el.show();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
    this.showVoiceActorNarrationSectionButton$el.show();
}
}
if(this.isTranscriptionAndEditAudioScreenDisplayed()){
    setTimeout(()=>{
        this.showSaveOrEditOnboardingInstruction();
    }, 500)
}
if(this.isInUploadMode()){
this.showUploadSectionButton$el.hide();
this.$el.find(".orrecordsection").hide();
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_RECORD_AUDIO_IN_PAGE_HEADER){
    this.showRecordSectionButton$el.show();

}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_TEXT_AVAILABLE){
    this.showTextToSpeechSectionButton$el.show();
}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && IS_CAPSULE_CREATION_VIA_VOICE_ACTOR){
    this.showVoiceActorNarrationSectionButton$el.show();
}
}
if(this.isInTTSMode()){
this.showTextToSpeechSectionButton$el.hide();
this.showVoiceActorNarrationSectionButton$el.hide();
this.$el.find(".orrecordsection").hide();
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_RECORD_AUDIO_IN_PAGE_HEADER){
    this.showRecordSectionButton$el.show();

}
if(!DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES && !DO_NOT_SHOW_UPLOAD_AUDIO_FILE_IN_PAGE_HEADER){
    this.showUploadSectionButton$el.show();
}

}
if(this.isTranscriptionAndEditAudioScreenDisplayed() && !this.isSequencerNodeWrapperDisplayed()){
this.$el.find("#nextButton").hide();
}
this.$el.find("#saveButtonIcon").hide();
//if(this.isTranscriptionAndEditAudioScreenDisplayed()){
this._enableNextButtonIfApplicable();
this._enableDoneRecordingBtnIfApplicable();
// }
}
if(this._currentCarouselPositon > 0){
this.$el.find("#previousButton").show();
this.hideBackButton();
}else{
this.$el.find("#previousButton").hide();
this.showBackButton();
}
},



hideBackButton : function(){
this.headerBackButton$el.hide();
},

showBackButton : function(){
if(this._shouldWarnBeforeUnload() || this._currentCarouselPositon > 0){
    this.headerBackButton$el.hide();
}else{
    this.headerBackButton$el.show();
}
},

setSelectedSongView : function(songSelectedView){
if(this._songSelectedView){
this._songSelectedView.$el.remove();
}
this._songSelectedView = songSelectedView;
if(this._songSelectedView){
this.$el.find("#selectedSongInfoPreview").append(this._songSelectedView.$el);
this.$el.find("#noSongSelectedInfoBox").hide();
}else{
this.$el.find("#noSongSelectedInfoBox").show();
}
},

isTranscriptionAndEditAudioScreenDisplayed : function(){
return this._currentCarouselPositon == 1 && TREBBLE_TEXT_BASED_AUDIO_EDITOR;
},

isRecordingScreenDisplayed : function(){
return this._currentCarouselPositon == 0;
},

isShortcastInfoScreenDisplayedDisplayed : function(){
return (this._currentCarouselPositon == 2 && TREBBLE_TEXT_BASED_AUDIO_EDITOR) ||(this._currentCarouselPositon == 1 && !TREBBLE_TEXT_BASED_AUDIO_EDITOR)
},


onPreviousButtonClicked: function(event, force) {
if(this._currentCarouselPositon > 0){
if(this.isTranscriptionAndEditAudioScreenDisplayed() && this.isAudioWasTranscribedAndEdited() && !force){
   return this.navigateToPreviousPageAndLooseAudioEditChangesConfirm();
}
if(this._recordMode){
this._currentCarouselPositon  = this._currentCarouselPositon -1;
if (this.carousel$el) {
    let carouselData = this.carousel$el.data('owlCarousel');
    carouselData.prev();
    this._updateHeaderButtons();
}
}else{
if(this.isInTTSMode()){
this._currentCarouselPositon = this._currentCarouselPositon - 2;
}else{
this._currentCarouselPositon  = this._currentCarouselPositon - 1;
}
if (this.carousel$el) {
let carouselData = this.carousel$el.data('owlCarousel');
carouselData.goTo(this._currentCarouselPositon);
this._updateHeaderButtons();

}
}
}
},

_initCommentBox: function() {
const users = [];
if (this._followersUsersInfo) {
for (const index in this._followersUsersInfo) {
    const userInfo = this._followersUsersInfo[index];
    users.push({"username": userInfo.username});
}
}
const params = {};
params.delimiter = "@";
params.users = users;
const comment$el = this.$el.find("#comment");
if(comment$el.mention){
//mention was initialized
comment$el.mention(params);
}
this.$el.find(".commentForm").on("submit", this._onFormSubmit.bind(this));
},

_onFormSubmit: function() {
return false;
},

_playStopPlayingRecording: function() {
if (this._isPlaying) {
this.trigger("stopPlayingRecordings");
} else {
this.trigger("playRecordings");
}
},

_saveRecording: function() {
this.trigger("saveRecording");
},

onDoneRecordingButtonClicked: function() {
    this.trigger("recordingCompleted");
},

_showRecordingSettings: function() {
if(this._isRecordingFlowBusy() || (this.showRecordingSettingsButton$el && this.showRecordingSettingsButton$el.hasClass("trebble_disabled"))){
    return;
}
if(STUDIO_DOCK_RECORD_UI){
    this._toggleStudioDockSettingsDrawer();
    return;
}
this.trigger("showRecordingSettings");
},

_onStudioDockModePillRecordClicked: function() {
    if(!STUDIO_DOCK_RECORD_UI){ return; }
    this._showRecordSection();
    this._syncStudioDockModePill("record");
},

_onStudioDockModePillUploadClicked: function() {
    if(!STUDIO_DOCK_RECORD_UI){ return; }
    this._showUploadSection();
    this._syncStudioDockModePill("upload");
},

_syncStudioDockModePill: function(activeMode) {
    if(!STUDIO_DOCK_RECORD_UI || !this.$el){ return; }
    const recordBtn$el = this.$el.find("#studioDockShowRecordBtn");
    const uploadBtn$el = this.$el.find("#studioDockShowUploadBtn");
    if(!recordBtn$el.length || !uploadBtn$el.length){ return; }
    const isRecord = activeMode === "record";
    recordBtn$el.toggleClass("is-active", isRecord).attr("aria-selected", isRecord ? "true" : "false");
    uploadBtn$el.toggleClass("is-active", !isRecord).attr("aria-selected", !isRecord ? "true" : "false");
},

_getStudioDockOpenPanelName: function() {
    if(!STUDIO_DOCK_RECORD_UI || !this.$el){
        return null;
    }
    const shell$el = this.$el.find("#recordingBlock .shell");
    if(!shell$el.length){
        return null;
    }
    if(shell$el.hasClass("settings-open")){
        return "settings";
    }
    if(shell$el.hasClass("notes-open")){
        return "notes";
    }
    if(shell$el.hasClass("drafts-open")){
        return "drafts";
    }
    return null;
},

_syncStudioDockPanelButtons: function() {
    if(!STUDIO_DOCK_RECORD_UI || !this.$el){
        return;
    }

    const activePanelName = this._getStudioDockOpenPanelName();
    const notesBtn$el = this.$el.find("#studioDockNotesToggle");
    const settingsBtn$el = this.$el.find("#studioDockSettingsBtn");

    if(notesBtn$el.length){
        const isNotesOpen = activePanelName === "notes";
        notesBtn$el.toggleClass("is-active", isNotesOpen).attr("aria-pressed", isNotesOpen ? "true" : "false");
    }

    if(settingsBtn$el.length){
        const isSettingsOpen = activePanelName === "settings";
        settingsBtn$el.toggleClass("is-active", isSettingsOpen).attr("aria-pressed", isSettingsOpen ? "true" : "false");
    }
},

_getStudioDockNotesDrawer$el: function() {
    if(this.noteSection$el && this.noteSection$el.length){
        return this.noteSection$el;
    }
    return $("#noteSection.drawer").first();
},

_getStudioDockSettingsDrawer$el: function() {
    if(this.studioDockDrawer$el && this.studioDockDrawer$el.length){
        return this.studioDockDrawer$el;
    }
    return $("#studioDockDrawer.drawer").first();
},

_cacheStudioDockDrawerElements: function() {
    const settingsDrawerRoot$el = this._getStudioDockSettingsDrawer$el();

    this.studioDockDrawer$el = settingsDrawerRoot$el;
    this.studioDockDrawerMicrophoneFld$el = settingsDrawerRoot$el.find("#studioDockDrawerMicrophoneFld");
    this.studioDockDrawerCameraFld$el = settingsDrawerRoot$el.find("#studioDockDrawerCameraFld");
    this.studioDockDrawerSpeakerFld$el = settingsDrawerRoot$el.find("#studioDockDrawerSpeakerFld");
    this.studioDockDrawerResolutionFld$el = settingsDrawerRoot$el.find("#studioDockDrawerResolutionFld");
    this.studioDockDrawerCameraField$el = settingsDrawerRoot$el.find("#studioDockDrawerCameraField");
    this.studioDockDrawerSpeakerField$el = settingsDrawerRoot$el.find("#studioDockDrawerSpeakerField");
    this.studioDockDrawerResolutionField$el = settingsDrawerRoot$el.find("#studioDockDrawerResolutionField");
    this.studioDockDrawerEchoToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerEchoToggle");
    this.studioDockDrawerNoiseToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerNoiseToggle");
    this.studioDockDrawerAutoGainToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerAutoGainToggle");
    this.studioDockDrawerCountdownToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerCountdownToggle");
    this.studioDockDrawerGridToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerGridToggle");
    this.studioDockDrawerGridToggleRow$el = this.studioDockDrawerGridToggle$el.closest(".studio-dock-setting-toggle");
    this.studioDockDrawerScreenNote$el = settingsDrawerRoot$el.find(".studio-dock-setting-note");
    this.studioDockSettingsButton$el = this.$el ? this.$el.find("#studioDockSettingsBtn") : $();
},

_mountStudioDockDrawersToBody: function() {
    if(!STUDIO_DOCK_RECORD_UI){
        return;
    }

    if(typeof document !== "undefined" && document.documentElement && document.documentElement.classList){
        document.documentElement.classList.add("studio-dock-floating-drawer-mounted");
    }

    const mountDrawerToBody = function(drawer$el) {
        if(!drawer$el || !drawer$el.length){
            return;
        }

        const drawerEl = drawer$el.get(0);
        if(drawerEl && drawerEl.parentElement !== document.body){
            drawer$el.detach().appendTo(document.body);
        }
    };

    mountDrawerToBody(this._getStudioDockNotesDrawer$el());
    mountDrawerToBody(this._getStudioDockSettingsDrawer$el());
    mountDrawerToBody(this.draftDrawer$el || this.$el.find("#draftDrawer").first());
    this._cacheStudioDockDrawerElements();
},

_applyStudioDockDrawerRootStyles: function() {
    if(!STUDIO_DOCK_RECORD_UI){
        return;
    }

    const pageEl = this.$el && this.$el.length ? this.$el.get(0) : null;
    const pageStyles = pageEl ? window.getComputedStyle(pageEl) : null;
    const recordingBlockEl = this.recordingBlock$el && this.recordingBlock$el.length ? this.recordingBlock$el.get(0) : null;
    const hasVisibleRecordingBlock = !!(
        recordingBlockEl &&
        recordingBlockEl.getClientRects &&
        recordingBlockEl.getClientRects().length &&
        recordingBlockEl.offsetHeight > 0
    );
    const boundsSourceEl = hasVisibleRecordingBlock ? recordingBlockEl : pageEl;
    const recordingBlockRect = boundsSourceEl && boundsSourceEl.getBoundingClientRect ? boundsSourceEl.getBoundingClientRect() : null;
    const drawerTopPx = recordingBlockRect ? Math.max(Math.round(recordingBlockRect.top), 0) : 56;
    const drawerBottomPx = recordingBlockRect && typeof window !== "undefined" ? Math.max(Math.round(window.innerHeight - recordingBlockRect.bottom), 0) : 0;
    const themeVariables = {};
    [
        "--sd-primary",
        "--sd-primary-dark",
        "--sd-primary-15",
        "--sd-primary-08",
        "--sd-ink",
        "--sd-ink-60",
        "--sd-ink-45",
        "--sd-ink-30",
        "--sd-ink-10",
        "--sd-ink-05",
        "--sd-rule",
        "--sd-drawer-rule",
        "--sd-bg",
        "--sd-bg-page",
        "--sd-bg-soft",
        "--sd-segmented-shell",
        "--sd-segmented-text",
        "--sd-segmented-active",
        "--sd-segmented-active-shadow",
        "--sd-meter-audio-shell",
        "--sd-meter-audio-border",
        "--sd-meter-audio-idle",
        "--sd-meter-audio-active"
    ].forEach(function(variableName) {
        if(!pageStyles){
            return;
        }
        const variableValue = pageStyles.getPropertyValue(variableName);
        if(variableValue){
            themeVariables[variableName] = variableValue.trim();
        }
    });

    const drawerBaseStyles = {
        position: "fixed",
        top: "var(--studio-dock-floating-drawer-top, 56px)",
        right: "0",
        bottom: "var(--studio-dock-floating-drawer-bottom, 0px)",
        left: "auto",
        width: "340px",
        maxWidth: "none",
        margin: "0",
        zIndex: "40",
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        background: themeVariables["--sd-bg"] || "#ffffff",
        color: themeVariables["--sd-ink"] || "#121212",
        borderLeft: "1px solid " + (themeVariables["--sd-rule"] || "rgba(18, 18, 18, 0.12)"),
        boxShadow: "-6px 0 18px -14px rgba(18, 18, 18, 0.14)",
        transition: "transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)",
        transform: "translateX(100%)",
        pointerEvents: "none"
    };

    const applyThemeToDrawer = function(drawer$el, drawerName) {
        if(!drawer$el || !drawer$el.length){
            return;
        }

        drawer$el.css(drawerBaseStyles);
        const drawerEl = drawer$el.get(0);
        if(drawerEl && drawerEl.style){
            drawerEl.style.setProperty("--studio-dock-floating-drawer-top", drawerTopPx + "px");
            drawerEl.style.setProperty("--studio-dock-floating-drawer-bottom", drawerBottomPx + "px");
            Object.keys(themeVariables).forEach(function(variableName) {
                drawerEl.style.setProperty(variableName, themeVariables[variableName]);
            });
        }

        drawer$el
            .attr("data-studio-dock-floating-drawer", drawerName)
            .attr("data-studio-dock-theme", themeName);
    };

    const notesDrawer$el = this._getStudioDockNotesDrawer$el();
    const settingsDrawer$el = this._getStudioDockSettingsDrawer$el();
    const themeName = this._isStudioDockDarkThemeEnabled() ? "dark" : "light";

    applyThemeToDrawer(notesDrawer$el, "notes");
    applyThemeToDrawer(settingsDrawer$el, "settings");
    applyThemeToDrawer(this.draftDrawer$el || this.$el.find("#draftDrawer").first(), "drafts");
},

_bindStudioDockDrawerOutsideHandler: function() {
    if(this._studioDockDrawerOutsideHandlerBound){
        return;
    }
    const self = this;
    this._studioDockDrawerOutsideHandlerBound = true;
    this._studioDockDrawerOutsideHandler = function(e){
        if(!self.$el || !self._getStudioDockOpenPanelName()){
            return;
        }
        const $target = $(e.target);
        if($target.closest("#studioDockDrawer").length){ return; }
        if($target.closest("#noteSection").length){ return; }
        if($target.closest("#draftDrawer").length){ return; }
        if($target.closest("#showRecordingSettingsButton").length){ return; }
        if($target.closest("#studioDockSettingsBtn").length){ return; }
        if($target.closest("#studioDockNotesToggle").length){ return; }
        if($target.closest("#draftPill").length){ return; }
        if($target.closest("[data-recording-draft-action='open-drawer']").length){ return; }
        if($target.closest("#recordControlsWrapper").length){ return; }
        self._closeStudioDockSidePanels();
    };
    $(document).on("click.studioDockDrawer", this._studioDockDrawerOutsideHandler);
},

_unbindStudioDockDrawerOutsideHandler: function() {
    if(!this._studioDockDrawerOutsideHandlerBound){
        return;
    }
    $(document).off("click.studioDockDrawer", this._studioDockDrawerOutsideHandler);
    this._studioDockDrawerOutsideHandlerBound = false;
    this._studioDockDrawerOutsideHandler = null;
},

_bindStudioDockFloatingDrawerHandlers: function() {
    if(this._studioDockFloatingDrawerHandlersBound){
        return;
    }

    this._cacheStudioDockDrawerElements();
    const self = this;
    const handlerRoots$el = this._getStudioDockNotesDrawer$el()
        .add(this._getStudioDockSettingsDrawer$el())
        .add(this.draftDrawer$el);
    const clickTargets$el = handlerRoots$el.find(
        "#studioDockDrawerClose, " +
        "#studioDockNotesDrawerClose, " +
        "#draftDrawerClose, " +
        "#studioDockDrawerEchoToggle, " +
        "#studioDockDrawerNoiseToggle, " +
        "#studioDockDrawerAutoGainToggle, " +
        "#studioDockDrawerCountdownToggle, " +
        "#studioDockDrawerGridToggle"
    );
    const changeTargets$el = handlerRoots$el.find(
        "#studioDockDrawerMicrophoneFld, " +
        "#studioDockDrawerCameraFld, " +
        "#studioDockDrawerSpeakerFld, " +
        "#studioDockDrawerResolutionFld"
    );
    this._studioDockFloatingDrawerHandlersBound = true;
    this._studioDockFloatingHandlerRoots$el = handlerRoots$el;
    this._studioDockFloatingClickSelector = "#studioDockDrawerClose, #studioDockNotesDrawerClose, #draftDrawerClose, #studioDockDrawerEchoToggle, #studioDockDrawerNoiseToggle, #studioDockDrawerAutoGainToggle, #studioDockDrawerCountdownToggle, #studioDockDrawerGridToggle";
    this._studioDockFloatingChangeSelector = "#studioDockDrawerMicrophoneFld, #studioDockDrawerCameraFld, #studioDockDrawerSpeakerFld, #studioDockDrawerResolutionFld";
    this._studioDockFloatingClickDocumentEvent = "click.studioDockFloatingDrawerControls." + this.cid;
    this._studioDockFloatingChangeDocumentEvent = "change.studioDockFloatingDrawerControls." + this.cid;
    this._studioDockFloatingClickTargetEls = clickTargets$el.toArray();
    this._studioDockFloatingChangeTargetEls = changeTargets$el.toArray();

    this._studioDockFloatingDrawerClickHandler = function(e) {
        const targetId = (e.currentTarget && e.currentTarget.id) || (this && this.id) || "";
        if(!targetId){
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        switch(targetId){
        case "studioDockDrawerClose":
        case "studioDockNotesDrawerClose":
            self._onStudioDockDrawerCloseClicked();
            break;
        case "draftDrawerClose":
            self._onDraftDrawerCloseClicked();
            break;
        case "studioDockDrawerEchoToggle":
            self._onStudioDockEchoToggleClicked();
            break;
        case "studioDockDrawerNoiseToggle":
            self._onStudioDockNoiseToggleClicked();
            break;
        case "studioDockDrawerAutoGainToggle":
            self._onStudioDockAutoGainToggleClicked();
            break;
        case "studioDockDrawerCountdownToggle":
            self._onStudioDockCountdownToggleClicked();
            break;
        case "studioDockDrawerGridToggle":
            self._onStudioDockDrawerGridToggleClicked();
            break;
        default:
            break;
        }
    };

    this._studioDockFloatingDrawerChangeHandler = function(e) {
        const targetId = (e.currentTarget && e.currentTarget.id) || (this && this.id) || "";
        if(!targetId){
            return;
        }

        switch(targetId){
        case "studioDockDrawerMicrophoneFld":
            self._onStudioDockDrawerMicrophoneChanged();
            break;
        case "studioDockDrawerCameraFld":
            self._onStudioDockDrawerCameraChanged();
            break;
        case "studioDockDrawerSpeakerFld":
            self._onStudioDockDrawerSpeakerChanged();
            break;
        case "studioDockDrawerResolutionFld":
            self._onStudioDockDrawerResolutionChanged();
            break;
        default:
            break;
        }
    };

    this._studioDockFloatingClickTargetEls.forEach(function(targetEl) {
        targetEl.onclick = self._studioDockFloatingDrawerClickHandler;
    });
    $(document)
        .off(this._studioDockFloatingClickDocumentEvent, this._studioDockFloatingClickSelector, this._studioDockFloatingDrawerClickHandler)
        .on(this._studioDockFloatingClickDocumentEvent, this._studioDockFloatingClickSelector, this._studioDockFloatingDrawerClickHandler);
    this._studioDockFloatingHandlerRoots$el
        .off(this._studioDockFloatingChangeDocumentEvent, this._studioDockFloatingChangeSelector, this._studioDockFloatingDrawerChangeHandler)
        .on(this._studioDockFloatingChangeDocumentEvent, this._studioDockFloatingChangeSelector, this._studioDockFloatingDrawerChangeHandler);
    this._bindRecordingDraftRecoveryActionButtons();
},

_unbindStudioDockFloatingDrawerHandlers: function() {
    if(!this._studioDockFloatingDrawerHandlersBound){
        return;
    }

    this._unbindRecordingDraftRecoveryActionButtons();

    if(this._studioDockFloatingClickTargetEls && this._studioDockFloatingClickTargetEls.length){
        this._studioDockFloatingClickTargetEls.forEach(function(targetEl) {
            targetEl.onclick = null;
        });
    }
    if(this._studioDockFloatingClickSelector && this._studioDockFloatingClickDocumentEvent && this._studioDockFloatingDrawerClickHandler){
        $(document).off(this._studioDockFloatingClickDocumentEvent, this._studioDockFloatingClickSelector, this._studioDockFloatingDrawerClickHandler);
    }
    if(this._studioDockFloatingHandlerRoots$el && this._studioDockFloatingChangeSelector && this._studioDockFloatingChangeDocumentEvent && this._studioDockFloatingDrawerChangeHandler){
        this._studioDockFloatingHandlerRoots$el.off(this._studioDockFloatingChangeDocumentEvent, this._studioDockFloatingChangeSelector, this._studioDockFloatingDrawerChangeHandler);
    }
    this._studioDockFloatingDrawerHandlersBound = false;
    this._studioDockFloatingHandlerRoots$el = null;
    this._studioDockFloatingClickSelector = null;
    this._studioDockFloatingChangeSelector = null;
    this._studioDockFloatingClickDocumentEvent = null;
    this._studioDockFloatingChangeDocumentEvent = null;
    this._studioDockFloatingClickTargetEls = null;
    this._studioDockFloatingChangeTargetEls = null;
    this._studioDockFloatingDrawerClickHandler = null;
    this._studioDockFloatingDrawerChangeHandler = null;
},

_setStudioDockPanelState: function(panelName) {
    if(!this.$el){
        return;
    }

    if(!STUDIO_DOCK_RECORD_UI){
        if(panelName === "drafts"){
            this._inlineDraftRecoveryPanelOpen = true;
        }else if(panelName === null){
            this._inlineDraftRecoveryPanelOpen = false;
        }
        this._renderRecordingDraftRecoveryPanel();
        return;
    }

    const shell$el = this.$el.find("#recordingBlock .shell");
    const settingsDrawer$el = this._getStudioDockSettingsDrawer$el();
    const notesDrawer$el = this._getStudioDockNotesDrawer$el();
    const draftDrawer$el = this.draftDrawer$el && this.draftDrawer$el.length ? this.draftDrawer$el : this.$el.find("#draftDrawer").first();
    if(!shell$el.length){
        return;
    }

    const normalizedPanelName = panelName === "settings" || panelName === "notes" || panelName === "drafts" ? panelName : null;
    const isSettingsOpen = normalizedPanelName === "settings";
    const isNotesOpen = normalizedPanelName === "notes";
    const isDraftsOpen = normalizedPanelName === "drafts";
    const isAnyPanelOpen = !!normalizedPanelName;

    shell$el.toggleClass("drawer-open", isAnyPanelOpen);
    shell$el.toggleClass("settings-open", isSettingsOpen);
    shell$el.toggleClass("notes-open", isNotesOpen);
    shell$el.toggleClass("drafts-open", isDraftsOpen);
    this._mountStudioDockDrawersToBody();
    this._applyStudioDockDrawerRootStyles();

    if(settingsDrawer$el.length){
        settingsDrawer$el
            .attr("aria-hidden", isSettingsOpen ? "false" : "true")
            .css({
                transform: isSettingsOpen ? "translateX(0)" : "translateX(100%)",
                pointerEvents: isSettingsOpen ? "auto" : "none"
            });
    }
    if(notesDrawer$el.length){
        notesDrawer$el
            .attr("aria-hidden", isNotesOpen ? "false" : "true")
            .css({
                transform: isNotesOpen ? "translateX(0)" : "translateX(100%)",
                pointerEvents: isNotesOpen ? "auto" : "none"
            });
    }
    if(draftDrawer$el.length){
        draftDrawer$el
            .attr("aria-hidden", isDraftsOpen ? "false" : "true")
            .css({
                transform: isDraftsOpen ? "translateX(0)" : "translateX(100%)",
                pointerEvents: isDraftsOpen ? "auto" : "none"
            });
    }

    const legacyCheckbox$el = this.$el.find("#showNotesToggleBox input").first();
    if(legacyCheckbox$el.length){
        legacyCheckbox$el.prop("checked", isNotesOpen);
    }

    this._syncStudioDockPanelButtons();
    this._syncRecordingLayoutVisibility();

    if(isAnyPanelOpen){
        this._bindStudioDockDrawerOutsideHandler();
    }else{
        this._unbindStudioDockDrawerOutsideHandler();
    }
},

_closeStudioDockSidePanels: function() {
    this._onDraftDrawerCloseClicked();
    this._setStudioDockPanelState(null);
},

_onStudioDockNotesToggleClicked: function() {
    if(!STUDIO_DOCK_RECORD_UI || !this.$el){ return; }
    this._cacheStudioDockDrawerElements();
    this._unbindStudioDockFloatingDrawerHandlers();
    this._bindStudioDockFloatingDrawerHandlers();
    const willOpen = this._getStudioDockOpenPanelName() !== "notes";
    this._setStudioDockPanelState(willOpen ? "notes" : null);
    if(willOpen){
        const noteField$el = this.$el.find("#noteField");
        if(noteField$el.length){
            try { noteField$el.focus(); } catch(e){}
        }
    }
},

_toggleStudioDockSettingsDrawer: function() {
    if(!STUDIO_DOCK_RECORD_UI || !this.$el){ return; }
    this._cacheStudioDockDrawerElements();
    this._unbindStudioDockFloatingDrawerHandlers();
    this._bindStudioDockFloatingDrawerHandlers();
    const drawer$el = this._getStudioDockSettingsDrawer$el();
    if(!drawer$el.length){ return; }
    const willOpen = this._getStudioDockOpenPanelName() !== "settings";
    if(willOpen){
        this.refreshInlineRecordingDeviceSelectors();
    }
    this._syncStudioDockDrawerControls();
    this._setStudioDockPanelState(willOpen ? "settings" : null);
},

_closeStudioDockSettingsDrawer: function() {
    this._closeStudioDockSidePanels();
},

_onStudioDockDrawerCloseClicked: function() {
    this._closeStudioDockSettingsDrawer();
},

_onRecordAudioModeButtonClicked: function() {
if(STUDIO_DOCK_RECORD_UI && this.getStudioDockVisualSource() === "screen"){
    this.setStudioDockVisualSource("camera", true);
}
this._requestRecordingMediaTypeChange("audio");
if (STUDIO_DOCK_RECORD_UI) { this._syncStudioDockSourcePillsWithMode(); }
},

_onRecordVideoModeButtonClicked: function() {
if(STUDIO_DOCK_RECORD_UI){
    this.setStudioDockVisualSource("camera", true);
}
this._requestRecordingMediaTypeChange("video");
if (STUDIO_DOCK_RECORD_UI) { this._syncStudioDockSourcePillsWithMode(); }
},

_prepareRecordingMediaTypeChange: function(recordingMediaType) {
return new RSVP.Promise((function(resolve, reject) {
    try {
        this.trigger("prepareRecordingMediaTypeChange", recordingMediaType, function(error) {
            if(error) {
                reject(error);
                return;
            }

            resolve();
        });
    } catch(error) {
        reject(error);
    }
}).bind(this));
},

_flushPendingRecordingMediaTypeChange: function() {
if(this._isRecordingFlowBusy()){
    return;
}

const pendingRecordingMediaTypeChange = this._pendingRecordingMediaTypeChange;
this._pendingRecordingMediaTypeChange = null;
if(pendingRecordingMediaTypeChange && pendingRecordingMediaTypeChange !== this._recordingMediaType){
    this._requestRecordingMediaTypeChange(pendingRecordingMediaTypeChange);
}
},

_requestRecordingMediaTypeChange: function(recordingMediaType) {
if(this._recordingMediaType === recordingMediaType){
    return;
}

if(recordingMediaType === "video" && !AudioRecorderHelper.getInstance().isRecordingMediaTypeSupported("video")){
    window.alertErrorMessage(window.getI18n(ti18n, "RECORDING_IS_NOT_SUPPORTED"));
    this._syncRecordingInteractionBusyState();
    return;
}

if(this._isRecordingFlowBusy()){
    this._pendingRecordingMediaTypeChange = recordingMediaType;
    return;
}

this._pendingRecordingMediaTypeChange = null;

if(this._isAudioRecordedForCapsule()){
    const buttonLabels = [window.getI18n(ti18n,"NO"), window.getI18n(ti18n,"YES")];
    const confirmCallback = (function(buttonIndex){
        if(buttonIndex ==  2){
            const prepareMediaTypeChangePromise = recordingMediaType === "video" ? this._prepareRecordingMediaTypeChange(recordingMediaType) : RSVP.Promise.resolve();
            prepareMediaTypeChangePromise.then((function(){
                return this.deleteRecordedAudio();
            }).bind(this)).then((function(){
                this.setRecordingMediaType(recordingMediaType);
            }).bind(this)).catch(function(error){
                console.error("Unable to delete the previous recording before switching the recording media type", error);
                window.alertErrorMessage(error);
            });
        }
    }).bind(this);
    window.showConfirmDialog(window.getI18n(ti18n,"ARE_YOU_WANT_TO_DELETE_AND_RERECORD_AGAIN"), confirmCallback, window.getI18n(ti18n,"DELETE_CAPSULE"), buttonLabels, null, null, "");
}else{
    this.setRecordingMediaType(recordingMediaType);
}
},

getRecordingMediaType: function() {
return this._recordingMediaType || "audio";
},

_isVideoRecordingMode: function() {
return this.getRecordingMediaType() === "video";
},

showRecordingPreviewLoading: function(message) {
this.setRecordingPreviewState("loading", message || window.getI18n(ti18n, "STARTING_CAMERA_PREVIEW"));
},

showRecordingPreviewError: function(message) {
this.setRecordingPreviewState("error", message || window.getI18n(ti18n, "CAMERA_PREVIEW_UNAVAILABLE"));
},

showRecordingPreviewReady: function() {
this.setRecordingPreviewState("ready");
},

_hasRecordingPreviewStreamAttached: function() {
if(!this.recordingPreviewVideo$el || !this.recordingPreviewVideo$el.get(0)){
    return false;
}

return !!this.recordingPreviewVideo$el.get(0).srcObject;
},

_setRecordingPreviewAspectRatio: function(width, height) {
const numericWidth = Number(width);
const numericHeight = Number(height);
const hasValidRatio = isFinite(numericWidth) && isFinite(numericHeight) && numericWidth > 0 && numericHeight > 0;
const aspectRatioValue = hasValidRatio ? (numericWidth + " / " + numericHeight) : null;
const visualStage$el = this.$el ? this.$el.find(".visual-stage").first() : null;

if(this.recordingPreviewStage$el && this.recordingPreviewStage$el.length){
    if(aspectRatioValue){
        this.recordingPreviewStage$el.get(0).style.setProperty("--sd-preview-aspect-ratio", aspectRatioValue);
    }else{
        this.recordingPreviewStage$el.get(0).style.removeProperty("--sd-preview-aspect-ratio");
    }
}

if(visualStage$el && visualStage$el.length){
    if(aspectRatioValue){
        visualStage$el.get(0).style.setProperty("--sd-preview-aspect-ratio", aspectRatioValue);
    }else{
        visualStage$el.get(0).style.removeProperty("--sd-preview-aspect-ratio");
    }
}
},

_getRecordingPreviewAspectRatioValue: function() {
const videoEl = this.recordingPreviewVideo$el && this.recordingPreviewVideo$el.get(0) ? this.recordingPreviewVideo$el.get(0) : null;

if(videoEl){
    const videoWidth = Number(videoEl.videoWidth || 0);
    const videoHeight = Number(videoEl.videoHeight || 0);
    if(videoWidth > 0 && videoHeight > 0){
        return videoWidth / videoHeight;
    }

    if(videoEl.srcObject && videoEl.srcObject.getVideoTracks){
        const videoTrack = videoEl.srcObject.getVideoTracks()[0];
        if(videoTrack){
            const trackSettings = videoTrack.getSettings ? videoTrack.getSettings() : null;
            const trackWidth = Number(trackSettings && trackSettings.width ? trackSettings.width : 0);
            const trackHeight = Number(trackSettings && trackSettings.height ? trackSettings.height : 0);
            if(trackWidth > 0 && trackHeight > 0){
                return trackWidth / trackHeight;
            }

            const trackAspectRatio = Number(trackSettings && trackSettings.aspectRatio ? trackSettings.aspectRatio : 0);
            if(trackAspectRatio > 0 && isFinite(trackAspectRatio)){
                return trackAspectRatio;
            }
        }
    }
}

const aspectRatioValue = this.recordingPreviewStage$el && this.recordingPreviewStage$el.length ? this.recordingPreviewStage$el.get(0).style.getPropertyValue("--sd-preview-aspect-ratio") : "";
if(aspectRatioValue){
    const normalizedValue = aspectRatioValue.trim();
    if(normalizedValue.indexOf("/") !== -1){
        const ratioParts = normalizedValue.split("/").map(function(part){
            return Number(String(part).trim());
        });
        if(ratioParts.length === 2 && ratioParts[0] > 0 && ratioParts[1] > 0){
            return ratioParts[0] / ratioParts[1];
        }
    }else{
        const numericAspectRatio = Number(normalizedValue);
        if(numericAspectRatio > 0 && isFinite(numericAspectRatio)){
            return numericAspectRatio;
        }
    }
}

return 16 / 9;
},

_syncRecordingPreviewAspectRatioFromElement: function(videoEl) {
if(!videoEl){
    this._setRecordingPreviewAspectRatio(null, null);
    return;
}

let width = videoEl.videoWidth || 0;
let height = videoEl.videoHeight || 0;

if((!width || !height) && videoEl.srcObject && videoEl.srcObject.getVideoTracks){
    const videoTrack = videoEl.srcObject.getVideoTracks()[0];
    if(videoTrack){
        const trackSettings = videoTrack.getSettings ? videoTrack.getSettings() : null;
        if(trackSettings){
            width = width || trackSettings.width || 0;
            height = height || trackSettings.height || 0;
            if((!width || !height) && trackSettings.aspectRatio){
                const normalizedAspectRatio = Number(trackSettings.aspectRatio);
                if(isFinite(normalizedAspectRatio) && normalizedAspectRatio > 0){
                    if(width && !height){
                        height = Math.round(width / normalizedAspectRatio);
                    }else if(height && !width){
                        width = Math.round(height * normalizedAspectRatio);
                    }
                }
            }
        }
    }
}

this._setRecordingPreviewAspectRatio(width, height);
},

_syncRecordingPreviewPresentation: function() {
const hasRecordingPreviewStreamAttached = this._hasRecordingPreviewStreamAttached();
const shouldShowOverlay = this._recordingMediaType === "video" && (this._recordingPreviewState === "loading" || this._recordingPreviewState === "error");

if(this.recordingPreviewStatusText$el){
    this.recordingPreviewStatusText$el.text(this._recordingPreviewStatusMessage || "");
}

if(this.recordingPreviewStatus$el){
    this.recordingPreviewStatus$el.toggle(shouldShowOverlay);
}

if(this.retryRecordingPreviewButton$el){
    if(this._recordingPreviewState === "error"){
        this.retryRecordingPreviewButton$el.css("display", "inline-flex");
    }else{
        this.retryRecordingPreviewButton$el.hide();
    }
}

if(this.recordingPreviewVideo$el){
    const shouldShowVideo = this._recordingMediaType === "video" && (this._recordingPreviewState === "ready" || hasRecordingPreviewStreamAttached);
    this.recordingPreviewVideo$el.css("opacity", shouldShowVideo ? "1" : "0");
}

this._syncCompactVideoTimerRowState();
},

setRecordingPreviewState: function(state, message) {
this._recordingPreviewState = state || "idle";
this._recordingPreviewStatusMessage = message || "";

if(!this.recordingPreviewStatus$el || !this.recordingPreviewStatusText$el){
    return;
}

this._syncRecordingPreviewPresentation();
},

_clearPendingRecordingPreviewBinding: function() {
if(this._clearRecordingPreviewBinding){
    this._clearRecordingPreviewBinding();
    this._clearRecordingPreviewBinding = null;
}
},

setRecordingMediaType: function(recordingMediaType, skipEvent) {
this._recordingMediaType = recordingMediaType === "video" ? "video" : "audio";
if(this._recordingMediaType !== "video"){
    this.stopRecordedVideoPlayback();
}

if(this.$el){
    this.$el.attr("recording-media-type", this._recordingMediaType);
}
if(this.recordingBlock$el){
    this.recordingBlock$el.attr("recording-media-type", this._recordingMediaType);
}

if(this.recordAudioModeButton$el && this.recordVideoModeButton$el){
    this.recordAudioModeButton$el.toggleClass("selected", this._recordingMediaType === "audio");
    this.recordVideoModeButton$el.toggleClass("selected", this._recordingMediaType === "video");
}

if(this.recordButtonWrapper$el){
    const recordIcon$el = this.recordButtonWrapper$el.find("t");
    recordIcon$el.toggleClass("pe-7s-micro", this._recordingMediaType === "audio");
    recordIcon$el.toggleClass("pe-7s-video", this._recordingMediaType === "video");
}

if(this.recordingPreviewContainer$el){
    if(this._recordingMediaType === "video"){
        this.recordingPreviewContainer$el.show();
        if(this._creationMode === CREATION_MODE.FROM_RECORDING){
            const videoEl = this.recordingPreviewVideo$el && this.recordingPreviewVideo$el.get(0);
            if(!(videoEl && videoEl.srcObject)){
                const isScreenSource = this.getStudioDockVisualSource() === "screen";
                this.showRecordingPreviewLoading(window.getI18n(ti18n, isScreenSource ? "STARTING_SCREEN_SHARE_PREVIEW" : "STARTING_CAMERA_PREVIEW"));
            }
        }else{
            this.setRecordingPreviewState("idle");
        }
        if(this.playButton$el){
            this.playButton$el.removeClass("hidden");
        }
    }else{
        this.clearRecordingPreviewStream();
        this.recordingPreviewContainer$el.hide();
        this.setRecordingPreviewState("idle");
        if(this.playButton$el){
            this.playButton$el.removeClass("trebble_disabled");
            if(!SHOW_PLAY_BUTTON_INSIDE_CIRCULAR_TIMER){
                this.playButton$el.removeClass("hidden");
            }
        }
    }
}

this._syncPeakMeterContainerForMediaType();

this._updateInlineRecordingDeviceFieldVisibility();

this._syncRecordingLayoutVisibility();
this._syncCircularProgressVisibilityForMode();

if(this._inlineRecordingDeviceControlsInitialized){
    this.refreshInlineRecordingDeviceSelectors();
}

if (STUDIO_DOCK_RECORD_UI) {
    this._syncStudioDockSourcePillsWithMode();
    this._syncStudioDockDrawerControls();
}

if(!skipEvent){
    this.trigger("recordingMediaTypeChanged", this._recordingMediaType);
}

if(this.recordProgressContainer$el && this.noteSection$el && this.uploadProgressInfo$el && this.audioEditorUploadProgressInfo$el){
    this._onWindowSizeChanged();
}
},

setRecordingPreviewStream: function(recordingMediaType, stream, options) {
if(!this.recordingPreviewVideo$el){
    return;
}

if(recordingMediaType === "video"){
    const previewOptions = options || {};
    if(previewOptions.sourceType){
        this.setStudioDockVisualSource(previewOptions.sourceType, true);
    }
    const videoEl = this.recordingPreviewVideo$el.get(0);
    const isVideoElementReady = function() {
        return videoEl.readyState >= 2 || videoEl.videoWidth > 0 || videoEl.videoHeight > 0;
    };
    let previewFrameCallbackId = null;
    const markPreviewReady = (function() {
        if(videoEl.srcObject === stream){
            this._clearPendingRecordingPreviewBinding();
            this._syncRecordingPreviewAspectRatioFromElement(videoEl);
            this.showRecordingPreviewReady();
        }
    }).bind(this);
    const onPreviewReady = function() {
        if(isVideoElementReady()){
            markPreviewReady();
        }
    };

    this._clearPendingRecordingPreviewBinding();
    videoEl.muted = true;
    videoEl.autoplay = true;
    videoEl.playsInline = true;
    this.recordingPreviewContainer$el.show();
    this.showRecordingPreviewLoading();
    videoEl.addEventListener("loadedmetadata", onPreviewReady);
    videoEl.addEventListener("loadeddata", onPreviewReady);
    videoEl.addEventListener("canplay", onPreviewReady);
    videoEl.addEventListener("playing", onPreviewReady);
    if(videoEl.requestVideoFrameCallback){
        previewFrameCallbackId = videoEl.requestVideoFrameCallback(function() {
            markPreviewReady();
        });
    }
    const previewReadyTimeoutId = window.setTimeout((function() {
        if(isVideoElementReady()){
            markPreviewReady();
            return;
        }

        this._syncRecordingPreviewPresentation();
    }).bind(this), RECORDING_PREVIEW_ATTACH_TIMEOUT_IN_MILLI);
    this._clearRecordingPreviewBinding = function() {
        window.clearTimeout(previewReadyTimeoutId);
        videoEl.removeEventListener("loadedmetadata", onPreviewReady);
        videoEl.removeEventListener("loadeddata", onPreviewReady);
        videoEl.removeEventListener("canplay", onPreviewReady);
        videoEl.removeEventListener("playing", onPreviewReady);
        if(previewFrameCallbackId !== null && videoEl.cancelVideoFrameCallback){
            videoEl.cancelVideoFrameCallback(previewFrameCallbackId);
        }
    };
    videoEl.srcObject = stream;
    this._syncRecordingPreviewAspectRatioFromElement(videoEl);
    this._syncRecordingPreviewPresentation();
    const playPromise = videoEl.play ? videoEl.play() : null;
    if(playPromise && playPromise.catch){
        playPromise.catch(function(error){
            console.error("Unable to autoplay recording preview", error);
        });
    }
    if(isVideoElementReady()){
        markPreviewReady();
    }
}else{
    this.clearRecordingPreviewStream();
}
},

clearRecordingPreviewStream: function() {
if(this.recordingPreviewVideo$el && this.recordingPreviewVideo$el.get(0)){
    const videoEl = this.recordingPreviewVideo$el.get(0);
    this._clearPendingRecordingPreviewBinding();
    if(videoEl.pause){
        videoEl.pause();
    }
    if(videoEl.srcObject){
        videoEl.srcObject = null;
    }
    this._setRecordingPreviewAspectRatio(null, null);
    this._syncRecordingPreviewPresentation();
}
},

_onRetryRecordingPreviewButtonClicked: function() {
if(this._recordingMediaType === "video" && !this._isRecordingFlowBusy()){
    this.showRecordingPreviewLoading();
    this.trigger("retryRecordingPreview");
}
},


_startRecording: function() {
if(!ALLOW_USER_TO_RECORD_MULTIPLE_AUDIO_SEGMENT && this._isAudioRecordedForCapsule()){
this.deleteRecordedAudioConfirm();
}else{
this.stopRecordedVideoPlayback();
this._cancelSnippetDeletion();
this._currentRecordedSnippet = [];
this._isRecording = true;
this._isStoppingRecording = false;
this._pendingRecordedSnippet = null;
this.$el.attr("is-recording","true");
this.$el.attr("is-recording-finalizing","false");
this._setCompactVideoTimerLabel("0:00");
this._syncCompactVideoTimerRowState();
this._refreshBeforeUnloadProtection();
this._syncRecordingInteractionBusyState();
//set recorded file info this._currentRecordedFile = null;
this.trigger("startRecording", this.getFileRecordingCounter());
this.hideBackButton();
}
},

startRecordTimer : function(){
if(SHOW_PLAY_BUTTON_INSIDE_CIRCULAR_TIMER){
this.playButton$el.hide();
this.progressbarText$el.show();
}



this._hideTrackContainer();
this._currentRecordedSnippet.push(this.recordedProgressBar.value());
//trigger record action on model
this.recordedProgressBar.animate(1, (function() {
this._stopRecording();
}).bind(this));
this._enableNextButtonIfApplicable(true);
this._enableDoneRecordingBtnIfApplicable();
},

getFileRecordingCounter: function() {
return this._completedRecordedSnippetArray.length;
},

_getLastCompletedRecordingCounter: function() {
return this._completedRecordedSnippetArray && this._completedRecordedSnippetArray.length > 0 ? this._completedRecordedSnippetArray.length - 1 : this.getFileRecordingCounter();
},

getFileRecordingKey: function() {
return this._recordKey;
},

_hasContentRecorded : function(){
return this._completedRecordedSnippetArray && this._completedRecordedSnippetArray.length > 0;
},
_stopRecording: function() {
if (!this._isRecording || this._isStoppingRecording) {
    return;
}

let currentRecordedProgress = this.recordedProgressBar && this.recordedProgressBar.value ? this.recordedProgressBar.value() : 0;
try{
    if(this.recordedProgressBar && this.recordedProgressBar.stop){
        this.recordedProgressBar.stop();
    }
    if(this.recordedProgressBar && this.recordedProgressBar.value){
        currentRecordedProgress = this.recordedProgressBar.value();
    }
}catch(error){
    console.warn("Unable to stop the recording progress bar cleanly", error);
}
if(!isFinite(currentRecordedProgress)){
    currentRecordedProgress = this._currentRecordedSnippet && this._currentRecordedSnippet.length > 0 ? this._currentRecordedSnippet[0] : 0;
}
const recordingStartProgress = this._currentRecordedSnippet && this._currentRecordedSnippet.length > 0 ? this._currentRecordedSnippet[0] : currentRecordedProgress;
this._pendingRecordedSnippet = [recordingStartProgress, currentRecordedProgress];
this._currentRecordedSnippet = null;
this._isRecording = false;
this._isStoppingRecording = true;
this.$el.attr("is-recording","false");
this.$el.attr("is-recording-finalizing","true");
this._syncCompactVideoTimerRowState();
this._refreshBeforeUnloadProtection();
this._syncRecordingInteractionBusyState();
this.hideBackButton();

if(SHOW_PLAY_BUTTON_INSIDE_CIRCULAR_TIMER){
    this.progressbarText$el.hide();
    this.playButton$el.show();
}

this._enableNextButtonIfApplicable(true);
this._enableDoneRecordingBtnIfApplicable();
this.trigger("stopRecording", this.getFileRecordingCounter());
},

onRecordingStartFailed: function() {
this._isRecording = false;
this._isStoppingRecording = false;
this._pendingRecordedSnippet = null;
this._currentRecordedSnippet = [];
this._showPauseRecordingButton(false);
this._syncCompactVideoTimerRowState();
this._finalizeRecordingUiState();
},

onRecordingStopSucceeded: function() {
if(this._pendingRecordedSnippet){
    this._completedRecordedSnippetArray.push(this._pendingRecordedSnippet);
    this.recordedProgressBar.set(this._pendingRecordedSnippet[1]);
    this.deleteProgressBar.set(this._pendingRecordedSnippet[1]);
}
this._pendingRecordedSnippet = null;
this._currentRecordedSnippet = null;
this._isStoppingRecording = false;
this._showPauseRecordingButton(false);
this._syncCompactVideoTimerRowState();
this._finalizeRecordingUiState();
},

onRecordingStopFailed: function() {
const rollbackProgress = this._pendingRecordedSnippet && this._pendingRecordedSnippet.length > 0 ? this._pendingRecordedSnippet[0] : 0;
this._pendingRecordedSnippet = null;
this._currentRecordedSnippet = [];
this._isStoppingRecording = false;
this.recordedProgressBar.set(rollbackProgress);
this.deleteProgressBar.set(rollbackProgress);
this._showPauseRecordingButton(false);
this._syncCompactVideoTimerRowState();
this._finalizeRecordingUiState();
},

_onWindowSizeChanged : function() {
// In the studio-dock redesign the layout is fully CSS-driven (CSS Grid on
// .panel, aspect-ratio on .visual-stage, flex on .audio-stage). The legacy
// imperative sizing below writes inline width/height/max-width/margin onto
// several descendants and that was causing the video preview and audio
// timer to visibly shrink the moment recording started (because some
// contributors to the calculation like recordingInstructionHeight flip to
// 0 while others like recordButtonsHeight grow). Skip the entire legacy
// layout pass when we're in studio-dock mode — the CSS handles it. We
// still publish stub values for a few fields that downstream code reads
// (background track swiper, note section), so nothing crashes if they
// happen to run in studio-dock.
if(this.$el && this.$el.hasClass("studio-dock")){
    // The ProgressBar.Circle SVG still needs a real non-zero container size
    // for its internal animation math — a 0-radius SVG produces NaN in the
    // strokeDashoffset calculation and the step callback silently stops
    // firing, which kills the timer display and may cause .stop() to throw.
    // 200px is arbitrary; the container itself is hidden by CSS.
    this._circleProgressBarContainerWidth = 200;
    this._circleProgressBarContainerHeight = 200;
    this._circleProgressBarDiameter = 200;
    this._trackSwiperContainerWidth = 1;
    // Set the container to a real size so the SVG path is valid.
    if(this.recordProgressContainer$el && this.recordProgressContainer$el.length){
        this.recordProgressContainer$el.get(0).style.setProperty("width", "200px", "important");
        this.recordProgressContainer$el.get(0).style.setProperty("height", "200px", "important");
    }
    this._applyStudioDockDrawerRootStyles();

    if(this._creationMode === CREATION_MODE.FROM_FILE && this.uploadBlock$el && this.uploadBlock$el.length){
        // Studio-dock upload mode is now CSS-driven. The legacy sizing pass
        // pushes the dropzone downward by reapplying inline width and
        // record-button margins that only make sense for the old circular
        // recorder layout.
        this.uploadBlock$el.css({
            "width": "",
            "height": "",
            "margin-top": "0px",
            "margin-bottom": "0px"
        });
    }

    return;
}
const headerHeight = 57;
const footerHeight = 0;
const isVideoRecordingMode = this._isVideoRecordingMode();
const getVisibleOuterHeight = function($el, fallbackHeight) {
    if(!$el || !$el.length || !$el.is(":visible")){
        return 0;
    }

    return $el.outerHeight(true) || fallbackHeight || 0;
};
const routerViewportHeight = PersistentModels.getInstance().getRouter().getViewportHeight();
const visibleCarouselItem$el = this.$el.find(".carouselItem:visible").first();
const carouselViewportHeight = visibleCarouselItem$el && visibleCarouselItem$el.length ? (visibleCarouselItem$el.innerHeight() || 0) : 0;
const recordingViewportHeight = carouselViewportHeight || (this.recordingBlock$el && this.recordingBlock$el.length ? (this.recordingBlock$el.innerHeight() || Math.max(routerViewportHeight - headerHeight - footerHeight, 0)) : Math.max(routerViewportHeight - headerHeight - footerHeight, 0));
const recordButtonsHeight = this.recordControlsWrapper$el && this.recordControlsWrapper$el.is(":visible") ? (this.recordControlsWrapper$el.outerHeight(true) || 50) : 50;
const marginHeight = isVideoRecordingMode ? 16 : 25;
const progressTextWidth = 120;
const compactProgressTextWidth = 90;
const progressTextHeight =  50;
const creationModeSelector = getVisibleOuterHeight(this.$el.find("#creationModeSelectorWrapper"), 60);
const showNotesToggleSectionHeight = getVisibleOuterHeight(this.$el.find("#showNotesToggleBox"), 50);
const mediaTypeSelectorHeight = getVisibleOuterHeight(this.recordingMediaTypeSelector$el, 52);
const peakMeterHeight = isVideoRecordingMode ? 0 : 10;
const backgroundMusicSelectionBoxHeight = SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER ? Math.max(getVisibleOuterHeight(this.trackContainer$el, BACKGROUND_MUSIC_SELECTION_BOX_HEIGHT), getVisibleOuterHeight(this.trackSlectorBlockSpacer$el, BACKGROUND_MUSIC_SELECTION_BOX_HEIGHT)) : 0;
const videoTimerHeight = isVideoRecordingMode ? getVisibleOuterHeight(this.videoRecordingTimerRow$el, 40) : 0;
const visibleVideoNoteSectionHeight = (isVideoRecordingMode && !STUDIO_DOCK_RECORD_UI) ? getVisibleOuterHeight(this.noteSection$el, 220) : 0;
const baseContentMaxWidth = 760;
let previewMaxWidth = Math.min(Math.max(window.getDocumentClienWidth() - (marginHeight * 2), 0), baseContentMaxWidth);
const previewAspectRatio = Math.max(this._getRecordingPreviewAspectRatioValue(), 0.2);
let estimatedPreviewHeight = Math.round(previewMaxWidth / previewAspectRatio) + (isVideoRecordingMode ? 24 : 28);
const recordingDeviceControlsHeight = getVisibleOuterHeight(this.recordingDeviceControlsPanel$el, isVideoRecordingMode ? 96 : 84);
const recordingInstructionHeight = getVisibleOuterHeight(this.recordingInstruction$el, 50);

if(isVideoRecordingMode){
    const previewChromeHeight = 24;
    const reservedVideoChromeHeight = recordButtonsHeight + recordingInstructionHeight + marginHeight*2 + backgroundMusicSelectionBoxHeight + creationModeSelector + showNotesToggleSectionHeight + mediaTypeSelectorHeight + recordingDeviceControlsHeight + videoTimerHeight + visibleVideoNoteSectionHeight + 16;
    const previewHeightBudget = Math.max(0, recordingViewportHeight - reservedVideoChromeHeight);
    const previewWidthFromHeightBudget = Math.floor(Math.max(0, previewHeightBudget - previewChromeHeight) * previewAspectRatio);

    if(previewWidthFromHeightBudget > 0){
        previewMaxWidth = Math.min(previewMaxWidth, previewWidthFromHeightBudget);
        estimatedPreviewHeight = Math.round(previewMaxWidth / previewAspectRatio) + previewChromeHeight;
    }
}

const effectivePreviewReservationHeight = isVideoRecordingMode && this.recordingPreviewContainer$el && this.recordingPreviewContainer$el.is(":visible") ? Math.max(this.recordingPreviewContainer$el.outerHeight(true) || 0, estimatedPreviewHeight) : 0;
const neededPadding =/* headerHeight + footerHeight + */recordButtonsHeight + recordingInstructionHeight + marginHeight*2 + backgroundMusicSelectionBoxHeight + creationModeSelector + showNotesToggleSectionHeight + mediaTypeSelectorHeight + peakMeterHeight + effectivePreviewReservationHeight + recordingDeviceControlsHeight + videoTimerHeight + visibleVideoNoteSectionHeight;
const newHeight = Math.max(132, recordingViewportHeight - neededPadding);
const newWidth =   Math.max(120, window.getDocumentClienWidth() - (marginHeight * 2));
const containerWidth = (newWidth < newHeight)?newWidth : newHeight;
const containerHeight = newHeight;
const circularProgressMarginTopHeight = isVideoRecordingMode ? 12 : 50;
const circularProgressMarginBottomHeight = isVideoRecordingMode ? 12 : 25;
let recordProgressContainerWidth = containerWidth;
let recordProgressContainerHeight = containerHeight;
// Device controls panel should always use the full content width (up to baseContentMaxWidth)
// regardless of how small the preview has been clamped by the height budget. Using the preview
// width here caused the mic/camera dropdowns to collapse to ~20px on short viewports.
const controlsMaxWidth = Math.min(newWidth, baseContentMaxWidth);
// Ensure the preview has a sensible minimum width so the camera feed remains usable on short
// viewports instead of collapsing to a tiny sliver. The page may scroll a bit in that edge case.
const MIN_PREVIEW_WIDTH = 280;
if(isVideoRecordingMode && previewMaxWidth < MIN_PREVIEW_WIDTH){
    previewMaxWidth = Math.min(MIN_PREVIEW_WIDTH, Math.min(newWidth, baseContentMaxWidth));
}

if(isVideoRecordingMode){
    const compactDiameter = Math.max(132, Math.min(176, Math.floor(Math.min(newWidth, controlsMaxWidth || baseContentMaxWidth) * 0.24)));
    recordProgressContainerWidth = compactDiameter;
    recordProgressContainerHeight = compactDiameter;
}

this._circleProgressBarContainerWidth = recordProgressContainerWidth;
this._circleProgressBarContainerHeight = recordProgressContainerHeight;
//this.noteSection$el.css("width",this._circleProgressBarContainerWidth +"px");
const noteSectionHeight = isVideoRecordingMode ? Math.max(220, this._circleProgressBarContainerHeight + circularProgressMarginTopHeight + circularProgressMarginBottomHeight) : (this._circleProgressBarContainerHeight + circularProgressMarginTopHeight + circularProgressMarginBottomHeight);
if(this.noteSection$el && !STUDIO_DOCK_RECORD_UI){
    this.noteSection$el.css("height", noteSectionHeight  +"px");
}
this._circleProgressBarDiameter = this._circleProgressBarContainerWidth < this._circleProgressBarContainerHeight?this._circleProgressBarContainerWidth : this._circleProgressBarContainerHeight;
this._trackSwiperContainerWidth = ( this._circleProgressBarDiameter)/Math.sqrt(2) ;
const progressTextTopPosition  = (containerWidth < containerHeight)?(containerWidth/2):(containerHeight/2);
const progressTextLeftPosition  = (containerWidth)/2;
const effectiveProgressTextTopPosition = isVideoRecordingMode ? (recordProgressContainerHeight / 2) : progressTextTopPosition;
const effectiveProgressTextLeftPosition = isVideoRecordingMode ? (recordProgressContainerWidth / 2) : progressTextLeftPosition;
const effectiveProgressTextWidth = isVideoRecordingMode ? compactProgressTextWidth : progressTextWidth;
this.progressbarText$el = this.$el.find(".progressbar-text");
this.uploadBlock$el/*.height(containerHeight)*/.width(containerWidth).css({"margin-top" :recordButtonsHeight +"px","margin-bottom" :marginHeight +"px"});
this.recordProgressContainer$el.height(recordProgressContainerHeight).width(recordProgressContainerWidth).css({"margin-top" :(isVideoRecordingMode ? 8 : recordButtonsHeight) +"px","margin-bottom" : (isVideoRecordingMode ? 8 : marginHeight) +"px"});
this.progressbarText$el.css({"top":effectiveProgressTextTopPosition +"px","left": effectiveProgressTextLeftPosition+"px","width" : effectiveProgressTextWidth +"px","text-align": "center", "font-size": isVideoRecordingMode ? "32px" : "", "line-height": isVideoRecordingMode ? "1" : "" });
const playButtonHeight =  93;
const playButtonWidth =  37;
this.$el.find("#recordProgressContainer #playButton").css({"top":(effectiveProgressTextTopPosition - (playButtonHeight/2)) +"px","left": (effectiveProgressTextLeftPosition  - (playButtonWidth/2))+"px","text-align": "center", "font-size": "70px","position":"absolute","margin":"0px","padding":"0px"});
this.uploadProgressInfo$el.css({"height": containerHeight +"px"});
this.audioEditorUploadProgressInfo$el.css({"height": containerHeight +"px"});
this.$el.find(".carouselItem").css({"height": (window.getDocumentClienHeight() - headerHeight - footerHeight) +"px"});
if(this.audioEditorSection$el && this.audioEditorSection$el.length){
    this.audioEditorSection$el.css({"height": Math.max(routerViewportHeight - headerHeight, 0) +"px"});
}
if(this.recordingPreviewContainer$el){
    const previewContainerMaxWidth = isVideoRecordingMode ? Math.min(controlsMaxWidth, previewMaxWidth || controlsMaxWidth) : controlsMaxWidth;
    this.recordingPreviewContainer$el.css({"max-width": previewContainerMaxWidth +"px", "margin-bottom": (isVideoRecordingMode ? "12px" : "16px")});
}
if(this.recordingDeviceControlsPanel$el){
    this.recordingDeviceControlsPanel$el.css({"max-width": controlsMaxWidth +"px", "margin-bottom": (isVideoRecordingMode ? "10px" : "12px")});
}
if(this.trackContainer$el && this._backgroundTrackSwiperObj){
if(!SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER){
    this.trackContainer$el.width(this._trackSwiperContainerWidth);
    const containerLeft = (this._circleProgressBarDiameter - this._trackSwiperContainerWidth)/2;
    const containerBottom = containerLeft;
    this.trackContainer$el.css("left",containerLeft +"px");
    this.trackContainer$el.css("bottom",containerBottom +"px");
}else{
    this.trackContainer$el.css("width",containerWidth +"px");
}
this._backgroundTrackSwiperObj.update();
}

},



onAfterPageShow: function() {

this.carousel$el.data('owlCarousel').reload();
if(this._songModel){
const capsuleUIDs =  this._songModel.get("capsuleUIDs");
if(capsuleUIDs && capsuleUIDs.length > 0){
const buttonLabels = [window.getI18n(ti18n,"CANCEL"), window.getI18n(ti18n,"OK")];
const confirmCallback = (function(buttonIndex){
if(buttonIndex ==  2){
this.close();
}
}).bind(this);
window.showConfirmDialog(window.getI18n(ti18n,"YOU_HAVE_ALREADY_CREATED_A_CAPSULE_FOR_THIS_SONG"), confirmCallback, window.getI18n(ti18n,"CAPSULE_ALREADY_EXISTS"), buttonLabels)
}
}
},

onBeforeRemoveFromPage : function(){
this.trigger("beforeRemoveFromPage", this);
},


onRemovedFromPage : function(){
this.clearRecordingPreviewStream();
this._isRecording = false;
this._isStoppingRecording = false;
this._refreshBeforeUnloadProtection();
this.undelegateEvents();
this.$el.removeData().unbind();
	// Unmount the folder picker React root so it doesn't leak listeners / state
	// after the page is removed. Wrap in try/catch because React 18's unmount
	// can throw if the container was already detached from the DOM.
if (this._folderPickerRoot) {
	try { this._folderPickerRoot.unmount(); } catch (e) { /* ignore */ }
	this._folderPickerRoot = null;
	}
this._pageHasBeenRemoved = true;
this.trigger("removedFromPage", this);
},

removePage : function(){
this._onPageHide(null, true);
},

isAudioEditorViewSafeToRemove: function(){
    return !this._audioEditorView || !this._audioEditorView.isUnsafeToRemove();
},

_onPageHide : function(event, force){
//this.trigger("deleteAllRecordings");
this.stopRecordedVideoPlayback();

if(!this._pageHasBeenRemoved && this.isAudioEditorViewSafeToRemove() && (force || this._canPageBeDeletedIfHidden() || PersistentModels.getInstance().getRouter().isBrowserHistoryGoingBack()))
{
this.trigger("pageHide")
PersistentModels.getInstance().getRouter().unRegisterForViewportHeightChange(this._pageId);
this.onBeforeRemoveFromPage();
this.remove();
this.onRemovedFromPage();
}
if(this._recordOnboardingTour){
    this._recordOnboardingTour.cancel();
    this._recordOnboardingTour = null;
}
if(this._saveOrEditOnboardingTour){
    this._saveOrEditOnboardingTour.cancel();
    this._saveOrEditOnboardingTour = null;
}
},

showWhatsACapsuleButton : function(){
this.$el.find("#whatsacapsuleButton").show();
},

hideWhatsACapsuleButton : function(){
this.$el.find("#whatsacapsuleButton").hide();
},

onWhatsACapsuleButtonClicked : function(){
this.trigger("onWhatsACapsuleButton");
},

showHideUploadingViewInCapsuleInfo : function(show){
this._uploadingViewInCapsuleInfoDisplayed = show;
if(show){
this.previousButtn$el.hide();
this.capsuleInfo$el.hide();
this.uploadProgressInfo$el.css("display","flex");
if(!this.$el.find("#saveButtonIcon").hasClass("trebble_disabled")){
    this.$el.find("#saveButtonIcon").addClass("trebble_disabled");
}
 if(!this.$el.find("#nextButton").hasClass("trebble_disabled")){
    this.$el.find("#nextButton").addClass("trebble_disabled");
}
}else{
this.previousButtn$el.show();
this.uploadProgressInfo$el.hide();
this.capsuleInfo$el.show();
	this._onCapsuleInfoEdited();
	this._enableNextButtonIfApplicable();
}
this._refreshBeforeUnloadProtection();
},

showHideUploadingViewInAudioEditor : function(show){
this._uploadingViewInAudioEditorDisplayed = show;
if(show){
this.previousButtn$el.hide();
this.audioEditorAndTranscriptionBox$el.hide();
this.audioEditorUploadProgressInfo$el.css("display","flex");
if(!this.$el.find("#saveButtonIcon").hasClass("trebble_disabled")){
    this.$el.find("#saveButtonIcon").addClass("trebble_disabled");
}
if(!this.$el.find("#nextButton").hasClass("trebble_disabled")){
    this.$el.find("#nextButton").addClass("trebble_disabled");
}
}else{
this.previousButtn$el.show();
this.audioEditorUploadProgressInfo$el.hide();
this.audioEditorAndTranscriptionBox$el.show();
	this._onCapsuleInfoEdited();
	this._enableNextButtonIfApplicable();
}
this._syncAudioEditorLayoutState();
this._syncAudioEditorSectionHeight();
this._refreshBeforeUnloadProtection();
},

showHideMessageToStartTranscriptionBox : function(show){
if(show){
this.messageToStartTranscriptionBox$el.show();
this.showSaveOrEditOnboardingInstruction();
}else{
this.messageToStartTranscriptionBox$el.hide();
}
this._syncAudioEditorLayoutState();
this._syncAudioEditorSectionHeight();
},

isSequencerNodeWrapperDisplayed : function(){
return this._sequencerNodeWrapperIsDisplayed;
},

showHideSequncerNodeWrapper : function(show){
this._sequencerNodeWrapperIsDisplayed = show;
if(show){
    this.sequncerNodeWrapper$el.show();
}else{
    this.sequncerNodeWrapper$el.hide();
}
this._syncAudioEditorLayoutState();
this._syncAudioEditorSectionHeight();
this._updateHeaderButtons();
},

_buildCarouselTrackItem$el : function(trackkUri , trackLabel, artistName, trackDownloadUrl){
if(trackDownloadUrl){
return this._buildTrackCarouselWrapper().append("<div class='trackItem' data-track-uri='"+ trackkUri+"'><div><span class='trackName'>"+trackLabel +"</span><span class='artistName'>"+artistName+"</span></div><span class='downloadInfo'>"+ window.getI18n(ti18n,"DOWNLOAD_INSTRUMENTAL") +" "+"<a href='"+trackDownloadUrl+"' target='_blank'>here</a></span></div>");
}else{
return this._buildTrackCarouselWrapper().append("<div class='trackItem' data-track-uri='"+ trackkUri+"'><div><span class='trackName'>"+trackLabel +"</span><span class='artistName'>"+artistName+"</span></div></div>");
}
},

_buildTrackItem$el : function(trackkUri , trackLabel){
return $("<div class='trackItem' data-track-uri='"+ trackkUri+"'>"+trackLabel +"</div>");
},



_hideTrackContainer : function(){
if(this.trackSlectorBlockSpacer$el && this.trackContainer$el){
if(this.$el && this.$el.hasClass("studio-dock")){
    this.trackContainer$el.hide();
    this.trackSlectorBlockSpacer$el.hide();
    return;
}
if(SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER){
    this.trackContainer$el.hide();
    if(this._recordingInstructionsDisplayed){
        this.trackSlectorBlockSpacer$el.hide();
    }else{
       this.trackSlectorBlockSpacer$el.css("display","flex");
   }
}else{
this.trackContainer$el.hide();
this.trackSlectorBlockSpacer$el.hide();
}
}
},

_showTrackContainer : function(){
if(this.trackSlectorBlockSpacer$el && this.trackContainer$el){
if(SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER){
    this.trackContainer$el.css("display","flex");
    this.trackSlectorBlockSpacer$el.hide();
}else{
    this.trackContainer$el.show();
    this.trackSlectorBlockSpacer$el.hide();
}
}
},
_onSelectionChanged : function(trebbleAudioModel){

},

_onDeleteSelectedBackgroundMusic : function(){
this._setBackgroundMusicTrebbleAudioModel(null);
},

_setBackgroundMusicTrebbleAudioModel : function(selectedBackgroundMusicTrebbleAudioModel){
this._selectedBackgroundMusicModel = selectedBackgroundMusicTrebbleAudioModel;
if(this._selectedBackgroundMusicModel){
const params = {"doNotShowArtistName": true,"doNotShowCoverArt": true};
params.model = this._selectedBackgroundMusicModel;
const backgroundMusicContextController = new SongContextController(params);
backgroundMusicContextController.buildModelAndRenderView().then((function(){
this.backgroundMusicSelectorView.setSelectedSongView(backgroundMusicContextController.getView())
this.trigger("backgroundTrackChange",this._selectedBackgroundMusicModel.getAudioUrl());
}).bind(this));
}else{
this.backgroundMusicSelectorView.setSelectedSongView(null);
this.trigger("backgroundTrackChange",null);
}
},

_showBackgroundMusicPicker : function(){
const onBackgroundMusicSelected = (function(selectedBackgroundMusicTrebbleAudioModel){
if(selectedBackgroundMusicTrebbleAudioModel){
    this._setBackgroundMusicTrebbleAudioModel(selectedBackgroundMusicTrebbleAudioModel);

}
}).bind(this)
return PersistentModels.getInstance().getRouter().showChooseBackgroundMusicPopup(onBackgroundMusicSelected);
},

_setupBackgroundMusicSelector: function(){
const backgroundMusicSelectorView = new SingleSongSelectorInputView({"noAudioSelectedCustomLabel":"<span class='ion-ios7-musical-notes' style='margin-right: 0.5em;margin-left: 0.5em;font-size: 1.5em;'/>"+window.getI18n(ti18n, "NO_BACKGROUND_MUSIC"),"chooseAudioCustomLabel":window.getI18n(ti18n, "ADD_BACKGROUND_MUSIC"),"removeAudioCustomLabel":window.getI18n(ti18n, "REMOVE_BACKGROUND_MUSIC")});
backgroundMusicSelectorView.render();
this.backgroundMusicSelectorView = backgroundMusicSelectorView;
this.listenTo(this.backgroundMusicSelectorView ,"deleteCurrentSelectedSong", this._onDeleteSelectedBackgroundMusic.bind(this));
this.listenTo(this.backgroundMusicSelectorView , "pickSong", this._showBackgroundMusicPicker.bind(this));
this._onSelectionChanged(this._selectedBackgroundMusicModel);
this._backgroundTrackContainerId  = 'trackContainer' + (new Date().getTime());
if(SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER){
this.trackContainer$el  = $("<div id='"+this._backgroundTrackContainerId+"' class='swiper-container trackSelectorBox' style='width: "+this._circleProgressBarContainerWidth+"px; overflow:visible;'></div>");
this.trackContainer$el.append(backgroundMusicSelectorView.$el);
this.trackContainer$el.insertBefore(this.recordControlsWrapper$el);
this.trackSlectorBlockSpacer$el.hide();
}else{
const containerLeft = (this._circleProgressBarDiameter - this._trackSwiperContainerWidth)/2;
const containerBottom = containerLeft;
this.trackContainer$el  = $("<div id='"+this._backgroundTrackContainerId+"' class='swiper-container trackSelectorBox' style='height: 50px;width:"+this._trackSwiperContainerWidth+"px; overflow:visible; position:absolute;left:"+containerLeft+"px;bottom:"+containerBottom+"px;'></div>");
this.trackContainer$el.append(backgroundMusicSelectorView.$el);
this.progressbarContainer$el.append(this.trackContainer$el);
this.trackSlectorBlockSpacer$el.hide();
}
this.trackContainer$el.hide();
},

_setupBackgroundTrackSelector : function(){
this._backgroundTrackContainerId  = 'trackContainer' + (new Date().getTime());
if(SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER){
this.trackContainer$el  = $("<div id='"+this._backgroundTrackContainerId+"' class='swiper-container trackSelectorBox' style='width: "+this._circleProgressBarContainerWidth+"px; '></div>");
this.trackContainer$el.append("<div class='swiper-wrapper'> </div>"+ this._buildCarouselNavigationButtons()+"</div>");
this.trackSlectorBlockSpacer$el.hide();
}else{
const containerLeft = (this._circleProgressBarDiameter - this._trackSwiperContainerWidth)/2;
const containerBottom = containerLeft;
this.trackContainer$el  = $("<div id='"+this._backgroundTrackContainerId+"' class='swiper-container trackSelectorBox' style='height: 50px;width:"+this._trackSwiperContainerWidth+"px; position:absolute;left:"+containerLeft+"px;bottom:"+containerBottom+"px;'></div>");
this.trackContainer$el.append("<div class='swiper-wrapper'> </div>"+ this._buildCarouselNavigationButtons()+"</div>");
this.trackSlectorBlockSpacer$el.hide();
}

const swiperWrapper$el  = this.trackContainer$el.find(".swiper-wrapper");
swiperWrapper$el.append(this._buildCarouselTrackItem$el("",NO_BACKGROUND_TRACK, CHOOSE_BACKGROUND_TRACK_LABEL));
for(let trackUri in BACKGROUND_MUSIC_URI_TO_INFO){
const trackInfo =  BACKGROUND_MUSIC_URI_TO_INFO[trackUri];
const trackName = trackInfo.name;
const artistName = trackInfo.artistName;
const trackDownloadUrl = trackInfo.downloadUrl;
swiperWrapper$el.append(this._buildCarouselTrackItem$el(trackUri, trackName, " "+window.getI18n(ti18n,"BY")+" " + artistName, trackDownloadUrl));
}
if(SHOW_BACKGROUND_TRACK_SELECTOR_OUTSIDE_OF_TIMER){
this.trackContainer$el.insertBefore(this.recordControlsWrapper$el);
}else{
this.progressbarContainer$el.append(this.trackContainer$el);
}

const swiperParams  =  {
speed: window.isMobileBrowser?200: 300,
longSwipesRatio : window.isMobileBrowser?0.2: 0.4,
watchSlidesProgress: true,
preloadImages: false,
watchSlidesVisibility: true,
slidesPerView: 1,
centeredSlides: true,
paginationHide: true,
slideToClickedSlide: true,
lazyLoading: true,
lazyLoadingInPrevNext: true,
lazy: {
loadPrevNext: true
},
//onInit : this._onSwiperInit.bind(this),
onSlideChangeEnd : this._onBackgroundTrackChange.bind(this),
nextButton :'.swiper-button-next',
prevButton : '.swiper-button-prev',
keyboardControl : true,
mousewheelControl : true,
mousewheel :  {
enabled: true
},
keyboard :  {
enabled: true,
onlyInViewport: false
},
on:{
"slideChangeTransitionEnd" : this._onBackgroundTrackChange.bind(this),
}
};


this._backgroundTrackSwiperObj = new Swiper("#"+this._backgroundTrackContainerId,swiperParams);
if(!this._canBackgroundMusicUsed()){
//disable background track on mobile for now
this._hideTrackContainer();
}
this.trackContainer$el.hide();

},
_onBackgroundTrackChange : function(){
const currentBackgroundTrackUri = this.$el.find(".swiper-slide-active > .trackItem").attr("data-track-uri");
this.trigger("backgroundTrackChange",currentBackgroundTrackUri);
},

_buildTrackCarouselWrapper : function(){
return  $("<div class='slideItemWrapper swiper-slide' style='width:100%;'></div>");

},

_buildCarouselNavigationButtons : function(){
return      '<div class="swiper-button-next ion-ios7-arrow-right"></div> <div class="swiper-button-prev ion-ios7-arrow-left"></div>';
},

getTextToConvert: function(){
return this.textToConvertField$el.val();
},

getTextToNarrate: function(){
return this.textToConvertByVoiceActorField$el.val();
},

getNarrationInstructions: function(){
return this.instructionsForVoiceActorField$el.val();
},

getTTSLanguage : function(){
return this.$el.find("#ttsLanguageFld option:selected").val();
},

getNarrationLanguage : function(){
return this.$el.find("#ttsLanguageForVoiceActorFld option:selected").val();
},

getLanguageUsedInAudio : function(){
return this.$el.find("#languageUsedInAudioFld option:selected").val();
},

getVoiceProfile : function(){
return this.$el.find("#voiceProfileFld option:selected").val();
},

getVoiceTone : function(){
return this.$el.find("#voiceToneFld option:selected").val();
},

isTextToConvertFieldEmpty : function(){
const textToConvertInAudio =  this.getTextToConvert();
return !textToConvertInAudio || textToConvertInAudio.trim().length  == 0;
},

isTextToNarrateFieldEmpty : function(){
const textToNarrate =  this.getTextToNarrate();
return !textToNarrate || textToNarrate.trim().length  == 0;
},

isTextToNarrateFieldValid : function(){
return !this.isTextToNarrateFieldEmpty() && this._isTextToNarrateCountValid();
},

_syncPeakMeterContainerForMediaType: function(){
if(!this._peakMeterView || !this._peakMeterView.$el){
    if(this.videoPeakMeterContainer$el){
        this.videoPeakMeterContainer$el.css("display", this._isVideoRecordingMode() ? "block" : "none");
    }
    if(this.peakMeterContainer$el){
        this.peakMeterContainer$el.css("display", this._isVideoRecordingMode() ? "none" : "");
    }
    return;
}

const shouldUseVideoPeakMeter = this._isVideoRecordingMode() && this.videoPeakMeterContainer$el && this.videoPeakMeterContainer$el.length;
const targetContainer$el = shouldUseVideoPeakMeter ? this.videoPeakMeterContainer$el : this.peakMeterContainer$el;
if(targetContainer$el && targetContainer$el.length && this._peakMeterView.$el.parent().get(0) !== targetContainer$el.get(0)){
    this._peakMeterView.$el.detach().appendTo(targetContainer$el);
}

this._peakMeterView.$el.toggleClass("video-peak-meter", !!shouldUseVideoPeakMeter);

if(this.videoPeakMeterContainer$el){
    this.videoPeakMeterContainer$el.css("display", shouldUseVideoPeakMeter ? "block" : "none");
}
if(this.peakMeterContainer$el){
    this.peakMeterContainer$el.css("display", shouldUseVideoPeakMeter ? "none" : "");
}
},

setPeakMeterViewwIfApplicable: function(){
if(this._peakMeterView){
this._syncPeakMeterContainerForMediaType();
}
},

_isStudioDockDarkThemeEnabled: function(){
const bodyHasDarkTheme = $("body").hasClass("darkTheme");
const htmlHasDarkTheme = document && document.documentElement ? document.documentElement.classList.contains("darkTheme") : false;

return !!LocalStorageHelper.getInstance().getUseEditorDarkTheme()
    || LocalStorageHelper.getInstance().isAppConfiguredToBeInDarkMode()
    || bodyHasDarkTheme
    || htmlHasDarkTheme;
},

_syncDarkThemeWithApp: function(){
this.setDarkTheme(this._isStudioDockDarkThemeEnabled());

const router = PersistentModels.getInstance().getRouter ? PersistentModels.getInstance().getRouter() : null;
if(router && router.isDarkModeOn){
    router.isDarkModeOn().then((function(darkMode){
        if(this.el){
            this.setDarkTheme(!!darkMode);
        }
    }).bind(this)).catch(function(error){
        console.error(error);
    });
}
},

_onAppDarkModeChanged: function(darkMode){
this.setDarkTheme(!!darkMode);
},

setDarkTheme : function(darkTheme){
    if(darkTheme){
        this.$el.addClass("lighttext transparent darkTheme");
    }else{
        this.$el.removeClass("lighttext transparent darkTheme");
    }

    if(STUDIO_DOCK_RECORD_UI){
        this._applyStudioDockDrawerRootStyles();
    }
},

/**
 * Returns the folder id currently selected in the folder picker (or null).
 * Called by RecordAudioHightlightPageNewController after successful save.
 */
getSelectedFolderId: function() {
    return this._selectedFolderId || null;
},

/**
 * Fetch the user's folders so the dropdown has options. We do this once per
 * render — subsequent re-renders of FolderPicker inside _renderFolderPicker
 * reuse the cached array.
 */
_loadFoldersForPicker: function() {
    try {
        const params = {};
        if(this._workspaceId !== undefined){
            params.workspaceId = this._workspaceId;
        }
        return TrebbleClientAPI.getInstance().listProjectFolders(params)
            .then((response) => {
                this._availableFolders = this._normalizeFolderResponse(response);
                // If the previously selected folder no longer exists in the
                // refreshed list, clear it so getSelectedFolderId() does not
                // return a stale id.
                if(this._selectedFolderId
                    && !this._availableFolders.some((f) => f.id === this._selectedFolderId)){
                    this._selectedFolderId = null;
                }
                return this._availableFolders;
            })
            .catch((error) => {
                console.warn("FolderPicker: failed to load folders", error);
                this._availableFolders = [];
                return [];
            });
    } catch (error) {
        console.warn("FolderPicker: unexpected error loading folders", error);
        this._availableFolders = [];
        return RSVP.Promise.resolve([]);
    }
},

/**
 * Normalize listProjectFolders into the FolderOption shape consumed by
 * FolderPicker. Keeps this logic local to the view so Create Content does
 * not depend on LibraryPage's internal mapping helpers.
 */
_normalizeFolderResponse: function(response) {
    let records = [];
    if (Array.isArray(response)) {
        records = response;
    } else if (response && typeof response === "object") {
        if (Array.isArray(response.folders)) {
            records = response.folders;
        } else if (Array.isArray(response.items)) {
            records = response.items;
        } else if (Array.isArray(response.message)) {
            records = response.message;
        }
    }
    return records.map((folder) => {
        const id = (folder && (folder._id || folder.id)) || "";
        const itemIds = Array.isArray(folder && folder.itemIds) ? folder.itemIds : [];
        const itemCountValue = (folder && typeof folder.itemCount === "number") ? folder.itemCount : itemIds.length;
        return {
            id: id,
            name: (folder && (folder.name || "Untitled Folder")) || "Untitled Folder",
            itemCount: itemCountValue,
            parentFolderId: (folder && folder.parentFolderId) || null,
        };
    }).filter((f) => !!f.id);
},

/**
 * Mount the React FolderPicker into its placeholder. Loads folders first
 * so the initial render already contains the available options.
 */
_mountFolderPicker: function() {
    const placeholder = this.$el.find("#folderPickerPlaceholder").get(0);
    if (!placeholder) {
        return;
    }
    if (!this._folderPickerRoot) {
        this._folderPickerRoot = createRoot(placeholder);
    }
    // Initial render with the (possibly empty) folder list and the default.
    this._renderFolderPicker();
    // Fetch folders then re-render so the user can actually pick one.
    this._loadFoldersForPicker().then(() => {
        this._renderFolderPicker();
    });
},

_renderFolderPicker: function() {
    if (!this._folderPickerRoot) return;
    const useEditorTheme = !!LocalStorageHelper.getInstance().getUseEditorDarkTheme();
    this._folderPickerRoot.render(
        React.createElement(FolderPicker, {
            folders: this._availableFolders || [],
            value: this._selectedFolderId || null,
            onChange: (id) => {
                this._selectedFolderId = id || null;
                this._renderFolderPicker();
                this.trigger("folderSelectionChanged", this._selectedFolderId);
            },
            useEditorTheme: useEditorTheme,
            ti18n: ti18n,
        })
    );
},

render : function() {
this.$el.html(this.template(this._templateParams));
this.setElement(this.$el.find("div").first());
if (STUDIO_DOCK_RECORD_UI) { this.$el.addClass("studio-dock"); }
this.$el.find(".ui-content").enhanceWithin();
//this.$el.find("#whatsacapsuleButton").click(this.onWhatsACapsuleButtonClicked.bind(this));

if(this._creationModeSelectorView){
this._creationModeSelectorView.$el.addClass("display_on_mobile");
this.$el.find("#creationModeSelectorWrapper").first().append(this._creationModeSelectorView.$el);
}
if(this._creationModeFlatListViewContainer$el){
this.$el.find("#creationModeSelectorWrapper").first().append(this._creationModeFlatListViewContainer$el);
}

this.trackSlectorBlockSpacer$el = this.$el.find(".track_selector_block_spacer");


this.uploadBlock$el =this.$el.find("#uploadBlock");
this.recordingBlock$el =  this.$el.find("#recordingBlock");
this.recordingDraftRecoveryPanel$el = this.$el.find("#recordingDraftRecoveryPanel");
this.recordingDraftRecoveryList$el = this.$el.find("#recordingDraftRecoveryList");
this.recordingDraftRecoveryEmptyState$el = this.$el.find("#recordingDraftRecoveryEmptyState");
this._studioDockShell$el = this.$el.find("#recordingBlock .shell");
this.draftRibbon$el = this.$el.find("#draftRibbon");
this.draftRibbonFileName$el = this.$el.find("#draftRibbonFileName");
this.draftRibbonDetail$el = this.$el.find("#draftRibbonDetail");
this.draftRibbonCount$el = this.$el.find("#draftRibbonCount");
this.draftRibbonRecoverBtn$el = this.$el.find("#draftRibbonRecoverBtn");
this.draftPill$el = this.$el.find("#draftPill");
this.draftPillCount$el = this.$el.find("#draftPillCount");
this.draftDrawer$el = this.$el.find("#draftDrawer");
this.draftDrawerList$el = this.$el.find("#draftDrawerList");
this.draftDrawerEmptyState$el = this.$el.find("#draftDrawerEmptyState");
this.flexContentCenteringBox$el = this.$el.find(".flexContentCenteringBox");
this.peakMeterContainer$el =  this.$el.find("#peak_meter_container");
this.videoPeakMeterContainer$el = this.$el.find("#video_peak_meter_container");
this.textToConvertField$el = this.$el.find("#textToConvertField");
this.textToConvertByVoiceActorField$el = this.$el.find("#textToConvertByVoiceActorField");
this.instructionsForVoiceActorField$el = this.$el.find("#instructionsForVoiceActorField");
this.wordCountNumber$el = this.$el.find(".word_count_wrapper .word_count_number");
this.textToConvertField$el.on("keyup input", this.onTextToConvertToAudioFieldChange.bind(this));
this.textToConvertByVoiceActorField$el.on("keyup input", this.onTextToNarrateFieldChange.bind(this));
this.showRecordSectionButton$el = this.$el.find("[data-role=header] #showRecordSectionButton");
this.showUploadSectionButton$el = this.$el.find("#showUploadSectionButton");
this.showTextToSpeechSectionButton$el = this.$el.find("#showTextToSpeechSectionButton");
this.showVoiceActorNarrationSectionButton$el = this.$el.find("#showVoiceActorNarrationSectionButton");
this.textToSpeechBlock$el =  this.$el.find("#textToSpeechBlock");
this.useVoiceActorBlock$el = this.$el.find("#useVoiceActorBlock");
this.recordProgressContainer$el =this.$el.find("#recordProgressContainer");
this.recordingMediaTypeSelector$el = this.$el.find("#recordingMediaTypeSelector");
this.recordAudioModeButton$el = this.$el.find("#recordAudioModeButton");
this.recordVideoModeButton$el = this.$el.find("#recordVideoModeButton");
this.studioDockSettingsButton$el = this.$el.find("#studioDockSettingsBtn");
this.videoRecordingTimerRow$el = this.$el.find("#videoRecordingTimerRow");
this.videoRecordingTimerValue$el = this.$el.find("#videoRecordingTimerValue");
this.recordingPreviewContainer$el = this.$el.find("#recordingPreviewContainer");
this.recordingPreviewStage$el = this.$el.find("#recordingPreviewStage");
this.recordingPreviewVideo$el = this.$el.find("#recordingPreviewVideo");
this.recordingPreviewGrid$el = this.$el.find("#recordingPreviewGrid");
this.recordingPreviewGridToggleButton$el = this.$el.find("#recordingPreviewGridToggleButton");
this.recordedPlaybackVideo$el = this.$el.find("#recordedPlaybackVideo");
this.recordedPlaybackBadge$el = this.$el.find("#recordedPlaybackBadge");
this.recordingPreviewStatus$el = this.$el.find("#recordingPreviewStatus");
this.recordingPreviewStatusText$el = this.$el.find("#recordingPreviewStatusText");
this.retryRecordingPreviewButton$el = this.$el.find("#retryRecordingPreviewButton");
this.recordingDeviceControlsPanel$el = this.$el.find("#recordingDeviceControlsPanel");
this.recordingDeviceSelectors$el = this.$el.find("#recordingDeviceSelectors");
this.recordingMicrophoneField$el = this.$el.find("#recordingMicrophoneField");
this.recordingCameraField$el = this.$el.find("#recordingCameraField");
this.inlineRecordingMicrophoneFld$el = this.$el.find("#inlineRecordingMicrophoneFld");
this.inlineRecordingCameraFld$el = this.$el.find("#inlineRecordingCameraFld");
const settingsDrawerRoot$el = this._getStudioDockSettingsDrawer$el();
this.studioDockDrawerMicrophoneFld$el = settingsDrawerRoot$el.find("#studioDockDrawerMicrophoneFld");
this.studioDockDrawerCameraFld$el = settingsDrawerRoot$el.find("#studioDockDrawerCameraFld");
this.studioDockDrawerSpeakerFld$el = settingsDrawerRoot$el.find("#studioDockDrawerSpeakerFld");
this.studioDockDrawerResolutionFld$el = settingsDrawerRoot$el.find("#studioDockDrawerResolutionFld");
this.studioDockDrawerCameraField$el = settingsDrawerRoot$el.find("#studioDockDrawerCameraField");
this.studioDockDrawerSpeakerField$el = settingsDrawerRoot$el.find("#studioDockDrawerSpeakerField");
this.studioDockDrawerResolutionField$el = settingsDrawerRoot$el.find("#studioDockDrawerResolutionField");
this.studioDockDrawerEchoToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerEchoToggle");
this.studioDockDrawerNoiseToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerNoiseToggle");
this.studioDockDrawerAutoGainToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerAutoGainToggle");
this.studioDockDrawerCountdownToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerCountdownToggle");
this.studioDockDrawerGridToggle$el = settingsDrawerRoot$el.find("#studioDockDrawerGridToggle");
this.studioDockDrawerGridToggleRow$el = this.studioDockDrawerGridToggle$el.closest(".studio-dock-setting-toggle");
this.studioDockDrawerScreenNote$el = settingsDrawerRoot$el.find(".studio-dock-setting-note");
this.recordingDevicePermissionBanner$el = this.$el.find("#recordingDevicePermissionBanner");
this.recordingDevicePermissionText$el = this.$el.find("#recordingDevicePermissionText");
this.requestRecordingDevicePermissionButton$el = this.$el.find("#requestRecordingDevicePermissionButton");
this.uploadProgressInfo$el =  this.$el.find(".capsule_info_wrapper .uploadProgressInfo");
this.audioEditorAndTranscriptionBox$el = this.$el.find(".audio_editor_and_transcription_box");
this.audioEditorSection$el = this.$el.find(".carouselItem.audio_editor_section");
this.transcriptionParametersBox$el = this.$el.find(".parameters_for_transcription_wrapper");
this.uploadProgressInfo$el.append(this._capsuleInfoProgressBarView.$el);
this.audioEditorUploadProgressInfo$el =  this.$el.find(".audio_editor_section .uploadProgressInfo");
this.audioEditorUploadProgressInfo$el.append(this._audioEditorProgressBarView.$el);
this.capsuleInfo$el = this.$el.find(".capsuleInfo");
this.previousButtn$el = this.$el.find("#previousButton");
this.playButton$el =  this.$el.find("#playButton");
this.saveButton$el =  this.$el.find("#saveButtonIcon");
this.setSaveAccess(this._canSaveChanges);
this.messageToStartTranscriptionBox$el =  this.$el.find(".message_to_start_transcription_box_wrapper");
this.sequncerNodeWrapper$el =  this.$el.find(".sequencer_node_wrapper");
this.transcribeAndEditBtn$el = this.$el.find("#transcribe_and_edit_audio_btn");
this.continueWithNoEditBtn$el = this.$el.find("#continue_with_no_edit_btn");
this._syncAudioEditorLayoutState();
this._syncAudioEditorSectionHeight();

this.capsuleConfigWrapper$el = this.$el.find(".capsuleConfigWrapper");
this.capsuleLifeSpanFld$el = this.$el.find("#capsuleLifeSpanFld");
this.doNotAddOnAirCheckbox$el = this.$el.find("#doNotAddOnAirCheckbox");
this.schedulingSettingWrapper$el =  this.$el.find(".schedulingSettingWrapper");
this.schedulingTimeWrapper$el =  this.$el.find(".schedulingTimeWrapper");
this.publishingSettingWrapper$el =  this.$el.find(".publishingSettingWrapper");
this.schedulingTimezoneWrapper$el =  this.$el.find(".schedulingTimezoneWrapper");
this.scheduleInfoWrapper$el =  this.$el.find(".scheduleInfoWrapper");
this.recordControlsWrapper$el = this.$el.find("#recordControlsWrapper");
this.doNotAddOnAirCheckbox$el.change(this.onDoNotAddOnAirCheckboxChange.bind(this));
this.capsuleLifeSpanFld$el.change(this._hideShowSchedulingDateFieldIfApplicable.bind(this));
this.titleField$el = this.$el.find("#titleField");
this.titleField$el.on("click blur keyup input", this._onCapsuleInfoEdited.bind(this));
// Folder picker placeholder (rendered via React). Fetches available folders
// lazily so the save step always reflects the latest library state.
this._mountFolderPicker();
this.schedulingSettingFld$el = this.$el.find("#schedulingSettingFld");
this.schedulingTimeFld$el = this.$el.find("#schedulingTimeFld");
this.schedulingTimezoneFld$el = this.$el.find("#schedulingTimezoneFld");
this.languageUsedInAudioFld$el = this.$el.find("#languageUsedInAudioFld");
this.showRecordingSettingsButton$el = this.$el.find("#showRecordingSettingsButton");
this.doneRecordingButton$el = this.$el.find("#doneRecordingButtonIcon");
this.recordingInstruction$el = this.$el.find("#recordingInstruction");
this.counterAnimationBox$el =  this.$el.find("#counterAnimationBox");
this.comment$el = this.$el.find("#comment");
this._renderRecordingDraftRecoveryPanel();
this.setPeakMeterViewwIfApplicable();
this.setStudioDockVisualSource(this._studioDockVisualSource, true);
this._syncStudioDockPreviewGridState();
this.setRecordingMediaType(this._recordingMediaType, true);
this.schedulingSettingFld$el.on("change", this._onCapsuleInfoEdited.bind(this));
this.schedulingTimeFld$el.on("change", this._onCapsuleInfoEdited.bind(this));
this.schedulingTimezoneFld$el.on("change", this._onTimezoneEdited.bind(this));
this.languageUsedInAudioFld$el.on("change", this._onTranscriptionLanguageFieldValueChange.bind(this));

this.$el.find(".orrecordsection").hide();
if(DO_NOT_SHOW_HEADER_BUTTONS_TO_SWITCH_MODES){
this.showRecordSectionButton$el.hide();
this.showUploadSectionButton$el.hide();
this.showTextToSpeechSectionButton$el.hide();
this.showVoiceActorNarrationSectionButton$el.hide();
}
if(this._recordOnly){
    this.$el.addClass("record_only");
    this.$el.find("#nextButton").hide();
    this.doneRecordingButton$el.css("display","inline-flex");
    this.doneRecordingButton$el.addClass("trebble_disabled")
}else{
    if(this._canShowNextButton()){
        this.$el.find("#nextButton").css("display","inline-flex");
    }else{
        this.$el.find("#nextButton").hide();
    }
    this.doneRecordingButton$el.hide();
}
if(!ENABLE_ADDING_MUSIC_TO_PLAY_AFTER_CAPSULE){
this.$el.find(".songToPlayAfterCapsuleFieldWrapper").hide();
}

if(this._canSaveOnlyAfterTranscriptionAndEditing){
this.$el.find("#transcribe_btn  .label").html(window.getI18n(ti18n,"TRANSCRIBE_AND_EDIT_AUDIO"));
}

this.$el.page();

this._addCapsuleCategoriesToView();
this._addTimezonesToView();
this._addTranscriptioneSupportedLanguageToView();
PersistentModels.getInstance().getRouter().registerForViewportHeightChange(this._pageId, this._onWindowSizeChanged.bind(this), false);
this.afterRendering();
this._onWindowSizeChanged();
this.$el.on("pagehide", this._onPageHide.bind(this));
this.$el.on("pageshow", this._onPageShow.bind(this));
this.listenTo(PersistentModels.getInstance().getRouter(), "onDarkMode", this._onAppDarkModeChanged.bind(this));
this._syncDarkThemeWithApp();

return this;
},

remove: function() {
this._unbindStudioDockDrawerOutsideHandler();
this._unbindRecordingDraftRecoveryActionButtons();
this._unbindStudioDockFloatingDrawerHandlers();
if(this._beforeUnloadHandlerRegistered && typeof window !== "undefined" && window.removeEventListener){
    window.removeEventListener("beforeunload", this._beforeUnloadHandler);
    this._beforeUnloadHandlerRegistered = false;
}

const notesDrawer$el = this._getStudioDockNotesDrawer$el();
const settingsDrawer$el = this._getStudioDockSettingsDrawer$el();

if(notesDrawer$el && notesDrawer$el.length && notesDrawer$el.parent().is("body")){
    notesDrawer$el.remove();
}
if(settingsDrawer$el && settingsDrawer$el.length && settingsDrawer$el.parent().is("body")){
    settingsDrawer$el.remove();
}
if(this.draftDrawer$el && this.draftDrawer$el.length && this.draftDrawer$el.parent().is("body")){
    this.draftDrawer$el.remove();
}
if(
    typeof document !== "undefined" &&
    document.documentElement &&
    document.documentElement.classList &&
    (!document.body || !document.body.querySelector("[data-studio-dock-floating-drawer]"))
){
    document.documentElement.classList.remove("studio-dock-floating-drawer-mounted");
}

return Backbone.View.prototype.remove.apply(this, arguments);
},



});

export default RecordAudioHightlightPageNewView;
